import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import DashboardTemplate from "../../Common/DashboardTemplate";
import {
    Checkbox,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TablePagination,
    Paper,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
    Box,
    Modal,
    FormControlLabel,
    Typography,
    InputAdornment,
    IconButton
} from "@material-ui/core";
import axios from 'axios';
import {ServiceLocator} from "../../../Services/ServiceLocator";
import DrawerMenuRight from "../../Common/DrawerMenuRight";
import { v4 as uuid } from 'uuid';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { DatePicker } from '@material-ui/pickers';
import { format } from 'date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import dayjs from "dayjs";
import { toUtcForStorage, fromUtcForDisplay, getCurrentLocalTime, createDayjsForPicker, dayjsToDate, formatUtcForDisplay } from '../../../utils/dateUtils';
import PartAutocompleteOption from '../../Common/PartAutocompleteOption';
import PartDisplay from '../../Common/PartDisplay';
import SortableTableHeader from '../../Common/SortableTableHeader';
import { bindTableSortHandler, sortCollection, RECEIVING_ACTIONS_SORT_ACCESSORS } from '../../../utils/tableSortUtils';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronUp, faChevronDown, faTrash, faInfoCircle, faCheck, faTimes, faFileInvoice, faDownload, faPencilAlt} from "@fortawesome/free-solid-svg-icons";
import {FilePond, registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { AuthenticationService } from "../../../Services/AuthenticationService";
import { filterPersistenceService } from "../../../Services/FilterPersistenceService";
import 'filepond/dist/filepond.min.css';
import {getNumberInputDisplayValue, parseNumberInputValue} from '../../../utils/numberInputUtils';
import { parseMultiBoxName, withShipmentFile, getPackingSlipAttachedFile, navigateToPackingSlipBoxEditor } from '../../../utils/packingSlipShipmentUtils';

registerPlugin(FilePondPluginFileValidateSize);
registerPlugin(FilePondPluginFileValidateType);

const styles = theme => ({
    wrapper: {
        margin: -5,
    },
    filterToggle: {
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '2px 10px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        minWidth: '150px',
        '& .MuiCheckbox-root': {
            padding: '0px',
            color: '#35d2d9',
            '&.Mui-checked': {
                color: '#35d2d9',
            },
        }
    },
    filterLabel: {
        marginLeft: '8px',
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    sortableHeader: {
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'background-color 0.2s ease',
    }
});

let adminUsers = [];
let partFamilies = [];
let editingLog;
let editingOrder;
let globalProps;
const UNIT_COST_DECIMALS = 6;
const MONEY_DECIMALS = 2;

const roundToDecimals = (value, decimals) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return 0;
    const factor = 10 ** decimals;
    return Math.round((numericValue + Number.EPSILON) * factor) / factor;
};

const normalizeUnitCost = (value) => roundToDecimals(value, UNIT_COST_DECIMALS);
const normalizeMoney = (value) => roundToDecimals(value, MONEY_DECIMALS);
const calculateLineTotal = (unitCost, quantity) => normalizeMoney((Number(unitCost) || 0) * (Number(quantity) || 0));

function addDays(date, days) {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

const getPurchaseExportColumnDefinitions = (isInTransitView) => {
    const columns = [
        { id: 'line', label: 'Line' },
        { id: 'purchaseOrderNumber', label: 'PO #' },
        { id: 'orderDate', label: 'Order Date' },
        { id: 'company', label: 'Company' },
        { id: 'vendorOrderNumber', label: 'Vendor Order #' },
        { id: 'quantity', label: 'Quantity' },
        { id: 'item', label: 'Item' },
    ];

    if (!isInTransitView) {
        columns.push(
            { id: 'unitCost', label: 'Unit Cost' },
            { id: 'extended', label: 'Extended' },
        );
    }

    columns.push(
        { id: 'quantityReceived', label: 'Received' },
        { id: 'onOrder', label: 'On Order' },
        { id: 'inTransit', label: 'In Transit' },
    );

    if (isInTransitView) {
        columns.push(
            { id: 'packingSlipBox', label: 'Packing Slip - Box #' },
            { id: 'tracking', label: 'Tracking' },
        );
    } else {
        columns.push(
            { id: 'eta', label: 'ETA' },
            { id: 'paid', label: 'Paid' },
            { id: 'receivedDate', label: 'Received Date' },
        );
    }

    return columns;
};

class AdminPurchases extends React.Component {
    inTransitPackingSlipsLoadedPoIds = new Set();
    shipmentPackingSlipsCache = null;
    state = {
        loading: true,
        user: null,
        permissions: [],
        adminUsers: [],
        vendors: [],
        parts: [],
        partFamilies: [],
        purchaseOrders: [],
        page: 0,
        rowsPerPage: 100,
        searchTerm: '',
        newLogQuantity: 0,
        newLogQuantityReceived: 0,
        newLogIsPaid: false,
        newLogIsReceived: false,
        newLogReceivedDate: getCurrentLocalTime(),
        editLogReceivedDate: getCurrentLocalTime(),
        newLogCompany: '',
        newLogOrderDate: getCurrentLocalTime(),
        invoiceFiles: [],
        packingSlipFiles: [],
        ordersExpanded: [],
        addingPurchaseLogOpen: false,
        savingPurchaseLog: false,
        newLogParts: [],
        newPurchaseOrderDate: getCurrentLocalTime(),
        newVendorOrderNumber: '',
        partsOptions: [],
        error: null,
        showOnlyOutstanding: false,
        showOnlyUnpaid: false,
        showOnlyInTransit: false,
        loadingPackingSlips: false,
        
        // Sorting state
        sortField: 'purchaseOrderNumber',
        sortDirection: 'desc',
        
        // Copy table
        showCopyTable: false,
        copyTableData: [],
        copyTablesByVendor: {},

        // Export
        exportDialogOpen: false,
        exportSelectedColumnIds: [],
        exportDialogInTransitView: false,
        
        // Invoice Dialog
        createInvoiceDialogOpen: false,
        attachInvoiceDialogOpen: false,
        invoiceToAttach: '',
        newInvoiceNumber: '',
        newInvoiceFile: null,
        allInvoices: [],
        savingInvoice: false,
        currentEditingPurchaseOrderId: null,
        editingOrder: null,
        editingVendorOrderNumber: '',
        
        // Receiving drawer
        receiveDrawerOpen: false,
        selectedPackingSlip: null,
        receivedQuantities: {},
        receivingPackingSlip: false,
        
        // Line-item invoice management
        lineItemInvoiceDialogOpen: false,
        currentEditingPurchasedPartId: null,
        purchasedPartInvoices: {},  // Cache for purchased part invoices
        attachLineItemInvoiceDialogOpen: false,
        invoiceToAttachToLineItem: '',
        
        // New line-item focused invoice creation/attachment
        createLineItemInvoiceDialogOpen: false,
        attachExistingInvoiceToLineItemsDialogOpen: false,
        currentPurchaseOrderId: null,
        selectedLineItems: [],
        lineItemSelectionMode: null, // 'create' or 'attach'
        invoiceToAttachToLineItems: '',
        
        // Enhanced paid/received functionality
        paidModalOpen: false,
        paidModalInvoiceNumber: '',
        paidModalInvoiceFile: null,
        receivedModalOpen: false,
        receivedModalTrackingNumber: '',
        receivedModalPackingSlipName: '',
        receivedModalReceivedDate: getCurrentLocalTime().format('YYYY-MM-DD'), // Default to today
        receivedModalFile: null,
        
        // Multi-select functionality
        selectedPurchasedParts: [],
        lastSelectedIndex: null, // Track last clicked index for Shift+Click range selection
        lastSelectedLineItemIndex: null,
        isProcessingModifierClick: false, // Flag to prevent checkbox onChange during modifier clicks
        multiSelectMode: false,
        multiSelectPaidModalOpen: false,
        multiSelectReceivedModalOpen: false,
        multiSelectInvoiceNumber: '',
        multiSelectInvoiceFile: null,
        multiSelectTrackingNumber: '',
        multiSelectPackingSlipName: '',
        multiSelectReceivedDate: getCurrentLocalTime().format('YYYY-MM-DD'), // Default to today
        multiSelectReceivedFile: null,
        multiSelectReceivedQuantities: {},
        multiSelectShowQuantities: false,
        
        // Receiving actions for purchase log sidebar
        purchaseLogReceivingActions: [],
        loadingReceivingActions: false,
        purchaseLogReceivingActionsSortField: 'receivedDate',
        purchaseLogReceivingActionsSortDirection: 'desc',
        editingReceivingActionId: null,
        editingReceivingAction: {},
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadSavedFilterSettings();
        this.loadData();
    }

    // Performance optimization: Memoize expensive calculations
    getMemoizedLineItems = () => {
        const cacheKey = `${this.state.showOnlyOutstanding}-${this.state.showOnlyUnpaid}-${this.state.showOnlyInTransit}-${this.state.searchTerm}-${this.state.sortField}-${this.state.sortDirection}`;
        
        if (this._lineItemsCache && this._lineItemsCache.key === cacheKey) {
            return this._lineItemsCache.data;
        }

        const filteredPurchaseOrders = this.getFilteredPurchaseOrders(this.state.purchaseOrders || []);
        let allLineItems = filteredPurchaseOrders.flatMap((po) => {
            const partsSortedByPartNumber = [...po.purchasedParts].sort((a, b) => {
                const partA = this.state.parts.find((x) => x.part.id === a.partId);
                const partB = this.state.parts.find((x) => x.part.id === b.partId);
                const aPartNumber = partA?.part.partId || '';
                const bPartNumber = partB?.part.partId || '';
                return aPartNumber.localeCompare(bPartNumber);
            });

            return partsSortedByPartNumber.map((part, lineIndex) => ({
                ...part,
                purchaseOrderNumber: po.purchaseOrderNumber,
                purchaseOrderLineNumber: lineIndex + 1,
                purchaseOrderId: po.id,
                placedOn: po.placedOn,
                purchaseOrderInvoices: po.purchaseOrderInvoices || [],
                packingSlips: po.packingSlips || [],
            }));
        });
        
        // Apply in transit filter at line item level (matching display logic exactly)
        if (this.state.showOnlyInTransit) {
            allLineItems = allLineItems.filter(item => {
                // Match exact display logic: purchaseLog.inTransitQuantity > 0
                // This will be false for null, undefined, 0, '', NaN, etc.
                const inTransit = item.inTransitQuantity;
                // Use the same condition as display: inTransitQuantity > 0
                return inTransit != null && inTransit !== '' && Number(inTransit) > 0;
            });
        }
        
        const sortedLineItems = this.sortLineItems(allLineItems);

        this._lineItemsCache = {
            key: cacheKey,
            data: sortedLineItems
        };

        return sortedLineItems;
    };
    
    loadSavedFilterSettings = () => {
        const savedSettings = filterPersistenceService.loadFilterSettings('purchases');
        if (savedSettings) {
            this.setState({
                page: savedSettings.page || 0,
                rowsPerPage: savedSettings.rowsPerPage || 100,
                searchTerm: savedSettings.searchTerm || '',
                showAdvancedInfo: savedSettings.showAdvancedInfo || false,
                showDeactivated: savedSettings.showDeactivated || false,
                showOldRevs: savedSettings.showOldRevs || false,
                sortField: savedSettings.sortField || 'purchaseOrderNumber',
                sortDirection: savedSettings.sortDirection || 'desc'
            });
        }
    }

    saveFilterSettings = () => {
        const settings = {
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            searchTerm: this.state.searchTerm,
            showAdvancedInfo: this.state.showAdvancedInfo,
            showDeactivated: this.state.showDeactivated,
            showOldRevs: this.state.showOldRevs,
            sortField: this.state.sortField,
            sortDirection: this.state.sortDirection
        };
        filterPersistenceService.saveFilterSettings('purchases', settings);
    }

    loadData = () => {
        const self = this;
        const user = AuthenticationService.getInstance().getUser();
        if (!user || !user.userPermissions || !user.userPermissions.includes('Purchase')) {
            globalProps.history.push('/login');
            return;
        }

        self.setState({loading: true});
        // Clear cache when loading new data
        this._lineItemsCache = null;
        this.inTransitPackingSlipsLoadedPoIds.clear();
        return Promise.all([self.loadAdminUsers(), self.loadVendors(), self.loadParts(), self.loadPurchaseOrders(), self.loadPartFamilies(), self.loadInvoices()]).then(async () => {
            // Create partsOptions array with families first, then individual parts
            const partsOptions = [];
            const partsOptionsNoFamily = [];
            
            // Add part families first
            self.state.partFamilies.forEach((family) => {
                partsOptions.push({
                    title: `${family.partFamilyId} (Family)`,
                    value: family.id,
                    isFamily: true,
                    family: family
                });
            });

            // Then add individual parts
            // Add parts to connection options (only currently purchasing)
            self.state.parts.filter(x => x.part.isActive && x.part.currentlyPurchasing).forEach((part) => {
                partsOptions.push({
                    title: `${part.part.partId} rev ${part.part.revision}`,
                    value: part.part.id,
                    isFamily: false,
                    part: part.part
                });
                partsOptionsNoFamily.push({
                    title: `${part.part.partId} rev ${part.part.revision}`,
                    value: part.part.id,
                    isFamily: false,
                    part: part.part
                });
            });

            // Create partsOptionsForEdit with ALL parts (for editing existing purchase logs)
            const partsOptionsForEdit = [];
            self.state.parts.filter(x => x.part.isActive).forEach((part) => {
                partsOptionsForEdit.push({
                    title: `${part.part.partId} rev ${part.part.revision}`,
                    value: part.part.id,
                    isFamily: false,
                    part: part.part
                });
            });

            // Load invoice data for all purchased parts (for initial display)
            try {
                await self.loadAllPurchasedPartInvoices();
            } catch (error) {
                console.error('Error loading purchased part invoices:', error);
            }

            self.setState({
                loading: false,
                user,
                adminUsers,
                permissions: user.userPermissions,
                partsOptions,
                partsOptionsNoFamily,
                partsOptionsForEdit
            }, () => {
                const openedLinkedLine = self.openLinkedPurchasedPart();
                if (!openedLinkedLine) {
                    setTimeout(() => {
                        if (this.searchInputRef) {
                            this.searchInputRef.focus();
                        }
                    }, 100);
                }
            });
        });
    };

    loadPartFamilies = () => {
        const self = this;
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getPartFamilies().then((partFamilies) => {
            self.setState({partFamilies});
        });
    };

    loadVendors = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getAllVendors().then((vendors) => {
            this.setState({vendors});
        })
    };

    loadAdminUsers = () => {
        const userService = ServiceLocator.Instance.getUserService();
        return userService.getAdminUsers().then((adminUsersResult) => {
            adminUsers = adminUsersResult;
        });
    };

    loadParts = () => {
        const self = this;
        self.setState({loading: true});
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getAllPartsExpanded().then((parts) => {
            parts = parts.sort(function (a, b) {
                if (a.part.partId < b.part.partId) return -1;
                if (a.part.partId > b.part.partId) return 1;
                return 0;
            });
            self.setState({parts});
        });
    };

    loadPurchaseOrders = () => {
        const self = this;
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getPurchaseOrders().then((purchaseOrders) => {
            // Sort by date
            purchaseOrders = purchaseOrders.sort(function (a, b) {
                return new Date(b.placedOn) - new Date(a.placedOn);
            });

            self.setState({purchaseOrders});
        });
    };

    loadInvoices = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getAllInvoices().then((invoices) => {
            this.setState({allInvoices: invoices});
        });
    };

    changeQuantity = (newLogPart, event) => {
        const {newLogParts} = this.state;
        const changingPart = newLogParts.find(x => x.id === newLogPart.id);
        const partExpanded = this.state.parts.find(x => x.part.id === newLogPart.partId);
        const value = event.target.value;
        changingPart.quantity = value;
        changingPart.partQuantity = value;
        
        // Calculate price based on vendor pricing if available
        if (changingPart.vendorParts && changingPart.vendorId) {
            const vendorPart = changingPart.vendorParts.find(vp => vp.vendorId === changingPart.vendorId);
            if (vendorPart) {
                if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas && vendorPart.tieredCostFormulas.length > 0) {
                    // Use tiered pricing
                    const sortedTiers = [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity);
                    const tier = changingPart.quantity < sortedTiers[0].quantity 
                        ? sortedTiers[0] 
                        : [...sortedTiers].reverse().find(t => changingPart.quantity >= t.quantity) || sortedTiers[sortedTiers.length - 1];
                    const unitPrice = normalizeUnitCost(tier.price);
                    changingPart.price = unitPrice;
                    changingPart.pricePaid = calculateLineTotal(unitPrice, changingPart.quantity).toFixed(2);
                    changingPart.total = calculateLineTotal(unitPrice, changingPart.quantity);
                } else if (vendorPart.costType === 1) {
                    // Use fixed pricing
                    const unitPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
                    changingPart.price = unitPrice;
                    changingPart.pricePaid = calculateLineTotal(unitPrice, changingPart.quantity).toFixed(2);
                    changingPart.total = calculateLineTotal(unitPrice, changingPart.quantity);
                } else {
                    // Fallback to part cost
                    const unitCost = partExpanded ? partExpanded.cost : 0.00;
                    const unitPrice = normalizeUnitCost(unitCost);
                    changingPart.price = unitPrice;
                    changingPart.pricePaid = calculateLineTotal(unitPrice, changingPart.quantity).toFixed(2);
                    changingPart.total = calculateLineTotal(unitPrice, changingPart.quantity);
                }
            } else {
                // Fallback to part cost
                const unitCost = partExpanded ? partExpanded.cost : 0.00;
                const unitPrice = normalizeUnitCost(unitCost);
                changingPart.price = unitPrice;
                changingPart.pricePaid = calculateLineTotal(unitPrice, changingPart.quantity).toFixed(2);
                changingPart.total = calculateLineTotal(unitPrice, changingPart.quantity);
            }
        } else {
            // Fallback to part cost
            const unitCost = partExpanded ? partExpanded.cost : 0.00;
            const unitPrice = normalizeUnitCost(unitCost);
            changingPart.price = unitPrice;
            changingPart.pricePaid = calculateLineTotal(unitPrice, changingPart.quantity).toFixed(2);
            changingPart.total = calculateLineTotal(unitPrice, changingPart.quantity);
        }
        
        this.setState({newLogParts});
    };

    changePricePaid = (newLogPart, event) => {
        const {newLogParts} = this.state;
        const changingPart = newLogParts.find(x => x.id === newLogPart.id);
        changingPart.pricePaid = event.target.value;
        this.setState({newLogParts});
    };

    changeQuantityReceived = (newLogPart, event) => {
        const {newLogParts} = this.state;
        const changingPart = newLogParts.find(x => x.id === newLogPart.id);
        changingPart.quantityReceived = event.target.value;
        this.setState({newLogParts});
    };

    handlePartChange = (event, newValue, newLogPart) => {
        let purchasingPart = null;
        let purchasingFamily = null;
        if (newValue) {
            purchasingPart = this.state.parts.find(x => x.part.id === newValue.value);
            purchasingFamily = this.state.partFamilies.find(x => x.id === newValue.value);
            if (!purchasingPart && !purchasingFamily) return;
        }

        const {newLogParts} = this.state;
        const changingPart = newLogParts.find(x => x.id === newLogPart.id);

        if (purchasingPart) {
            changingPart.partId = !newValue ? null : newValue.value;
            let vendors = [];
                purchasingPart.part.vendorParts.forEach((vendorPart) => {
                    const vendor = this.state.vendors.find(x => x.id === vendorPart.vendorId);
                    if (vendor && vendors.indexOf(vendor) < 0) vendors.push(vendor);
                });
            changingPart.vendors = vendors;
            changingPart.vendorsList = vendors.map((vendor) => vendor.name);
            changingPart.selectedOption = newValue ? {
                title: `${purchasingPart.part.partId} rev ${purchasingPart.part.revision}`,
                value: newValue.value,
                part: purchasingPart.part
            } : null;
            
            // Calculate initial pricing based on part cost and quantity
            const partExpanded = this.state.parts.find(x => x.part.id === newValue.value);
            if (partExpanded) {
                const unitCost = normalizeUnitCost(partExpanded.cost || 0.00);
                const quantity = changingPart.quantity || 1;
                changingPart.pricePaid = calculateLineTotal(unitCost, quantity).toFixed(2);
                
                // Set initial vendor information
                const selectedVendorId = purchasingPart.part.selectedVendorId;
                const vendorPart = purchasingPart.part.vendorParts.find(x => x.vendorId === selectedVendorId) || purchasingPart.part.vendorParts[0];
                if (vendorPart) {
                    changingPart.vendorId = vendorPart.vendorId;
                    changingPart.vendorParts = purchasingPart.part.vendorParts;
                    
                    // Calculate price based on vendor pricing if available
                    if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas && vendorPart.tieredCostFormulas.length > 0) {
                        // Use selected tiered cost formula for default quantity and unit price
                        const selectedTier = vendorPart.tieredCostFormulas.find(t => t.isSelected);
                        const tier = selectedTier || [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity)[0];
                        const tierQuantity = tier.quantity || 1;
                        const tierPrice = normalizeUnitCost(tier.price);
                        changingPart.quantity = tierQuantity;
                        changingPart.partQuantity = tierQuantity;
                        changingPart.price = tierPrice;
                        changingPart.total = calculateLineTotal(tierPrice, tierQuantity);
                        changingPart.pricePaid = changingPart.total.toFixed(2);
                    } else if (vendorPart.costType === 1) {
                        // Use fixed pricing
                        const unitPrice = normalizeUnitCost(vendorPart.cost);
                        changingPart.price = unitPrice;
                        changingPart.total = calculateLineTotal(unitPrice, quantity);
                        changingPart.pricePaid = changingPart.total.toFixed(2);
                    }
                }
            }
            
            this.setState({newLogParts});
        } else if (purchasingFamily) {
            // Get all parts in this family and their vendors
            const familyParts = this.state.parts.filter(part => 
                part.part.partToFamilies && 
                part.part.partToFamilies.some(ptf => ptf.familyId === purchasingFamily.id)
            );
            
            // Remove the family row
            const familyRowIndex = newLogParts.indexOf(changingPart);
            newLogParts.splice(familyRowIndex, 1);
            
            // Add each part from the family as a separate line item
            familyParts.forEach(part => {
                const partToFamily = part.part.partToFamilies.find(ptf => ptf.familyId === purchasingFamily.id);
                
                // Skip implied parts when adding families to purchase orders
                if (partToFamily && partToFamily.isImpliedPart) {
                    return;
                }
                
                const defaultQuantity = partToFamily ? partToFamily.purchaseQuantity : 1;
                
                let vendors = [];
                part.part.vendorParts.forEach(vendorPart => {
                    const vendor = this.state.vendors.find(x => x.id === vendorPart.vendorId);
                    if (vendor && !vendors.some(v => v.id === vendor.id)) {
                        vendors.push(vendor);
                    }
                });
                
                newLogParts.push({
                    id: uuid(),
                    familyId: purchasingFamily.id,
                    familyQuantity: 1,
                    partId: part.part.id,
                    partQuantity: defaultQuantity,
                    description: part.part.description,
                    vendor: vendors.map(vendor => vendor.name),
                    vendorId: vendors.map(vendor => vendor.id),
                    price: 0,
                    total: 0,
                    isFamilyRow: false,
                    isOverridden: false,
                    isFamilyPart: true,
                    vendorParts: part.part.vendorParts,
                    selectedOption: {
                        title: `${part.part.partId} rev ${part.part.revision}`,
                        value: part.part.id,
                        part: part.part
                    }
                });
            });
            
            this.setState({newLogParts});
        }
    };

    openAddPurchaseLog = () => {
        this.setState({
            addingPurchaseLogOpen: true,
            savingPurchaseLog: false,
            newLogParts: [{
                id: uuid(),
                familyId: null,
                familyQuantity: 1,
                isFamilyRow: true,
                description: '',
                vendor: '',
                vendorId: null,
                vendors: [],
                vendorsList: [],
                vendorParts: [],
                price: 0,
                pricePaid: '0.00',
                total: 0,
                quantity: 1,
                partQuantity: 1,
                selectedOption: null,
                partId: null,
                isModifying: false,
                isOverridden: false,
                isFamilyPart: false
            }],
            newPurchaseOrderDate: getCurrentLocalTime()
        });
    };

    handleCloseNewPurchaseLog = () => {
        this.setState({
            addingPurchaseLogOpen: false,
            newVendorOrderNumber: ''
        });
    };

    addPurchaseOrderPart = () => {
        const {newLogParts} = this.state;
        newLogParts.push({
            id: uuid(),
            companyName: '',
            quantity: 0,
            quantityReceived: 0,
            partId: null,
            partFamilyId: null,
            isPaid: true,
            isReceived: false,
            orderDate: new Date(),
            receivedDate: null,
            pricePaid: 0.00,
            vendorsList: [],
            userId: AuthenticationService.getInstance().getUserId(),
            selectedOption: null
        });
        this.setState({newLogParts});
    };

    removeNewPartFromOrder = (newLogPart) => {
        const {newLogParts} = this.state;
        newLogParts.splice(newLogParts.indexOf(newLogPart), 1);
        this.setState({newLogParts, loading: true});
        setTimeout(() => {
            this.setState({loading: false});
        }, 50);
    };

    changeCompany = (newLogPart, vendor) => {
        const {newLogParts} = this.state;
        const changingPart = newLogParts.find(x => x.id === newLogPart.id);
        if (!changingPart) return window.$alertError("Something went wrong...");
        changingPart.companyName = vendor;
        this.setState({newLogParts});
    };

    changeReceivedDate = (newLogPart, newValue) => {
        const {newLogParts} = this.state;
        const changingPart = newLogParts.find(x => x.id === newLogPart.id);
        if (!changingPart) return window.$alertError("Something went wrong...");
        changingPart.receivedDate = newValue;
        this.setState({newLogParts});
    };

    changeCustomCompany = (newLogPart, vendor) => {
        const {newLogParts} = this.state;
        const changingPart = newLogParts.find(x => x.id === newLogPart.id);
        if (!changingPart) return window.$alertError("Something went wrong...");
        changingPart.companyName = vendor;
        this.setState({newLogParts});
    };

    setIsPaid = (newLogPart, event) => {
        const {newLogParts} = this.state;
        const changingPart = newLogParts.find(x => x.id === newLogPart.id);
        if (!changingPart) return window.$alertError("Something went wrong...");
        changingPart.isPaid = event.target.checked;
        this.setState({newLogParts});
    };

    setIsReceived = (newLogPart, event) => {
        const {newLogParts} = this.state;
        const changingPart = newLogParts.find(x => x.id === newLogPart.id);
        if (!changingPart) return window.$alertError("Something went wrong...");
        changingPart.isReceived = event.target.checked;
        this.setState({newLogParts});
    };

    addPurchaseOrder = () => {
        const self = this;

        self.setState({savingPurchaseLog: true});
        const payload = {
            id: uuid(),
            placedOn: toUtcForStorage(this.state.newPurchaseOrderDate),
            vendorOrderNumber: this.state.newVendorOrderNumber,
            pricePaid: 0.00,
            invoices: [],
            packingSlips: [],
            purchasedParts: this.state.newLogParts,
            userId: AuthenticationService.getInstance().getUserId()
        };
        const partService = ServiceLocator.Instance.getPartService();
        partService.createPurchaseOrder(payload).then((purchaseOrder) => {
            this.setState({selectedPurchaseOrderId: purchaseOrder.id});
            Promise.all([self.saveInvoiceFiles(), self.savePackingSlipFiles()]).then(() => {
                window.$alertSuccess("Purchase log created");
                self.setState({addingPurchaseLogOpen: false, savingPurchaseLog: false});
                self.loadData();
            });
        });
    };

    editPart = (partExpanded, newTab) => {
        if (newTab)
            window.open(`/admin/parts/${partExpanded.part.id}`);
        else
            globalProps.history.push(`/admin/parts/${partExpanded.part.id}`);
    };

    toggleOrderExpanded = (purchaseOrderId) => {
        let {ordersExpanded} = this.state;
        if (ordersExpanded.indexOf(purchaseOrderId) > -1)
            ordersExpanded.splice(ordersExpanded.indexOf(purchaseOrderId), 1);
        else
            ordersExpanded.push(purchaseOrderId);

        this.setState({ordersExpanded});
    };

    openLinkedPurchasedPart = () => {
        const params = new URLSearchParams(this.props.location?.search || window.location.search);
        const purchasedPartId = params.get('purchasedPart');
        if (!purchasedPartId) return false;

        const wantedId = purchasedPartId.toLowerCase();
        for (const purchaseOrder of this.state.purchaseOrders || []) {
            const part = (purchaseOrder.purchasedParts || []).find((line) => String(line.id).toLowerCase() === wantedId);
            if (!part) continue;
            this.editLog(part, purchaseOrder.id);
            return true;
        }
        return false;
    };

    editLog = (purchaseLog, purchaseOrderId) => {
        editingLog = purchaseLog;
        
        // Find the selected part and populate vendorParts and vendorId (for tiered pricing when editing quantity)
        const selectedPart = this.state.parts.find(x => x.part.id === purchaseLog.partId);
        if (selectedPart && selectedPart.part.vendorParts) {
            editingLog.vendorParts = selectedPart.part.vendorParts;
            editingLog.vendorId = editingLog.vendorId || selectedPart.part.selectedVendorId || (selectedPart.part.vendorParts[0] && selectedPart.part.vendorParts[0].vendorId);
        } else {
            editingLog.vendorParts = [];
            editingLog.vendorId = null;
        }
        
        this.setState({
            editingLog,
            editingLogOriginal: JSON.parse(JSON.stringify(purchaseLog)), // Store original for comparison
            selectedPurchaseOrderId: purchaseOrderId,
            editLogIsReceived: editingLog.receivedDate !== null,
            editLogOpen: true,
            editingReceivingActionId: null,
            editingReceivingAction: {}
        });
        
        // Load history for this purchased part and packing slip data for the purchase order
        this.loadPurchasedPartHistory(purchaseLog.id);
        this.loadPackingSlipsForPurchaseOrder(purchaseOrderId);
        this.loadReceivingActionsForPurchasedPart(purchaseLog.id);
    };

    loadPurchasedPartHistory = async (purchasedPartId) => {
        try {
            // Only need to load invoices since packing slip data is available through purchase order
            await this.loadInvoicesForPurchasedPart(purchasedPartId);
        } catch (error) {
            console.error('Error loading purchased part history:', error);
        }
    };

    attachShipmentFilesToPackingSlips = async (packingSlips) => {
        const slips = packingSlips || [];
        if (slips.length === 0) return slips;

        const withLocalShipmentFiles = slips.map(slip => withShipmentFile(slip, slips));
        const needsShipmentFile = withLocalShipmentFiles.some(slip =>
            parseMultiBoxName(slip.name) && !(slip.fileUrl || slip.FileUrl)
        );
        if (!needsShipmentFile) return withLocalShipmentFiles;

        try {
            const partService = ServiceLocator.Instance.getPartService();
            const allSlips = this.shipmentPackingSlipsCache || await partService.getAllPackingSlips();
            this.shipmentPackingSlipsCache = allSlips;
            return slips.map(slip => withShipmentFile(slip, allSlips));
        } catch (error) {
            console.error('Error resolving packing slip files from shipment:', error);
            return withLocalShipmentFiles;
        }
    };

    loadPackingSlipsForPurchaseOrder = async (purchaseOrderId) => {
        try {
            const partService = ServiceLocator.Instance.getPartService();
            const packingSlips = await this.attachShipmentFilesToPackingSlips(
                await partService.getPackingSlipsByPurchaseOrderId(purchaseOrderId)
            );
            
            // Update the purchase order in the state with the loaded packing slips
            this.setState(prevState => ({
                purchaseOrders: prevState.purchaseOrders.map(po => 
                    po.id === purchaseOrderId 
                        ? { ...po, packingSlips: packingSlips || [] }
                        : po
                )
            }));
        } catch (error) {
            console.error('Error loading packing slips for purchase order:', error);
        }
    };

    loadReceivingActionsForPurchasedPart = async (purchasedPartId) => {
        this.setState({ loadingReceivingActions: true });
        try {
            const partService = ServiceLocator.Instance.getPartService();
            const actions = await partService.getReceivingActionsByPurchasedPartId(purchasedPartId);

            const allReceivingActions = (actions || []).map(action => ({
                ...action,
                packingSlip: action.packingSlipId ? {
                    id: action.packingSlipId,
                    name: action.packingSlipName,
                    fileUrl: action.packingSlipFileUrl,
                    fileName: action.packingSlipFileName
                } : null
            }));

            this.setState({
                purchaseLogReceivingActions: allReceivingActions,
                loadingReceivingActions: false
            });
        } catch (error) {
            console.error('Error loading receiving actions for purchased part:', error);
            this.setState({
                purchaseLogReceivingActions: [],
                loadingReceivingActions: false
            });
        }
    };

    isDirectReceiveAction = (action) => {
        return !action.packingSlipId && !action.packingSlip;
    };

    refreshPurchaseLogReceivingData = async () => {
        if (editingLog?.id) {
            await this.refreshEditingLog();
            await this.loadReceivingActionsForPurchasedPart(editingLog.id);
        }
        if (this.state.selectedPurchaseOrderId) {
            await this.loadPackingSlipsForPurchaseOrder(this.state.selectedPurchaseOrderId);
        }
    };

    handleEditReceivingAction = (action) => {
        this.setState({
            editingReceivingActionId: action.id,
            editingReceivingAction: {
                quantityReceived: action.quantityReceived,
                notes: action.notes || ''
            }
        });
    };

    handleCancelEditReceivingAction = () => {
        this.setState({
            editingReceivingActionId: null,
            editingReceivingAction: {}
        });
    };

    handleEditingReceivingActionChange = (field, value) => {
        this.setState(prevState => ({
            editingReceivingAction: {
                ...prevState.editingReceivingAction,
                [field]: value
            }
        }));
    };

    handleSaveReceivingAction = async (actionId) => {
        const quantityReceived = parseNumberInputValue(this.state.editingReceivingAction.quantityReceived);
        if (!Number.isFinite(quantityReceived) || quantityReceived < 1) {
            window.$alertError('Quantity received must be at least 1');
            return;
        }

        try {
            const partService = ServiceLocator.Instance.getPartService();
            const existingAction = this.state.purchaseLogReceivingActions.find(action => action.id === actionId);
            await partService.updateReceivingAction(actionId, {
                ...existingAction,
                quantityReceived,
                notes: this.state.editingReceivingAction.notes || ''
            });
            this.setState({
                editingReceivingActionId: null,
                editingReceivingAction: {}
            });
            await this.loadData();
            await this.refreshPurchaseLogReceivingData();
            window.$alertSuccess('Receiving action updated');
        } catch (error) {
            console.error('Error updating receiving action:', error);
            window.$alertError('Failed to update receiving action');
        }
    };

    handleDeleteReceivingAction = async (action) => {
        const quantity = action.quantityReceived || 0;
        const isDirectReceive = this.isDirectReceiveAction(action);
        const confirmMessage = isDirectReceive
            ? `Delete this direct receive (${quantity} qty)? This will reduce the received quantity on this line item and cannot be undone.`
            : 'Are you sure you want to delete this receiving action? This action cannot be undone.';
        if (!window.confirm(confirmMessage)) {
            return;
        }

        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.deleteReceivingAction(action.id);
            this.setState({
                editingReceivingActionId: null,
                editingReceivingAction: {}
            });
            await this.loadData();
            await this.refreshPurchaseLogReceivingData();
            window.$alertSuccess(isDirectReceive ? 'Direct receive deleted' : 'Receiving action deleted');
        } catch (error) {
            console.error('Error deleting receiving action:', error);
            window.$alertError(isDirectReceive ? 'Failed to delete direct receive' : 'Failed to delete receiving action');
        }
    };

    handleDeleteDirectReceiveAction = async (action) => {
        await this.handleDeleteReceivingAction(action);
    };

    getPackingSlipsForPurchasedPart = (purchasedPartId, purchaseOrderOverride = null, partId = null) => {
        // Use provided purchase order or find it in state
        const purchaseOrder = purchaseOrderOverride || this.state.purchaseOrders.find(po => 
            po.purchasedParts && po.purchasedParts.some(part => part.id === purchasedPartId)
        );
        
        if (!purchaseOrder || !purchaseOrder.packingSlips || purchaseOrder.packingSlips.length === 0) {
            return [];
        }
        
        // Filter packing slip items to only show ones for this purchased part
        const packingSlipItems = [];
        purchaseOrder.packingSlips.forEach(packingSlip => {
            if (packingSlip.items) {
                packingSlip.items.forEach(item => {
                    // Check multiple possible ways the purchased part ID might be stored
                    const itemPurchasedPartId = item.purchasedPartId || 
                                               item.purchasedPart?.id || 
                                               item.PurchasedPartId;
                    
                    const itemPartId = item.partId || item.part?.id || item.PartId;
                    const purchasedPartMatches =
                        itemPurchasedPartId != null &&
                        String(itemPurchasedPartId).toLowerCase() === String(purchasedPartId).toLowerCase();
                    const partMatches =
                        partId != null &&
                        itemPartId != null &&
                        String(itemPartId).toLowerCase() === String(partId).toLowerCase();

                    if (purchasedPartMatches || partMatches) {
                        packingSlipItems.push({
                            ...item,
                            packingSlip: packingSlip
                        });
                    }
                });
            }
        });
        return packingSlipItems;
    };

    getInTransitShipmentDetailsForPurchasedPart = (purchasedPartId, purchaseOrderId, partId = null) => {
        const purchaseOrder = this.state.purchaseOrders.find(po => po.id === purchaseOrderId);
        const packingSlipItems = this.getPackingSlipsForPurchasedPart(purchasedPartId, purchaseOrder, partId);

        if (!packingSlipItems.length) {
            return {
                packingSlipBoxText: '-',
                trackingText: '-'
            };
        }

        const inTransitSlipEntries = packingSlipItems.filter((item) => {
            const qtyOnSlip = item.quantityExpected || 0;
            const qtyReceived = item.quantityReceived || 0;
            return Math.max(0, qtyOnSlip - qtyReceived) > 0;
        });

        const slipsToDisplay = inTransitSlipEntries.length > 0 ? inTransitSlipEntries : packingSlipItems;

        const packingSlipBoxValues = [];
        const trackingValues = [];
        const seenTracking = new Set();
        const groupedSlipBoxes = new Map();

        slipsToDisplay.forEach(({ packingSlip }) => {
            if (!packingSlip) return;

            const boxMatch = packingSlip.name?.match(/Box\s(\d+)$/i);
            const baseNameMatch = packingSlip.name?.match(/^(.+)\s-\sBox\s\d+$/i);
            const baseSlipName = (baseNameMatch?.[1] || packingSlip.name || `Slip ${packingSlip.id?.substring(0, 8) || ''}`).trim();
            const boxLabel = boxMatch ? `Box ${boxMatch[1]}` : null;

            if (!groupedSlipBoxes.has(baseSlipName)) {
                groupedSlipBoxes.set(baseSlipName, new Set());
            }
            if (boxLabel) {
                groupedSlipBoxes.get(baseSlipName).add(boxLabel);
            }

            const tracking = (packingSlip.trackingNumber || '').trim();
            if (tracking && !seenTracking.has(tracking)) {
                seenTracking.add(tracking);
                trackingValues.push(tracking);
            }
        });

        groupedSlipBoxes.forEach((boxSet, baseSlipName) => {
            const sortedBoxes = Array.from(boxSet).sort((a, b) => {
                const aNum = parseInt(a.replace(/[^\d]/g, ''), 10);
                const bNum = parseInt(b.replace(/[^\d]/g, ''), 10);
                if (Number.isNaN(aNum) || Number.isNaN(bNum)) return a.localeCompare(b);
                return aNum - bNum;
            });

            if (sortedBoxes.length > 0) {
                packingSlipBoxValues.push(`${baseSlipName} (${sortedBoxes.join(', ')})`);
            } else {
                packingSlipBoxValues.push(baseSlipName);
            }
        });

        return {
            packingSlipBoxText: packingSlipBoxValues.length ? packingSlipBoxValues.join(', ') : '-',
            trackingText: trackingValues.length ? trackingValues.join(', ') : '-'
        };
    };

    loadInTransitPackingSlips = async () => {
        const partService = ServiceLocator.Instance.getPartService();
        const poIdsNeedingSlips = Array.from(
            new Set(
                (this.state.purchaseOrders || [])
                    .filter(po => (po.purchasedParts || []).some(part => Number(part.inTransitQuantity || 0) > 0))
                    .map(po => po.id)
                    .filter(id => id && !this.inTransitPackingSlipsLoadedPoIds.has(id))
            )
        );

        if (poIdsNeedingSlips.length === 0) return;

        const fetchedByPoId = {};
        await Promise.all(
            poIdsNeedingSlips.map(async (purchaseOrderId) => {
                try {
                    const packingSlips = await this.attachShipmentFilesToPackingSlips(
                        await partService.getPackingSlipsByPurchaseOrderId(purchaseOrderId)
                    );
                    fetchedByPoId[purchaseOrderId] = packingSlips || [];
                    this.inTransitPackingSlipsLoadedPoIds.add(purchaseOrderId);
                } catch (error) {
                    console.error(`Error loading packing slips for PO ${purchaseOrderId}:`, error);
                }
            })
        );

        const fetchedIds = Object.keys(fetchedByPoId);
        if (fetchedIds.length === 0) return;

        this._lineItemsCache = null;
        this.setState(prevState => ({
            purchaseOrders: prevState.purchaseOrders.map(po =>
                fetchedByPoId[po.id] !== undefined ? { ...po, packingSlips: fetchedByPoId[po.id] } : po
            )
        }));
    };

    editPurchaseOrder = async (purchaseOrder, purchaseOrderId, newTab = false) => {
        // Navigate to the dedicated EditPurchaseOrder page
        if (newTab) {
            window.open(`/admin/purchases/edit/${purchaseOrder.id}`, '_blank');
        } else {
            globalProps.history.push(`/admin/purchases/edit/${purchaseOrder.id}`);
        }
    };

    editCompany = (event) => {
        editingLog.companyName = event.target.value;
        this.setState({editingLog});
    };

    editQuantity = (event) => {
        const partExpanded = this.state.parts.find(x => x.part.id === editingLog.partId);
        editingLog.quantity = event.target.value;
        const qty = Number(editingLog.quantity);
        // Use vendor tiered/fixed pricing when available (same logic as changeQuantity for new lines)
        if (editingLog.vendorParts && (editingLog.vendorId || (partExpanded && partExpanded.part && partExpanded.part.selectedVendorId))) {
            const vendorId = editingLog.vendorId || (partExpanded && partExpanded.part.selectedVendorId);
            const vendorPart = editingLog.vendorParts.find(vp => vp.vendorId === vendorId);
            if (vendorPart) {
                if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas && vendorPart.tieredCostFormulas.length > 0) {
                    // Use tiered pricing: find the tier that applies to the new quantity.
                    // Tier price is per-unit; use it as unit cost and recalc total (total changes, unit cost = tier).
                    const sortedTiers = [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity);
                    const tier = qty < sortedTiers[0].quantity
                        ? sortedTiers[0]
                        : [...sortedTiers].reverse().find(t => qty >= t.quantity) || sortedTiers[sortedTiers.length - 1];
                    const tierUnitCost = Number(tier.price);
                    editingLog.unitCost = tierUnitCost.toFixed(2);
                    editingLog.pricePaid = (tierUnitCost * qty).toFixed(2);
                } else if (vendorPart.costType === 1) {
                    // Fixed pricing
                    const unitPrice = Number(vendorPart.basePrice / vendorPart.quantity) || 0;
                    editingLog.unitCost = unitPrice.toFixed(2);
                    editingLog.pricePaid = (unitPrice * qty).toFixed(2);
                } else {
                    const unitCost = partExpanded ? partExpanded.cost : 0.00;
                    editingLog.unitCost = (unitCost || 0).toFixed(2);
                    editingLog.pricePaid = ((unitCost || 0) * qty).toFixed(2);
                }
            } else {
                const unitCost = partExpanded ? partExpanded.cost : 0.00;
                editingLog.unitCost = (unitCost || 0).toFixed(2);
                editingLog.pricePaid = ((unitCost || 0) * qty).toFixed(2);
            }
        } else {
            // No vendor pricing: use part cost or keep unit cost and recalc total
            const unitCost = partExpanded ? partExpanded.cost : 0.00;
            if (editingLog.unitCost != null && editingLog.unitCost !== '') {
                editingLog.pricePaid = (Number(editingLog.unitCost) * qty).toFixed(2);
            } else {
                editingLog.unitCost = (unitCost || 0).toFixed(2);
                editingLog.pricePaid = ((unitCost || 0) * qty).toFixed(2);
            }
        }
        this.setState({editingLog});
    }

    editLogPricePaid = (event) => {
        editingLog.pricePaid = event.target.value;
        // Calculate unit cost based on total price and quantity
        if (editingLog.quantity > 0) {
            editingLog.unitCost = (editingLog.pricePaid / editingLog.quantity).toFixed(2);
        }
        this.setState({editingLog});
    }

    editUnitCost = (event) => {
        editingLog.unitCost = event.target.value;
        // Calculate total price based on unit cost and quantity
        editingLog.pricePaid = (editingLog.unitCost * editingLog.quantity).toFixed(2);
        this.setState({editingLog});
    }

    editIsPaid = (event) => {
        if (event.target.checked) {
            // Show modal to capture invoice details
            this.setState({
                paidModalOpen: true,
                paidModalInvoiceNumber: '',
                paidModalInvoiceFile: null
            });
        } else {
            // Unchecking - just toggle the flag
            editingLog.isPaid = false;
            this.setState({editingLog});
        }
    };

    handlePaidModalClose = () => {
        this.setState({
            paidModalOpen: false,
            paidModalInvoiceNumber: '',
            paidModalInvoiceFile: null
        });
    };

    handlePaidModalSubmit = async () => {
        if (!this.state.paidModalInvoiceNumber.trim()) {
            window.$alertError('Invoice number is required');
            return;
        }

        try {
            // Use the multi-select function with just the single item
            this.setState({
                selectedPurchasedParts: [editingLog.id],
                multiSelectInvoiceNumber: this.state.paidModalInvoiceNumber,
                multiSelectInvoiceFile: this.state.paidModalInvoiceFile
            }, async () => {
                await this.handleMultiSelectPaidSubmit();
                // Wait for data to refresh before closing modal
                await this.loadData();
                await this.refreshEditingLog();
                this.handlePaidModalClose();
            });
        } catch (error) {
            console.error('Error creating invoice and marking as paid:', error);
            window.$alertError('Failed to create invoice and mark as paid');
        }
    };

    handleSkipInvoice = () => {
        const { editingLog } = this.state;
        
        // Mark as paid without creating invoice
        editingLog.isPaid = true;
        
        this.setState({ editingLog });
        this.handlePaidModalClose();
    };

    handleEditLogPartChange = (event, newValue) => {
        if (newValue) {
            editingLog.partId = newValue.value;
            
            // Find the selected part and populate vendorParts
            const selectedPart = this.state.parts.find(x => x.part.id === newValue.value);
            if (selectedPart && selectedPart.part.vendorParts) {
                editingLog.vendorParts = selectedPart.part.vendorParts;
            } else {
                editingLog.vendorParts = [];
            }
            
            this.setState({editingLog});
        }
    };

    editQuantityReceived = (event) => {
        editingLog.quantityReceived = event.target.value;
        this.setState({editingLog});
    };

    editIsReceived = (event) => {
        if (event.target.checked) {
            // Show modal to capture tracking number
            this.setState({
                receivedModalOpen: true,
                receivedModalTrackingNumber: '',
                receivedModalReceivedDate: getCurrentLocalTime().format('YYYY-MM-DD'), // Set to today when opening
                receivedModalFile: null
            });
        } else {
            // Unchecking - just toggle the flag
            editingLog.quantityReceived = 0;
            this.setState({editingLog});
        }
    };

    handleReceivedModalClose = () => {
        this.setState({
            receivedModalOpen: false,
            receivedModalTrackingNumber: '',
            receivedModalPackingSlipName: '',
            receivedModalReceivedDate: getCurrentLocalTime().format('YYYY-MM-DD'), // Reset to today
            receivedModalFile: null
        });
    };

    handleReceivedModalSubmit = async () => {
        if (!this.state.receivedModalPackingSlipName.trim()) {
            window.$alertError('Packing slip name is required');
            return;
        }

        try {
            // Use the multi-select function with just the single item
            this.setState({
                selectedPurchasedParts: [editingLog.id],
                multiSelectPackingSlipName: this.state.receivedModalPackingSlipName,
                multiSelectTrackingNumber: this.state.receivedModalTrackingNumber,
                multiSelectReceivedDate: this.state.receivedModalReceivedDate,
                multiSelectReceivedFile: this.state.receivedModalFile
            }, async () => {
                await this.handleMultiSelectReceivedSubmit();
                // Wait for data to refresh before closing modal
                await this.loadData();
                await this.refreshEditingLog();
                this.handleReceivedModalClose();
            });
        } catch (error) {
            console.error('Error creating packing slip and marking as received:', error);
            window.$alertError('Failed to create packing slip and mark as received');
        }
    };

    handleSkipPackingSlip = async () => {
        const { editingLog } = this.state;
        const quantityToReceive = Math.max(
            0,
            (parseNumberInputValue(editingLog.quantity) || 0) - (parseNumberInputValue(editingLog.quantityReceived) || 0)
        );

        if (quantityToReceive <= 0) {
            window.$alertError('No remaining quantity to receive');
            return;
        }

        try {
            const partService = ServiceLocator.Instance.getPartService();
            const receivedDate = toUtcForStorage(this.state.receivedModalReceivedDate);

            await partService.directReceive({
                lines: [{
                    purchasedPartId: editingLog.id,
                    quantity: quantityToReceive,
                    receivedDate
                }],
                userId: AuthenticationService.getInstance().getUserId()
            });

            editingLog.isReceived = true;
            editingLog.receivedDate = receivedDate;
            editingLog.quantityReceived = (parseNumberInputValue(editingLog.quantityReceived) || 0) + quantityToReceive;

            await this.loadReceivingActionsForPurchasedPart(editingLog.id);
            this.setState({ editingLog });
            this.handleReceivedModalClose();
            window.$alertSuccess('Marked as received (no packing slip created)');
            await this.loadData();
        } catch (error) {
            console.error('Error marking item as received:', error);
            window.$alertError('Failed to mark item as received');
        }
    };

    // Multi-select functionality
    handleSelectPurchasedPart = (purchasedPartId, event) => {
        // Get sorted line items array for range selection
        const sortedLineItems = this.getMemoizedLineItems();
        const currentIndex = sortedLineItems.findIndex(item => item.id === purchasedPartId);
        const isCurrentlySelected = this.state.selectedPurchasedParts.includes(purchasedPartId);
        
        // Check for modifier keys
        const isCtrlPressed = (event && (event.ctrlKey || event.metaKey)) || 
                             (event.nativeEvent && (event.nativeEvent.ctrlKey || event.nativeEvent.metaKey));
        const isShiftPressed = (event && event.shiftKey) || 
                               (event.nativeEvent && event.nativeEvent.shiftKey);
        
        // Set flag to prevent checkbox onChange from processing modifier clicks
        const hasModifiers = isCtrlPressed || isShiftPressed;
        if (hasModifiers) {
            this.setState({ isProcessingModifierClick: true });
            if (event && event.preventDefault) event.preventDefault();
            if (event && event.stopPropagation) event.stopPropagation();
        }
        
        if (currentIndex === -1) {
            // Item not found in filtered data, fall back to simple toggle
            if (isCurrentlySelected) {
                this.setState(prevState => ({
                    selectedPurchasedParts: prevState.selectedPurchasedParts.filter(id => id !== purchasedPartId),
                    lastSelectedIndex: null
                }));
            } else {
                this.setState(prevState => ({
                    selectedPurchasedParts: [...prevState.selectedPurchasedParts, purchasedPartId],
                    lastSelectedIndex: null
                }));
            }
            if (hasModifiers) {
                setTimeout(() => {
                    this.setState({ isProcessingModifierClick: false });
                }, 100);
            }
            return;
        }

        if (isShiftPressed && this.state.lastSelectedIndex !== null && this.state.lastSelectedIndex !== -1) {
            // Shift+Click: Select range from lastSelectedIndex to currentIndex
            const startIndex = Math.min(this.state.lastSelectedIndex, currentIndex);
            const endIndex = Math.max(this.state.lastSelectedIndex, currentIndex);
            const rangeIds = sortedLineItems.slice(startIndex, endIndex + 1).map(item => item.id);
            
            if (isCtrlPressed) {
                // Ctrl+Shift+Click: Toggle range selection
                const allInRangeSelected = rangeIds.every(id => this.state.selectedPurchasedParts.includes(id));
                if (allInRangeSelected) {
                    // Remove all items in range
                    this.setState(prevState => ({
                        selectedPurchasedParts: prevState.selectedPurchasedParts.filter(id => !rangeIds.includes(id)),
                        lastSelectedIndex: currentIndex
                    }));
                } else {
                    // Add all items in range
                    this.setState(prevState => ({
                        selectedPurchasedParts: [...new Set([...prevState.selectedPurchasedParts, ...rangeIds])],
                        lastSelectedIndex: currentIndex
                    }));
                }
            } else {
                // Shift+Click: Add range, or remove range when clicking checked endpoints
                this.setState(prevState => {
                    const anchorId = sortedLineItems[this.state.lastSelectedIndex]?.id;
                    const anchorIsSelected = anchorId ? prevState.selectedPurchasedParts.includes(anchorId) : true;
                    const allInRangeSelected = rangeIds.every(id => prevState.selectedPurchasedParts.includes(id));
                    const shouldDeselectRange = !anchorIsSelected || (isCurrentlySelected && allInRangeSelected);
                    return {
                        selectedPurchasedParts: shouldDeselectRange
                            ? prevState.selectedPurchasedParts.filter(id => !rangeIds.includes(id))
                            : [...new Set([...prevState.selectedPurchasedParts, ...rangeIds])],
                        lastSelectedIndex: currentIndex
                    };
                });
            }
        } else if (isCtrlPressed) {
            // Ctrl+Click: Toggle individual item
            if (isCurrentlySelected) {
                this.setState(prevState => ({
                    selectedPurchasedParts: prevState.selectedPurchasedParts.filter(id => id !== purchasedPartId),
                    lastSelectedIndex: currentIndex
                }));
            } else {
                this.setState(prevState => ({
                    selectedPurchasedParts: [...prevState.selectedPurchasedParts, purchasedPartId],
                    lastSelectedIndex: currentIndex
                }));
            }
        } else {
            // Normal click: Simple toggle
            if (isCurrentlySelected) {
                this.setState(prevState => ({
                    selectedPurchasedParts: prevState.selectedPurchasedParts.filter(id => id !== purchasedPartId),
                    lastSelectedIndex: currentIndex
                }));
            } else {
                this.setState(prevState => ({
                    selectedPurchasedParts: [...prevState.selectedPurchasedParts, purchasedPartId],
                    lastSelectedIndex: currentIndex
                }));
            }
        }
        
        // Clear the modifier flag after a short delay
        if (hasModifiers) {
            setTimeout(() => {
                this.setState({ isProcessingModifierClick: false });
            }, 100);
        }
    };

    handleSelectAllPurchasedParts = (event) => {
        const checked = event.target.checked;
        if (checked) {
            const filteredPurchaseOrders = this.getFilteredPurchaseOrders(this.state.purchaseOrders || []);
            const allLineItems = filteredPurchaseOrders.flatMap(po => 
                po.purchasedParts.map(part => part.id)
            );
            const sortedLineItems = this.sortLineItems(allLineItems.map(id => ({id})));
            const paginatedLineItems = sortedLineItems.slice(
                this.state.page * this.state.rowsPerPage,
                this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
            );
            this.setState({
                selectedPurchasedParts: paginatedLineItems.map(item => item.id)
            });
        } else {
            this.setState({
                selectedPurchasedParts: []
            });
        }
    };

    handleMultiSelectPaid = () => {
        if (this.state.selectedPurchasedParts.length === 0) {
            window.$alertError('Please select at least one item');
            return;
        }

        // Group selected items by vendor
        const filteredPurchaseOrders = this.getFilteredPurchaseOrders(this.state.purchaseOrders || []);
        const allLineItems = filteredPurchaseOrders.flatMap(po => 
            po.purchasedParts.map(part => ({
                ...part,
                purchaseOrderNumber: po.purchaseOrderNumber,
                purchaseOrderId: po.id,
                placedOn: po.placedOn
            }))
        );
        
        const selectedItems = allLineItems.filter(item => 
            this.state.selectedPurchasedParts.includes(item.id)
        );

        // Check if all selected items are from the same vendor
        const vendors = [...new Set(selectedItems.map(item => item.companyName))];
        if (vendors.length > 1) {
            window.$alertError('All selected items must be from the same vendor');
            return;
        }

        this.setState({
            multiSelectPaidModalOpen: true,
            multiSelectInvoiceNumber: '',
            multiSelectInvoiceFile: null
        });
    };

    handleMultiSelectReceived = () => {
        if (this.state.selectedPurchasedParts.length === 0) {
            window.$alertError('Please select at least one item');
            return;
        }

        // Group selected items by vendor
        const filteredPurchaseOrders = this.getFilteredPurchaseOrders(this.state.purchaseOrders || []);
        const allLineItems = filteredPurchaseOrders.flatMap(po => 
            po.purchasedParts.map(part => ({
                ...part,
                purchaseOrderNumber: po.purchaseOrderNumber,
                purchaseOrderId: po.id,
                placedOn: po.placedOn
            }))
        );
        
        const selectedItems = allLineItems.filter(item => 
            this.state.selectedPurchasedParts.includes(item.id)
        );

        // Check if all selected items are from the same vendor
        const vendors = [...new Set(selectedItems.map(item => item.companyName))];
        if (vendors.length > 1) {
            window.$alertError('All selected items must be from the same vendor');
            return;
        }

        this.setState({
            multiSelectReceivedModalOpen: true,
            multiSelectTrackingNumber: '',
            multiSelectReceivedDate: getCurrentLocalTime().format('YYYY-MM-DD'), // Reset to today
            multiSelectReceivedFile: null
        });
    };

    handleMultiSelectPaidSubmit = async () => {
        if (!this.state.multiSelectInvoiceNumber.trim()) {
            window.$alertError('Invoice number is required');
            return;
        }

        try {
            const partService = ServiceLocator.Instance.getPartService();
            
            // Get selected items
            const filteredPurchaseOrders = this.getFilteredPurchaseOrders(this.state.purchaseOrders || []);
            const allLineItems = filteredPurchaseOrders.flatMap(po => 
                po.purchasedParts.map(part => ({
                    ...part,
                    purchaseOrderNumber: po.purchaseOrderNumber,
                    purchaseOrderId: po.id,
                    placedOn: po.placedOn
                }))
            );
            
            const selectedItems = allLineItems.filter(item => 
                this.state.selectedPurchasedParts.includes(item.id)
            );

            // Create invoice
            const invoice = {
                id: uuid(),
                invoiceNumber: this.state.multiSelectInvoiceNumber,
                isPaid: true,
                userId: AuthenticationService.getInstance().getUserId()
            };

            // Create the invoice
            await partService.createInvoice(invoice, this.state.multiSelectInvoiceFile);

            // Use bulk attachment with quantities
            const purchasedPartQuantities = {};
            selectedItems.forEach(item => {
                purchasedPartQuantities[item.id] = item.quantity;
            });
            
            await partService.bulkAttachInvoiceToPurchasedParts(invoice.id, purchasedPartQuantities);

            window.$alertSuccess(`Invoice created and ${selectedItems.length} item(s) marked as paid`);
            this.setState({
                multiSelectPaidModalOpen: false,
                multiSelectInvoiceNumber: '',
                multiSelectInvoiceFile: null,
                selectedPurchasedParts: []
            });
            
            // Reload data to show the new invoice
            await this.loadData();
        } catch (error) {
            console.error('Error creating invoice and marking items as paid:', error);
            window.$alertError('Failed to create invoice and mark items as paid');
        }
    };

    handleMultiSelectReceivedSubmit = async () => {
        if (!this.state.multiSelectPackingSlipName.trim()) {
            window.$alertError('Packing slip name is required');
            return;
        }

        try {
            const partService = ServiceLocator.Instance.getPartService();
            
            // Get selected items
            const filteredPurchaseOrders = this.getFilteredPurchaseOrders(this.state.purchaseOrders || []);
            const allLineItems = filteredPurchaseOrders.flatMap(po => 
                po.purchasedParts.map(part => ({
                    ...part,
                    purchaseOrderNumber: po.purchaseOrderNumber,
                    purchaseOrderId: po.id,
                    placedOn: po.placedOn
                }))
            );
            
            const selectedItems = allLineItems.filter(item => 
                this.state.selectedPurchasedParts.includes(item.id)
            );

            // Create a single packing slip for all selected items
            const formData = new FormData();
            
            // Get vendor name from the first item (assuming all items are from the same vendor for multi-select)
            const vendorName = selectedItems[0]?.companyName || 'Unknown Vendor';
            
            // Use quantities from state if available, otherwise use remaining quantity
            // If quantity is explicitly set to 0 or blank, use 0 (don't receive anything)
            const quantitiesToReceive = {};
            selectedItems.forEach(item => {
                const quantityFromState = this.state.multiSelectReceivedQuantities[item.id];
                const remainingToReceive = Math.max(0, item.quantity - (item.quantityReceived || 0));
                
                // Check if quantity was explicitly set in the form (including 0)
                if (this.state.multiSelectReceivedQuantities.hasOwnProperty(item.id)) {
                    // Quantity was explicitly set - use it (even if 0)
                    const parsedQuantity = parseNumberInputValue(quantityFromState) || 0;
                    quantitiesToReceive[item.id] = Math.min(parsedQuantity, remainingToReceive);
                } else {
                    // Quantity was not set - default to remaining quantity
                    quantitiesToReceive[item.id] = remainingToReceive;
                }
            });

            const packingSlipData = {
                id: uuid(),
                name: this.state.multiSelectPackingSlipName,
                trackingNumber: this.state.multiSelectTrackingNumber,
                vendorName: vendorName,
                dateCreated: toUtcForStorage(getCurrentLocalTime()),
                isReceived: false, // Start as not received, then receive it
                userId: AuthenticationService.getInstance().getUserId(),
                items: selectedItems.filter(item => {
                    // Only include items with quantity > 0
                    const qty = quantitiesToReceive[item.id] ?? 0;
                    return qty > 0;
                }).map(item => ({
                    id: uuid(),
                    purchasedPartId: item.id,
                    quantityExpected: quantitiesToReceive[item.id] ?? 0,
                    quantityReceived: 0 // Start with 0, will be updated when received
                }))
            };

            formData.append('packingSlip', JSON.stringify(packingSlipData));
            
            // Add file if uploaded
            if (this.state.multiSelectReceivedFile) {
                formData.append('file', this.state.multiSelectReceivedFile);
            }

            // Create the packing slip
            const createdPackingSlip = await partService.createPurchaseOrderPackingSlip(formData);
            
            // Receive the packing slip with custom quantities
            const userId = AuthenticationService.getInstance().getUserId();
            const packingSlipItemQuantities = {};
            createdPackingSlip.items.forEach((psItem) => {
                // Find the original item by purchasedPartId
                const originalItem = selectedItems.find(item => item.id === psItem.purchasedPartId);
                if (originalItem) {
                    const qty = quantitiesToReceive[originalItem.id] ?? 0;
                    if (qty > 0) {
                        packingSlipItemQuantities[psItem.id] = qty;
                    }
                }
            });
            
            if (Object.keys(packingSlipItemQuantities).length > 0) {
                await partService.receivePackingSlipWithQuantities(createdPackingSlip.id, packingSlipItemQuantities);
            } else {
                // If no items to receive, delete the packing slip
                await partService.deletePackingSlip(createdPackingSlip.id);
                window.$alertWarning('No items to receive - packing slip not created');
                return;
            }

            // Update the received date, quantity received, and isReceived status for each purchased part
            // Only update items that have a quantity to receive > 0
            const receivedDate = toUtcForStorage(this.state.multiSelectReceivedDate);
            const itemsToUpdate = selectedItems.filter(item => {
                const qty = quantitiesToReceive[item.id] ?? 0;
                return qty > 0;
            });
            
            const updatePromises = itemsToUpdate.map(item => {
                const quantityReceived = quantitiesToReceive[item.id] ?? 0;
                const newQuantityReceived = (item.quantityReceived || 0) + quantityReceived;
                const isFullyReceived = newQuantityReceived >= item.quantity;
                
                const updatedItem = {
                    ...item,
                    receivedDate: receivedDate,
                    quantityReceived: newQuantityReceived,
                    isReceived: isFullyReceived // Mark as received only if fully received
                };
                return partService.updatePurchaseLog(updatedItem);
            });
            await Promise.all(updatePromises);

            window.$alertSuccess(`Packing slip created and ${itemsToUpdate.length} item(s) marked as received`);
            this.setState({
                multiSelectReceivedModalOpen: false,
                multiSelectTrackingNumber: '',
                multiSelectPackingSlipName: '',
                multiSelectReceivedDate: getCurrentLocalTime().format('YYYY-MM-DD'), // Reset to today
                multiSelectReceivedFile: null,
                multiSelectReceivedQuantities: {},
                multiSelectShowQuantities: false,
                selectedPurchasedParts: []
            });
            
            // Reload data to show the new packing slips
            await this.loadData();
        } catch (error) {
            console.error('Error creating packing slip and marking items as received:', error);
            window.$alertError('Failed to create packing slip and mark items as received');
        }
    };

    handleMultiSelectSkipPackingSlip = async () => {
        try {
            const partService = ServiceLocator.Instance.getPartService();
            
            // Get selected items
            const filteredPurchaseOrders = this.getFilteredPurchaseOrders(this.state.purchaseOrders || []);
            const allLineItems = filteredPurchaseOrders.flatMap(po => 
                po.purchasedParts.map(part => ({
                    ...part,
                    purchaseOrderNumber: po.purchaseOrderNumber,
                    purchaseOrderId: po.id,
                    placedOn: po.placedOn
                }))
            );
            
            const selectedItems = allLineItems.filter(item => 
                this.state.selectedPurchasedParts.includes(item.id)
            );

            // Use quantities from state if available, otherwise use remaining quantity
            // If quantity is explicitly set to 0 or blank, use 0 (don't receive anything)
            const quantitiesToReceive = {};
            selectedItems.forEach(item => {
                const quantityFromState = this.state.multiSelectReceivedQuantities[item.id];
                const remainingToReceive = Math.max(0, item.quantity - (item.quantityReceived || 0));
                
                // Check if quantity was explicitly set in the form (including 0)
                if (this.state.multiSelectReceivedQuantities.hasOwnProperty(item.id)) {
                    // Quantity was explicitly set - use it (even if 0)
                    const parsedQuantity = parseNumberInputValue(quantityFromState) || 0;
                    quantitiesToReceive[item.id] = Math.min(parsedQuantity, remainingToReceive);
                } else {
                    // Quantity was not set - default to remaining quantity
                    quantitiesToReceive[item.id] = remainingToReceive;
                }
            });

            // Update the received date, quantity received, and isReceived status for each purchased part
            // Only update items that have a quantity to receive > 0
            const receivedDate = toUtcForStorage(this.state.multiSelectReceivedDate);
            const itemsToUpdate = selectedItems.filter(item => {
                const qty = quantitiesToReceive[item.id] ?? 0;
                return qty > 0;
            });

            await partService.directReceive({
                lines: itemsToUpdate.map(item => ({
                    purchasedPartId: item.id,
                    quantity: quantitiesToReceive[item.id] ?? 0,
                    receivedDate
                })),
                userId: AuthenticationService.getInstance().getUserId()
            });

            window.$alertSuccess(`${itemsToUpdate.length} item(s) marked as received (no packing slip created)`);
            this.setState({
                multiSelectReceivedModalOpen: false,
                multiSelectTrackingNumber: '',
                multiSelectPackingSlipName: '',
                multiSelectReceivedDate: getCurrentLocalTime().format('YYYY-MM-DD'), // Reset to today
                multiSelectReceivedFile: null,
                multiSelectReceivedQuantities: {},
                multiSelectShowQuantities: false,
                selectedPurchasedParts: []
            });
            
            // Reload data to show the updated status
            await this.loadData();
        } catch (error) {
            console.error('Error marking items as received:', error);
            window.$alertError('Failed to mark items as received');
        }
    };

    handleMultiSelectSkipInvoice = async () => {
        try {
            const partService = ServiceLocator.Instance.getPartService();
            
            // Get selected items
            const filteredPurchaseOrders = this.getFilteredPurchaseOrders(this.state.purchaseOrders || []);
            const allLineItems = filteredPurchaseOrders.flatMap(po => 
                po.purchasedParts.map(part => ({
                    ...part,
                    purchaseOrderNumber: po.purchaseOrderNumber,
                    purchaseOrderId: po.id,
                    placedOn: po.placedOn
                }))
            );
            
            const selectedItems = allLineItems.filter(item => 
                this.state.selectedPurchasedParts.includes(item.id)
            );

            // Mark items as paid without creating invoice
            const updatePromises = selectedItems.map(item => {
                const updatedItem = {
                    ...item,
                    isPaid: true // Mark as paid
                };
                return partService.updatePurchaseLog(updatedItem);
            });
            await Promise.all(updatePromises);

            window.$alertSuccess(`${selectedItems.length} item(s) marked as paid (no invoice created)`);
            this.setState({
                multiSelectPaidModalOpen: false,
                multiSelectInvoiceNumber: '',
                multiSelectInvoiceFile: null,
                selectedPurchasedParts: []
            });
            
            // Reload data to show the updated status
            await this.loadData();
        } catch (error) {
            console.error('Error marking items as paid:', error);
            window.$alertError('Failed to mark items as paid');
        }
    };

    handleCloseEditLog = () => {
        this.setState({
            editingLog: null,
            editingLogOriginal: null,
            editLogOpen: false,
            editingReceivingActionId: null,
            editingReceivingAction: {}
        });
    };

    hasEditLogUnsavedChanges = () => {
        if (this.state.editingReceivingActionId) return true;
        if (!this.state.editingLog || !this.state.editingLogOriginal) return false;
        
        const current = this.state.editingLog;
        const original = this.state.editingLogOriginal;
        
        return (
            current.companyName !== original.companyName ||
            current.quantity !== original.quantity ||
            current.isPaid !== original.isPaid ||
            current.quantityReceived !== original.quantityReceived ||
            current.partId !== original.partId ||
            new Date(current.orderDate).getTime() !== new Date(original.orderDate).getTime()
        );
    };

    handleCloseEditOrder = () => {
        this.setState({
            editingOrder: null, 
            editOrderOpen: false,
            loadingPackingSlips: false,
            editingVendorOrderNumber: ''
        });
    };

    updatePurchaseLog = () => {
        const self = this;
        self.setState({savingPurchaseLog: true});
        Promise.all([self.saveLog(), self.saveInvoiceFiles(), self.savePackingSlipFiles()]).then(() => {
            self.setState({editLogOpen: false, savingPurchaseLog: false});
            self.loadData();
        });
    };

    saveLog = () => {
        const payload = {
            id: editingLog.id,
            companyName: editingLog.companyName,
            quantity: parseNumberInputValue(editingLog.quantity),
            quantityReceived: parseNumberInputValue(editingLog.quantityReceived),
            partId: editingLog.partId,
            isPaid: editingLog.isPaid,
            orderDate: toUtcForStorage(editingLog.orderDate),
            orderId: editingLog.orderId,
            pricePaid: editingLog.pricePaid,
            receivedDate: toUtcForStorage(editingLog.receivedDate)
        };
        const partService = ServiceLocator.Instance.getPartService();
        return partService.updatePurchaseLog(payload).then(() => {
            window.$alertSuccess("Purchase log updated");
        });
    };

    saveInvoiceFiles = () => {
        // Note: Invoice attachment is now handled at the line-item level using the new interface
        // This method is deprecated and no longer used
        return Promise.resolve();
    };

    savePackingSlipFiles = () => {
        const self = this;
        if (this.state.packingSlipFiles.length > 0) {
            self.setState({savingPurchaseOrder: true});
            const partService = ServiceLocator.Instance.getPartService();
            
            // Create the packing slip data
            const packingSlipData = {
                purchaseOrderFk: this.state.selectedPurchaseOrderId,
                dateReceived: toUtcForStorage(new Date()),
                items: this.state.packingSlipItems || []
            };

            // For now, we'll just use the first file
            const file = this.state.packingSlipFiles[0];
            
            return partService.createPurchaseOrderPackingSlip(packingSlipData, file).then((newPackingSlip) => {
                window.$alertSuccess("Packing slip uploaded.");
                self.setState({savingPurchaseOrder: false, packingSlipFiles: [], packingSlipItems: []});
                self.loadData();
            }).catch(function (error) {
                window.$alertError("Something went wrong saving your packing slip.");
                console.log(error);
                self.setState({savingPurchaseOrder: false});
            });
        } else return Promise.resolve();
    };

    download(url, filename) {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';

        xhr.onload = function () {
            const hyperlinkElement = document.createElement("a");
            hyperlinkElement.href = URL.createObjectURL(xhr.response);
            hyperlinkElement.setAttribute("download", filename);
            hyperlinkElement.click();
        };

        xhr.open('GET', url);
        xhr.send();
    }

    deletePurchaseLog = () => {
        const confirm = window.confirm("Are you sure you want to delete this purchase log?");
        if (!confirm) return;

        const self = this;
        self.setState({savingPurchaseLog: true});
        const partService = ServiceLocator.Instance.getPartService();
        partService.deletePurchaseLog(editingLog.id).then(() => {
            window.$alertSuccess("Purchase log deleted");
            self.setState({editLogOpen: false, savingPurchaseLog: false});
            self.loadData();
        });
    };

    updatePurchaseOrder = () => {
        const self = this;
        self.setState({savingPurchaseLog: true});
        Promise.all([self.saveOrder(), self.saveInvoiceFiles(), self.savePackingSlipFiles()]).then(() => {
            self.setState({editOrderOpen: false, savingPurchaseLog: false});
            self.loadData();
        });
    };

    saveOrder = () => {
        // Update the editingOrder with the current vendor order number from state
        const updatedOrder = {
            ...this.state.editingOrder,
            vendorOrderNumber: this.state.editingVendorOrderNumber
        };
        
        const partService = ServiceLocator.Instance.getPartService();
        return partService.updatePurchaseOrder(updatedOrder).then(() => {
            window.$alertSuccess("Purchase order updated");
        });
    };

    deletePurchaseOrder = () => {
        const confirm = window.confirm("Are you sure you want to delete this purchase order?");
        if (!confirm) return;

        const self = this;
        self.setState({savingPurchaseLog: true});
        const partService = ServiceLocator.Instance.getPartService();
        partService.deletePurchaseOrder(this.state.editingOrder.id).then(() => {
            window.$alertSuccess("Purchase order deleted");
            self.setState({editOrderOpen: false, savingPurchaseLog: false});
            self.loadData();
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage}, () => {
            this.saveFilterSettings();
        });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    searchPurchases = (event) => {
        const searchInput = event.target.value;
        this.setState({searchTerm: event.target.value, page: 0}, () => {
            this.saveFilterSettings();
        });
    };

    getPurchaseSearchTerms = () => {
        return (this.state.searchTerm || '')
            .split(' ')
            .map(term => term.trim().toLowerCase())
            .filter(term => term !== '');
    };

    purchaseSearchTermMatchesPart = (part, order, searchTerm) => {
        if (order.purchaseOrderNumber?.toString().toLowerCase().includes(searchTerm)) return true;
        if (order.vendorOrderNumber?.toString().toLowerCase().includes(searchTerm)) return true;

        const partExpanded = this.state.parts.find(x => x.part.id === part.partId);
        if (partExpanded?.part.partId?.toLowerCase().includes(searchTerm)) return true;
        if (partExpanded?.part.description?.toLowerCase().includes(searchTerm)) return true;
        if (part.companyName?.toLowerCase().includes(searchTerm)) return true;

        const user = this.state.adminUsers.find(x => x.id === part.userId);
        if (user && `${user.firstName} ${user.lastName}`.toLowerCase().includes(searchTerm)) return true;

        return false;
    };

    getFilteredPurchaseOrders = (purchaseOrders) => {
        const showOnlyOutstanding = this.state.showOnlyOutstanding;
        const showOnlyUnpaid = this.state.showOnlyUnpaid;
        const showOnlyInTransit = this.state.showOnlyInTransit;
        const searchTerms = this.getPurchaseSearchTerms();
        
        return purchaseOrders.filter(order => {
            // First filter parts based on outstanding, unpaid, and in transit status
            const filteredParts = order.purchasedParts.filter(part => {
                // Check outstanding status
                if (showOnlyOutstanding && part.quantity <= (part.quantityReceived || 0)) {
                    return false;
                }
                
                // Check unpaid status
                if (showOnlyUnpaid && part.isPaid) {
                    return false;
                }
                
                // Check in transit status - only show rows where inTransitQuantity > 0 (matching display logic on line 3913)
                if (showOnlyInTransit) {
                    // Match the exact display logic: purchaseLog.inTransitQuantity > 0
                    const inTransit = part.inTransitQuantity;
                    // Use the same condition as display: inTransitQuantity > 0
                    if (inTransit == null || inTransit === '' || !(Number(inTransit) > 0)) {
                        return false;
                    }
                }
                
                return true;
            });

            // If no parts match the filters, exclude the entire order
            if (filteredParts.length === 0) {
                return false;
            }

            if (searchTerms.length === 0) return true;

            // Every term must match the order or at least one remaining line.
            return searchTerms.every(term =>
                filteredParts.some(part => this.purchaseSearchTermMatchesPart(part, order, term))
            );
        }).map(order => ({
            ...order,
            // Only include the filtered parts in the order
            purchasedParts: order.purchasedParts.filter(part => {
                if (showOnlyOutstanding && part.quantity <= (part.quantityReceived || 0)) {
                    return false;
                }
                if (showOnlyUnpaid && part.isPaid) {
                    return false;
                }
                
                if (searchTerms.length > 0) {
                    return searchTerms.every(term => this.purchaseSearchTermMatchesPart(part, order, term));
                }
                
                return true;
            })
        }));
    };

    handleFamilyChange = (event, newValue, rowIndex) => {
        if (!newValue) return;
        const { parts, vendors } = this.state;
        const selectedPart = parts.find(x => x.part.id === newValue.value);
        const family = this.state.partFamilies.find(x => x.id === newValue.value);

        // Check if the selected item is a family
        if (family) {
            // Find all parts that belong to this family
            const familyParts = parts.filter(x => x.part.partToFamilies?.some(ptf => ptf.familyId === family.id));
            
            // Get the purchase quantity from the first part in the family
            const firstPartToFamily = familyParts[0]?.part.partToFamilies.find(ptf => ptf.familyId === family.id);
            const familyPurchaseQuantity = parseInt(firstPartToFamily?.purchaseQuantity) || 1;

            // Update the family row
            const updatedLogParts = this.state.newLogParts.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...row,
                        familyId: family.id,
                        familyQuantity: 1,
                        description: family.description,
                        isFamilyRow: true,
                        isOverridden: false,
                        selectedOption: {
                            ...newValue,
                            family: family
                        }
                    };
                }
                return row;
            });

            // Remove any existing parts from this family, but keep the family row
            const filteredLogParts = updatedLogParts.filter(row => row.familyId !== family.id || row.isFamilyRow);

            // Find the index of the family row
            const index = filteredLogParts.findIndex(row => row.id === updatedLogParts[rowIndex].id);

            // Add part rows after the family row
            familyParts.forEach((part, i) => {
                const partToFamily = part.part.partToFamilies.find(ptf => ptf.familyId === family.id);
                
                // Skip implied parts when adding families to purchase orders
                if (partToFamily && partToFamily.isImpliedPart) {
                    return;
                }
                const vendorPart = part.part.vendorParts.find(x => x.vendorId === part.part.selectedVendorId) || part.part.vendorParts[0];
                const vendorName = vendorPart ? vendors.find(x => x.id === vendorPart.vendorId)?.name : '';
                let initialPrice = 0;
                const purchaseQuantity = parseInt(partToFamily?.purchaseQuantity) || 1;
                const partQuantity = purchaseQuantity; // Initial family quantity is 1

                if (vendorPart && vendorPart.costType === 0 && vendorPart.tieredCostFormulas && vendorPart.tieredCostFormulas.length > 0) {
                    // Use selected tiered cost formula for default unit price
                    const selectedTier = vendorPart.tieredCostFormulas.find(t => t.isSelected);
                    const tier = selectedTier || [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity)[0];
                    initialPrice = normalizeUnitCost(tier.price);
                } else if (vendorPart) {
                    initialPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
                }

                const newPartRow = {
                    id: uuid(),
                    familyId: family.id,
                    familyQuantity: 1,
                    partId: part.part.id,
                    partQuantity: partQuantity,
                    description: part.part.description,
                    vendor: vendorName,
                    vendorId: vendorPart?.vendorId,
                    price: initialPrice,
                    total: calculateLineTotal(initialPrice, partQuantity),
                    isFamilyRow: false,
                    isOverridden: false,
                    isFamilyPart: true,
                    vendorParts: part.part.vendorParts,
                    selectedOption: {
                        title: `${part.part.partId} rev ${part.part.revision}`,
                        value: part.part.id,
                        part: part.part
                    }
                };
                filteredLogParts.splice(index + 1 + i, 0, newPartRow);
            });

            this.setState({ newLogParts: filteredLogParts }, () => {
                // Autofocus the family quantity input field after family selection
                setTimeout(() => {
                    const quantityInput = document.querySelector(`input[data-row-index="${rowIndex}"][data-field-type="family-quantity"]`);
                    if (quantityInput) {
                        quantityInput.focus();
                        quantityInput.select();
                    }
                }, 100);
            });
        } else if (selectedPart) {
            // Check if the selected part belongs to a family
            if (selectedPart.part.partToFamilies && selectedPart.part.partToFamilies.length > 0) {
                // Only select the family if the part belongs to exactly one family
                if (selectedPart.part.partToFamilies.length === 1) {
                    const familyId = selectedPart.part.partToFamilies[0].familyId;
                    const partFamily = this.state.partFamilies.find(f => f.id === familyId);
                    
                    if (partFamily) {
                        // Automatically select the family instead of the individual part
                        // Create a new value object for the family
                        const familyValue = {
                            title: `${partFamily.partFamilyId} (Family)`,
                            value: partFamily.id,
                            isFamily: true
                        };
                        
                        // Recursively call this method with the family value
                        this.handleFamilyChange(event, familyValue, rowIndex);
                        return;
                    }
                }
                // If part belongs to multiple families, select the part directly
            }
            
            // Handle individual part selection (no family found)
            const updatedLogParts = this.state.newLogParts.map((row, index) => {
                if (index === rowIndex) {
                    const vendorPart = selectedPart.part.vendorParts.find(x => x.vendorId === selectedPart.part.selectedVendorId) || selectedPart.part.vendorParts[0];
                    const vendorName = vendorPart ? vendors.find(x => x.id === vendorPart.vendorId)?.name : '';
                    let initialPrice = 0;
                    let initialQuantity = 1;

                    if (vendorPart && vendorPart.costType === 0 && vendorPart.tieredCostFormulas && vendorPart.tieredCostFormulas.length > 0) {
                        // Find the selected tiered cost formula
                        const selectedTier = vendorPart.tieredCostFormulas.find(t => t.isSelected);
                        if (selectedTier) {
                            initialPrice = normalizeUnitCost(selectedTier.price);
                            initialQuantity = selectedTier.quantity;
                        } else {
                            // Fallback to first tier if none selected
                            const sortedTiers = [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity);
                            initialPrice = normalizeUnitCost(sortedTiers[0].price);
                            initialQuantity = sortedTiers[0].quantity;
                        }
                    } else if (vendorPart) {
                        initialPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
                        initialQuantity = vendorPart.quantity || initialQuantity;
                    }

                    return {
                        ...row,
                        familyId: null,
                        familyQuantity: null,
                        partId: selectedPart.part.id,
                        partQuantity: initialQuantity,
                        description: selectedPart.part.description,
                        vendor: vendorName,
                        vendorId: vendorPart?.vendorId,
                        price: initialPrice,
                        total: calculateLineTotal(initialPrice, initialQuantity),
                        isFamilyRow: false,
                        isOverridden: false,
                        isFamilyPart: false,
                        vendorParts: selectedPart.part.vendorParts,
                        selectedOption: newValue
                    };
                }
                return row;
            });

            this.setState({ newLogParts: updatedLogParts }, () => {
                // Autofocus the part quantity input field after part selection
                setTimeout(() => {
                    const quantityInput = document.querySelector(`input[data-row-index="${rowIndex}"][data-field-type="part-quantity"]`);
                    if (quantityInput) {
                        quantityInput.focus();
                        quantityInput.select();
                    }
                }, 100);
            });
        }
    };

    handlePartDisplayClick = (rowIndex) => {
        // Set isModifying to true to show the autocomplete
        const updatedRows = [...this.state.newLogParts];
        updatedRows[rowIndex].isModifying = true;
        this.setState({ newLogParts: updatedRows });
    };

    handleFamilyQuantityChange = (event, rowIndex) => {
        const newQuantity = event.target.value;
        const familyId = this.state.newLogParts[rowIndex].familyId;

        const updatedLogParts = this.state.newLogParts.map((row, index) => {
            if (index === rowIndex) {
                return { ...row, familyQuantity: newQuantity };
            }
            if (row.familyId === familyId && !row.isFamilyRow) {
                const part = this.state.parts.find(x => x.part.id === row.partId);
                if (!part) return row;
                
                // Get the PartToFamily relationship for this part and family
                const partFamilyRelation = part.part.partToFamilies.find(ptf => ptf.familyId === familyId);
                const purchaseQuantity = parseInt(partFamilyRelation?.purchaseQuantity) || 1;
                const partQuantity = purchaseQuantity * parseNumberInputValue(newQuantity);
                
                // Find the vendor part to check for tiered pricing
                const vendorPart = row.vendorParts?.find(vp => vp.vendorId === row.vendorId);
                let newPrice = normalizeUnitCost(row.price);
                
                if (vendorPart && vendorPart.costType === 0 && !row.isOverridden) { // Tiered pricing
                    // Sort tiers by quantity in ascending order to find the correct threshold
                    const sortedTiers = [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity);
                    // Find the highest tier less than or equal to the quantity
                    const tier = [...sortedTiers].reverse().find(t => partQuantity >= t.quantity) || sortedTiers[0];
                    newPrice = normalizeUnitCost(tier.price);
                }
                
                return {
                    ...row,
                    partQuantity: partQuantity,
                    price: newPrice,
                    total: calculateLineTotal(newPrice, partQuantity),
                    isOverridden: false // Reset override flag when family quantity changes
                };
            }
            return row;
        });

        this.setState({ newLogParts: updatedLogParts });
    };

    handleVendorChange = (event, index) => {
        const {newLogParts} = this.state;
        const row = newLogParts[index];
        const vendorId = event.target.value;
        const vendor = this.state.vendors.find(x => x.id === vendorId);
        const vendorPart = row.vendorParts?.find(vp => vp.vendorId === vendorId);

        if (vendorPart) {
            // Keep user's quantity; only update price/total from new vendor's pricing
            const quantity = parseNumberInputValue(row.partQuantity) || 1;
            let newPrice = 0;

            if (vendorPart.costType === 0) { // Tiered pricing
                const sortedTiers = [...(vendorPart.tieredCostFormulas || [])].sort((a, b) => a.quantity - b.quantity);
                const tier = quantity < sortedTiers[0]?.quantity
                    ? sortedTiers[0]
                    : [...sortedTiers].reverse().find(t => quantity >= t.quantity) || sortedTiers[sortedTiers.length - 1];
                if (tier) {
                    newPrice = normalizeUnitCost(tier.price);
                }
            } else { // Fixed pricing
                newPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
            }

            row.vendor = vendor.name;
            row.vendorId = vendorId;
            row.companyName = vendor.name;
            row.price = newPrice;
            // Do not overwrite row.partQuantity - keep the user's entered quantity
            row.total = calculateLineTotal(newPrice, quantity);
            row.pricePaid = row.total.toFixed(2);
            row.isOverridden = true;

            this.setState({newLogParts});
        }
    };

    handlePartQuantityChange = (event, index) => {
        const newQuantity = event.target.value; // Store raw value during typing
        const updatedLogParts = [...this.state.newLogParts];
        const row = updatedLogParts[index];
        
        // Update quantity
        updatedLogParts[index] = {
            ...row,
            partQuantity: newQuantity
        };

        // Recalculate price based on new quantity if using tiered pricing
        if (row.vendorParts) {
            const vendorPart = row.vendorParts.find(vp => vp.vendorId === row.vendorId);
            if (vendorPart && vendorPart.costType === 0 && vendorPart.tieredCostFormulas?.length > 0) { // Tiered pricing
                // Sort tiers by quantity in ascending order to find the lowest applicable tier
                const sortedTiers = [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity);
                // If quantity is below first threshold, use lowest tier
                // Otherwise find the highest applicable tier
                const tier = newQuantity < sortedTiers[0].quantity 
                    ? sortedTiers[0] 
                    : [...sortedTiers].reverse().find(t => newQuantity >= t.quantity) || sortedTiers[sortedTiers.length - 1];
                
                if (tier) {
                    updatedLogParts[index] = {
                        ...updatedLogParts[index],
                        price: normalizeUnitCost(tier.price),
                        total: calculateLineTotal(tier.price, newQuantity)
                    };
                } else {
                    // If no tier found, just update the total with current price
                    updatedLogParts[index] = {
                        ...updatedLogParts[index],
                        total: calculateLineTotal(row.price, newQuantity)
                    };
                }
            } else {
                // For fixed pricing or no tiers, just update the total
                updatedLogParts[index] = {
                    ...updatedLogParts[index],
                    total: calculateLineTotal(row.price, newQuantity)
                };
            }
        } else {
            // If no vendor parts, just update the total
            updatedLogParts[index] = {
                ...updatedLogParts[index],
                total: calculateLineTotal(row.price, newQuantity)
            };
        }

        this.setState({ newLogParts: updatedLogParts });
    };

    handlePartPriceChange = (event, rowIndex) => {
        const {newLogParts} = this.state;
        const row = newLogParts[rowIndex];
        const newPrice = event.target.value;
        
        row.price = normalizeUnitCost(newPrice);
        row.total = calculateLineTotal(row.price, row.partQuantity);
        row.isOverridden = true;

        this.setState({newLogParts});
    };

    removeLine = (rowIndex) => {
        const {newLogParts} = this.state;
        const row = newLogParts[rowIndex];
        
        if (row.isFamilyRow) {
            // Remove family row and all its part rows
            const filteredLogParts = newLogParts.filter(x => x.familyId !== row.familyId);
            this.setState({ newLogParts: filteredLogParts });
        } else {
            // Remove just the part row
            newLogParts.splice(rowIndex, 1);
            this.setState({ newLogParts });
        }
    };

    handleQuantityKeyDown = (event, currentIndex) => {
        if (event.key === 'Tab' && !event.shiftKey) {
            // If this is the last row and we're tabbing forward from the quantity field, create new line
            if (currentIndex === this.state.newLogParts.length - 1) {
                event.preventDefault();
                this.addNewLine();
                // Focus on the new row's part number field
                setTimeout(() => {
                    const nextRowIndex = this.state.newLogParts.length - 1;
                    const nextInput = document.querySelector(`input[data-row-index="${nextRowIndex}"][data-field-type="part-number"]`);
                    if (nextInput) {
                        nextInput.focus();
                    }
                }, 100);
            }
        }
    };

    addNewLine = () => {
        this.setState(prevState => ({
            newLogParts: [...prevState.newLogParts, {
                id: uuid(),
                familyId: null,
                familyQuantity: 1,
                isFamilyRow: true,
                description: '',
                vendor: '',
                vendorId: null,
                vendors: [],
                vendorsList: [],
                vendorParts: [],
                price: 0,
                pricePaid: '0.00',
                total: 0,
                quantity: 1,
                partQuantity: 1,
                selectedOption: null,
                partId: null,
                isModifying: false,
                isOverridden: false,
                isFamilyPart: false,
                companyName: ''
            }]
        }));
    };

    submitPurchaseOrder = () => {
        const self = this;
        self.setState({savingPurchaseLog: true});

        // Group parts by vendor
        const vendorGroups = {};
        this.state.newLogParts.filter(x => !x.isFamilyRow).forEach(part => {
            if (!vendorGroups[part.vendor]) {
                vendorGroups[part.vendor] = [];
            }
            vendorGroups[part.vendor].push(part);
        });

        // Create a purchase order for each vendor
        const promises = Object.entries(vendorGroups).map(([vendor, parts]) => {
            const payload = {
                id: uuid(),
                placedOn: this.state.newPurchaseOrderDate,
                vendorOrderNumber: this.state.newVendorOrderNumber,
                pricePaid: normalizeMoney(parts.reduce((sum, part) => sum + (part.total || 0), 0)),
                invoices: [],
                packingSlips: [],
                userId: AuthenticationService.getInstance().getUserId(),
                purchasedParts: parts.map(part => {
                    const basePart = {
                        id: uuid(),
                        companyName: vendor,
                        quantityReceived: 0,
                        isPaid: false,
                        isReceived: false,
                        orderDate: this.state.newPurchaseOrderDate,
                        receivedDate: null,
                        pricePaid: normalizeMoney(part.total),
                        userId: AuthenticationService.getInstance().getUserId()
                    };

                    // If this part has a family and no quantity override, use the family ID
                    if (part.family && !part.quantity) {
                        return {
                            ...basePart,
                            partFamilyId: part.family.id,
                            quantity: parseNumberInputValue(part.family.quantity)
                        };
                    }
                    // Otherwise use the individual part ID and quantity
                    return {
                        ...basePart,
                        partId: part.partId,
                        quantity: parseNumberInputValue(part.partQuantity)
                    };
                })
            };
            const partService = ServiceLocator.Instance.getPartService();
            return partService.createPurchaseOrder(payload);
        });

        Promise.all(promises).then(() => {
            // Create copy table data grouped by vendor
            const copyTablesByVendor = {};
            Object.entries(vendorGroups).forEach(([vendor, parts]) => {
                copyTablesByVendor[vendor] = parts.map(part => {
                    const partExpanded = self.state.parts.find(x => x.part.id === part.partId);
                    return {
                        partNumber: partExpanded?.part.partId || 'Unknown',
                        revision: partExpanded?.part.revision || '',
                        quantity: part.partQuantity
                    };
                }).sort((a, b) => {
                    // Sort by partNumber first, then by revision
                    const partNumberCompare = (a.partNumber || '').localeCompare(b.partNumber || '');
                    if (partNumberCompare !== 0) {
                        return partNumberCompare;
                    }
                    return (a.revision || '').localeCompare(b.revision || '');
                });
            });
            
            window.$alertSuccess("Purchase orders created");
            self.setState({
                addingPurchaseLogOpen: false, 
                savingPurchaseLog: false,
                showCopyTable: true,
                copyTablesByVendor
            });
            self.loadData();
        });
    };

    handleReceivePackingSlip = async (packingSlipId) => {
        // Prevent double receiving
        if (this.state.receivingPackingSlip) {
            return;
        }
        
        this.setState({ receivingPackingSlip: true });
        
        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.receivePurchaseOrderPackingSlip(packingSlipId);
            
            // Update the packing slip in the local state
            const updatedPackingSlip = editingOrder.packingSlips.find(slip => slip.id === packingSlipId);
            if (updatedPackingSlip) {
                updatedPackingSlip.isReceived = true;
                updatedPackingSlip.dateReceived = toUtcForStorage(new Date());
            }

            // Update the quantities in the purchased parts
            if (updatedPackingSlip?.items) {
                updatedPackingSlip.items.forEach(item => {
                    const purchasedPart = editingOrder.purchasedParts.find(p => p.partId === item.partId);
                    if (purchasedPart) {
                        purchasedPart.quantityReceived = (purchasedPart.quantityReceived || 0) + item.quantityReceived;
                    }
                });
            }

            // Update the purchase order in the state
            const updatedPurchaseOrders = this.state.purchaseOrders.map(po => 
                po.id === editingOrder.id ? editingOrder : po
            );

            this.setState({ 
                purchaseOrders: updatedPurchaseOrders,
                editingOrder: { ...editingOrder }
            });

            window.$alertSuccess("Packing slip received");
        } catch (error) {
            console.error('Error receiving packing slip:', error);
            if (error.message && error.message.includes('already been received')) {
                window.$alertError("This packing slip has already been received");
            } else {
                window.$alertError("Failed to receive packing slip");
            }
        } finally {
            this.setState({ receivingPackingSlip: false });
        }
    };

    // New receiving methods
    handlePackingSlipSelect = (packingSlip) => {
        const receivedQuantities = {};
        if (packingSlip.items) {
            packingSlip.items.forEach(item => {
                receivedQuantities[item.id] = item.quantityExpected;
            });
        }
        this.setState({
            selectedPackingSlip: packingSlip,
            receivedQuantities,
            receiveDrawerOpen: true
        });
    };

    handleReceiveAll = async () => {
        this.setState({receivingPackingSlip: true});
        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.receivePurchaseOrderPackingSlip(this.state.selectedPackingSlip.id);
            
            window.$alertSuccess('Packing slip received successfully');
            this.closeReceiveDrawer();
            
            // Refresh the editing order
            await this.refreshEditingOrder();
        } catch (error) {
            console.error('Error receiving packing slip:', error);
            if (error.message && error.message.includes('already been received')) {
                window.$alertError("This packing slip has already been received");
            } else {
                window.$alertError('Failed to receive packing slip');
            }
        } finally {
            this.setState({receivingPackingSlip: false});
        }
    };

    handleReceiveCustom = async () => {
        this.setState({receivingPackingSlip: true});
        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.receivePackingSlipWithQuantities(
                this.state.selectedPackingSlip.id,
                this.state.receivedQuantities
            );
            
            window.$alertSuccess('Packing slip received successfully');
            this.closeReceiveDrawer();
            
            // Refresh the editing order
            await this.refreshEditingOrder();
        } catch (error) {
            console.error('Error receiving packing slip:', error);
            if (error.message && error.message.includes('already been received')) {
                window.$alertError("This packing slip has already been received");
            } else {
                window.$alertError('Failed to receive packing slip');
            }
        } finally {
            this.setState({receivingPackingSlip: false});
        }
    };

    handleQuantityChange = (itemId, value) => {
        this.setState(prevState => ({
            receivedQuantities: {
                ...prevState.receivedQuantities,
                [itemId]: parseNumberInputValue(value)
            }
        }));
    };

    closeReceiveDrawer = () => {
        this.setState({
            receiveDrawerOpen: false,
            selectedPackingSlip: null,
            receivedQuantities: {}
        });
    };

    getTieredPricingTooltip = (vendorPart) => {
        if (!vendorPart) return '';
        
        if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas?.length > 0) {
            return vendorPart.tieredCostFormulas
                .sort((a, b) => a.quantity - b.quantity)
                .map(tier => `${tier.quantity}: $${Number(tier.price).toFixed(2)} ea`)
                .join('\n');
        } else {
            return `${vendorPart.quantity}: $${Number(vendorPart.basePrice / vendorPart.quantity).toFixed(UNIT_COST_DECIMALS) || '0.00'} ea`;
        }
    };

        closeCopyTable = () => {
        this.setState({ 
            showCopyTable: false,
            copyTableData: [],
            copyTablesByVendor: {}
        });
    };

    copyVendorTableToClipboard = async (vendor, tableData) => {
        // Create HTML table string for specific vendor
        const tableHtml = `
            <table style="border-collapse: collapse; border: 1px solid black; font-family: Arial, sans-serif; font-size: 12px;">
                <thead>
                    <tr>
                        <th style="border: 1px solid black; padding: 8px; background-color: #f0f0f0; text-align: center;">Quantity</th>
                        <th style="border: 1px solid black; padding: 8px; background-color: #f0f0f0; text-align: center;">Item</th>
                    </tr>
                </thead>
                <tbody>
                    ${tableData.map(item => 
                        `<tr>
                            <td style="border: 1px solid black; padding: 8px; text-align: center;">${item.quantity}</td>
                            <td style="border: 1px solid black; padding: 8px; text-align: left;">${item.partNumber} rev ${item.revision}</td>
                        </tr>`
                    ).join('')}
                </tbody>
            </table>
        `;

        // Create plain text version as fallback
        const plainText = `Quantity\tItem\n${tableData.map(item => 
            `${item.quantity}\t${item.partNumber} rev ${item.revision}`
        ).join('\n')}`;

        try {
            // Try to copy HTML to clipboard
            if (window.ClipboardItem) {
                await navigator.clipboard.write([
                    new window.ClipboardItem({
                        'text/html': new Blob([tableHtml], { type: 'text/html' }),
                        'text/plain': new Blob([plainText], { type: 'text/plain' })
                    })
                ]);
                window.$alertSuccess(`${vendor} table copied to clipboard!`);
            } else {
                // Fallback if ClipboardItem is not available
                await navigator.clipboard.writeText(plainText);
                window.$alertSuccess(`${vendor} table copied to clipboard as text!`);
            }
        } catch (err) {
            console.error('Failed to copy table: ', err);
            window.$alertError("Failed to copy table to clipboard");
        }
    };

    copyTableToClipboard = async () => {
        // Create HTML table string
        const tableHtml = `
            <table style="border-collapse: collapse; border: 1px solid black; font-family: Arial, sans-serif; font-size: 12px;">
                <thead>
                    <tr>
                        <th style="border: 1px solid black; padding: 8px; background-color: #f0f0f0; text-align: center;">Quantity</th>
                        <th style="border: 1px solid black; padding: 8px; background-color: #f0f0f0; text-align: left;">Item</th>
                    </tr>
                </thead>
                <tbody>
                    ${this.state.copyTableData.map(item => 
                        `<tr>
                            <td style="border: 1px solid black; padding: 8px; text-align: center;">${item.quantity}</td>
                            <td style="border: 1px solid black; padding: 8px;">${item.partNumber} rev ${item.revision}</td>
                        </tr>`
                    ).join('')}
                </tbody>
            </table>
        `;

        // Create plain text version as fallback
        const plainText = `Quantity\tItem\n${this.state.copyTableData.map(item => 
            `${item.quantity}\t${item.partNumber} rev ${item.revision}`
        ).join('\n')}`;

        try {
            // Try to copy HTML to clipboard
            if (window.ClipboardItem) {
                await navigator.clipboard.write([
                    new window.ClipboardItem({
                        'text/html': new Blob([tableHtml], { type: 'text/html' }),
                        'text/plain': new Blob([plainText], { type: 'text/plain' })
                    })
                ]);
                window.$alertSuccess('Table copied to clipboard!');
            } else {
                // Fallback if ClipboardItem is not available
                await navigator.clipboard.writeText(plainText);
                window.$alertSuccess('Table copied to clipboard as text!');
            }
        } catch (err) {
            // Fallback to plain text if HTML clipboard fails
            try {
                await navigator.clipboard.writeText(plainText);
                window.$alertSuccess('Table copied to clipboard as text!');
            } catch (fallbackErr) {
                window.$alertError('Failed to copy to clipboard. Please copy manually.');
                console.error('Clipboard error:', fallbackErr);
            }
        }
    };

    showPurchaseOrderCopyTable = (purchaseOrder) => {
        const copyTableData = purchaseOrder.purchasedParts.map(part => {
            const partExpanded = this.state.parts.find(x => x.part.id === part.partId);
            return {
                partNumber: partExpanded?.part.partId || 'Unknown',
                revision: partExpanded?.part.revision || '',
                quantity: part.quantity
            };
        }).sort((a, b) => {
            // Sort by partNumber first, then by revision
            const partNumberCompare = (a.partNumber || '').localeCompare(b.partNumber || '');
            if (partNumberCompare !== 0) {
                return partNumberCompare;
            }
            return (a.revision || '').localeCompare(b.revision || '');
        });
        
        this.setState({
            showCopyTable: true,
            copyTableData
        });
    };

    getInvoiceForPurchaseOrder = (purchaseOrderId) => {
        const purchaseOrder = this.state.purchaseOrders.find(po => po.id === purchaseOrderId);
        if (!purchaseOrder || !purchaseOrder.purchaseOrderInvoices || purchaseOrder.purchaseOrderInvoices.length === 0) {
            return null;
        }
        
        // Find the first paid invoice
        for (const poi of purchaseOrder.purchaseOrderInvoices) {
            if (poi.invoice && poi.invoice.isPaid) {
                return poi.invoice;
            }
        }
        
        return null;
    };

    handleInvoiceClick = (purchaseOrderId) => {
        const invoice = this.getInvoiceForPurchaseOrder(purchaseOrderId);
        if (invoice && invoice.fileUrl) {
            window.open(invoice.fileUrl, '_blank');
        }
    };

    // New invoice management methods
    handleCreateInvoice = (purchaseOrderId) => {
        this.setState({
            createInvoiceDialogOpen: true,
            currentEditingPurchaseOrderId: purchaseOrderId,
            newInvoiceNumber: '',
            newInvoiceFile: null,
        });
    };

    handleCloseCreateInvoice = () => {
        this.setState({
            createInvoiceDialogOpen: false,
            currentEditingPurchaseOrderId: null,
            newInvoiceNumber: '',
            newInvoiceFile: null,
        });
    };

    handleSaveNewInvoice = async () => {
        if (!this.state.newInvoiceNumber.trim()) {
            window.$alertError('Invoice number is required');
            return;
        }

        this.setState({savingInvoice: true});
        
        try {
            const partService = ServiceLocator.Instance.getPartService();
            const invoice = {
                id: uuid(),
                invoiceNumber: this.state.newInvoiceNumber,
                isPaid: false,
                userId: AuthenticationService.getInstance().getUserId()
            };

            const createdInvoice = await partService.createInvoice(invoice, this.state.newInvoiceFile);
            
            // Attach the invoice to the current purchase order
            if (this.state.currentEditingPurchaseOrderId) {
                await partService.attachInvoiceToPurchaseOrder(createdInvoice.id, this.state.currentEditingPurchaseOrderId);
            }
            
            window.$alertSuccess('Invoice created and attached successfully');
            this.handleCloseCreateInvoice();
            await this.loadData();
            
            // Update editingOrder with fresh data from the state
            await this.refreshEditingOrder();
        } catch (error) {
            console.error('Error creating invoice:', error);
            window.$alertError('Failed to create invoice');
        } finally {
            this.setState({savingInvoice: false});
        }
    };

    handleAttachExistingInvoice = (purchaseOrderId) => {
        this.setState({
            attachInvoiceDialogOpen: true,
            currentEditingPurchaseOrderId: purchaseOrderId,
            invoiceToAttach: '',
        });
    };

    handleCloseAttachInvoice = () => {
        this.setState({
            attachInvoiceDialogOpen: false,
            currentEditingPurchaseOrderId: null,
            invoiceToAttach: '',
        });
    };

    handleSaveAttachInvoice = async () => {
        if (!this.state.invoiceToAttach) {
            window.$alertError('Please select an invoice to attach');
            return;
        }

        this.setState({savingInvoice: true});
        
        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.attachInvoiceToPurchaseOrder(this.state.invoiceToAttach, this.state.currentEditingPurchaseOrderId);
            
            window.$alertSuccess('Invoice attached successfully');
            this.handleCloseAttachInvoice();
            await this.loadData();
            
            // Update editingOrder with fresh data from the state
            await this.refreshEditingOrder();
        } catch (error) {
            console.error('Error attaching invoice:', error);
            window.$alertError('Failed to attach invoice');
        } finally {
            this.setState({savingInvoice: false});
        }
    };

    handleToggleInvoicePaidStatus = async (invoiceId, currentStatus) => {
        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.updateInvoicePaidStatus(invoiceId, !currentStatus);
            
            window.$alertSuccess(`Invoice marked as ${!currentStatus ? 'paid' : 'unpaid'}`);
            
            // Small delay to ensure backend has processed the update
            await new Promise(resolve => setTimeout(resolve, 500));
            
            // Refresh all data to ensure line item paid status is updated
            await this.loadData();
            
            // Update editingOrder with fresh data from the state
            await this.refreshEditingOrder();
        } catch (error) {
            console.error('Error updating invoice status:', error);
            window.$alertError('Failed to update invoice status');
        }
    };

    refreshEditingOrder = async () => {
        if (this.state.editingOrder && this.state.editingOrder.id) {
            const updatedOrder = this.state.purchaseOrders.find(po => po.id === this.state.editingOrder.id);
            if (updatedOrder) {
                try {
                    // Load packing slips for the updated order
                    const partService = ServiceLocator.Instance.getPartService();
                    const packingSlips = await this.attachShipmentFilesToPackingSlips(
                        await partService.getPackingSlipsByPurchaseOrderId(updatedOrder.id)
                    );
                    const updatedEditingOrder = {
                        ...updatedOrder,
                        packingSlips: packingSlips || []
                    };
                    this.setState({editingOrder: updatedEditingOrder});
                } catch (error) {
                    console.error('Error loading packing slips:', error);
                    // Fall back to just updating without packing slips
                    this.setState({editingOrder: updatedOrder});
                }
            }
        }
    };

    refreshEditingLog = async () => {
        if (editingLog && editingLog.id) {
            // Find the updated purchased part in the state data
            let updatedLog = null;
            let purchaseOrderId = null;
            for (const purchaseOrder of this.state.purchaseOrders) {
                if (purchaseOrder.purchasedParts) {
                    const foundLog = purchaseOrder.purchasedParts.find(part => part.id === editingLog.id);
                    if (foundLog) {
                        updatedLog = foundLog;
                        purchaseOrderId = purchaseOrder.id;
                        break;
                    }
                }
            }
            
            if (updatedLog) {
                // Update the global editingLog variable with fresh data
                Object.assign(editingLog, updatedLog);
                // Also update the state
                this.setState({editingLog: {...editingLog}});
                
                // Reload packing slips for the purchase order to show new packing slips
                if (purchaseOrderId) {
                    await this.loadPackingSlipsForPurchaseOrder(purchaseOrderId);
                }
            }
        }
    };

    handleDetachInvoice = async (invoiceId, purchaseOrderId) => {
        if (!window.confirm('Are you sure you want to detach this invoice from the purchase order?')) {
            return;
        }

        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.detachInvoiceFromPurchaseOrder(invoiceId, purchaseOrderId);
            
            window.$alertSuccess('Invoice detached successfully');
            await this.loadData();
            
            // Update editingOrder with fresh data from the state
            await this.refreshEditingOrder();
        } catch (error) {
            console.error('Error detaching invoice:', error);
            window.$alertError('Failed to detach invoice');
        }
    };

    getUnassignedParts = () => {
        if (!this.state.editingOrder) return [];
        return this.state.editingOrder.purchasedParts.filter(part => 
            !this.state.editingOrder.packingSlips?.some(slip => 
                slip.items?.some(item => item.partId === part.partId)
            )
        );
    };

    // New line-item focused invoice methods
    handleCreateLineItemInvoice = (purchaseOrderId) => {
        this.setState({
            createLineItemInvoiceDialogOpen: true,
            currentPurchaseOrderId: purchaseOrderId,
            newInvoiceNumber: '',
            newInvoiceFile: null,
            selectedLineItems: [],
            lastSelectedLineItemIndex: null,
            lineItemSelectionMode: 'create'
        });
    };

    handleAttachExistingLineItemInvoice = (purchaseOrderId) => {
        this.setState({
            attachExistingInvoiceToLineItemsDialogOpen: true,
            currentPurchaseOrderId: purchaseOrderId,
            invoiceToAttachToLineItems: '',
            selectedLineItems: [],
            lastSelectedLineItemIndex: null,
            lineItemSelectionMode: 'attach'
        });
    };

    handleLineItemSelection = (purchasedPartId, isSelected, event, currentOrder) => {
        const orderParts = currentOrder?.purchasedParts || [];
        const currentIndex = orderParts.findIndex(part => part.id === purchasedPartId);
        const isShiftPressed = !!(event?.shiftKey || event?.nativeEvent?.shiftKey);

        if (isShiftPressed && this.state.lastSelectedLineItemIndex !== null && currentIndex !== -1) {
            const startIndex = Math.min(this.state.lastSelectedLineItemIndex, currentIndex);
            const endIndex = Math.max(this.state.lastSelectedLineItemIndex, currentIndex);
            const rangeIds = orderParts.slice(startIndex, endIndex + 1).map(part => part.id);

            this.setState(prevState => {
                const anchorId = orderParts[this.state.lastSelectedLineItemIndex]?.id;
                const anchorIsSelected = anchorId ? prevState.selectedLineItems.includes(anchorId) : true;
                const allInRangeSelected = rangeIds.every(id => prevState.selectedLineItems.includes(id));
                const shouldDeselectRange = !anchorIsSelected || (isSelected && allInRangeSelected);

                return {
                    selectedLineItems: shouldDeselectRange
                        ? prevState.selectedLineItems.filter(id => !rangeIds.includes(id))
                        : [...new Set([...prevState.selectedLineItems, ...rangeIds])],
                    lastSelectedLineItemIndex: currentIndex
                };
            });
            return;
        }

        this.setState(prevState => {
            const selectedLineItems = isSelected
                ? [...new Set([...prevState.selectedLineItems, purchasedPartId])]
                : prevState.selectedLineItems.filter(id => id !== purchasedPartId);

            return {
                selectedLineItems,
                lastSelectedLineItemIndex: currentIndex !== -1 ? currentIndex : prevState.lastSelectedLineItemIndex
            };
        });
    };

    handleCloseCreateLineItemInvoice = () => {
        this.setState({
            createLineItemInvoiceDialogOpen: false,
            currentPurchaseOrderId: null,
            newInvoiceNumber: '',
            newInvoiceFile: null,
            selectedLineItems: [],
            lastSelectedLineItemIndex: null,
            lineItemSelectionMode: null
        });
    };

    handleCloseAttachExistingInvoiceToLineItems = () => {
        this.setState({
            attachExistingInvoiceToLineItemsDialogOpen: false,
            currentPurchaseOrderId: null,
            invoiceToAttachToLineItems: '',
            selectedLineItems: [],
            lastSelectedLineItemIndex: null,
            lineItemSelectionMode: null
        });
    };

    handleSaveCreateLineItemInvoice = async () => {
        if (!this.state.newInvoiceNumber.trim()) {
            window.$alertError('Invoice number is required');
            return;
        }

        if (this.state.selectedLineItems.length === 0) {
            window.$alertError('Please select at least one line item');
            return;
        }

        this.setState({savingInvoice: true});
        
        try {
            const partService = ServiceLocator.Instance.getPartService();
            const invoice = {
                id: uuid(),
                invoiceNumber: this.state.newInvoiceNumber,
                isPaid: false,
                userId: AuthenticationService.getInstance().getUserId()
            };

            const createdInvoice = await partService.createInvoice(invoice, this.state.newInvoiceFile);
            
            // Attach the invoice to each selected line item
            for (const purchasedPartId of this.state.selectedLineItems) {
                await partService.attachInvoiceToPurchasedPart(purchasedPartId, createdInvoice.id);
            }
            
            window.$alertSuccess('Invoice created and attached to selected line items successfully');
            this.handleCloseCreateLineItemInvoice();
            await this.loadData();
            await this.loadAllPurchasedPartInvoices();
            await this.refreshEditingOrder();
        } catch (error) {
            console.error('Error creating line item invoice:', error);
            window.$alertError('Failed to create invoice');
        } finally {
            this.setState({savingInvoice: false});
        }
    };

    handleSaveAttachExistingInvoiceToLineItems = async () => {
        if (!this.state.invoiceToAttachToLineItems) {
            window.$alertError('Please select an invoice to attach');
            return;
        }

        if (this.state.selectedLineItems.length === 0) {
            window.$alertError('Please select at least one line item');
            return;
        }

        this.setState({savingInvoice: true});
        
        try {
            const partService = ServiceLocator.Instance.getPartService();
            
            // Attach the invoice to each selected line item
            for (const purchasedPartId of this.state.selectedLineItems) {
                await partService.attachInvoiceToPurchasedPart(purchasedPartId, this.state.invoiceToAttachToLineItems);
            }
            
            window.$alertSuccess('Invoice attached to selected line items successfully');
            this.handleCloseAttachExistingInvoiceToLineItems();
            await this.loadData();
            await this.loadAllPurchasedPartInvoices();
            await this.refreshEditingOrder();
        } catch (error) {
            console.error('Error attaching invoice to line items:', error);
            window.$alertError('Failed to attach invoice');
        } finally {
            this.setState({savingInvoice: false});
        }
    };

    // Line-item invoice management methods
    loadInvoicesForPurchasedPart = async (purchasedPartId) => {
        try {
            // Check if we already have the data in our bulk cache
            if (this.state.purchasedPartInvoices && this.state.purchasedPartInvoices[purchasedPartId]) {
                return this.state.purchasedPartInvoices[purchasedPartId];
            }
            
            // If not in cache, load individually
            const partService = ServiceLocator.Instance.getPartService();
            const invoices = await partService.getInvoicesForPurchasedPart(purchasedPartId);
            
            // Update the cache
            this.setState(prevState => ({
                purchasedPartInvoices: {
                    ...prevState.purchasedPartInvoices,
                    [purchasedPartId]: invoices
                }
            }));
            
            return invoices;
        } catch (error) {
            console.error('Error loading invoices for purchased part:', error);
            return [];
        }
    };

    handleManageLineItemInvoices = async (purchasedPartId) => {
        this.setState({
            lineItemInvoiceDialogOpen: true,
            currentEditingPurchasedPartId: purchasedPartId
        });
        
        // Load invoices for this purchased part
        await this.loadInvoicesForPurchasedPart(purchasedPartId);
    };

    handleCloseLineItemInvoiceDialog = () => {
        this.setState({
            lineItemInvoiceDialogOpen: false,
            currentEditingPurchasedPartId: null
        });
    };

    handleAttachInvoiceToLineItem = (purchasedPartId) => {
        this.setState({
            attachLineItemInvoiceDialogOpen: true,
            currentEditingPurchasedPartId: purchasedPartId,
            invoiceToAttachToLineItem: ''
        });
    };

    handleCloseAttachInvoiceToLineItem = () => {
        this.setState({
            attachLineItemInvoiceDialogOpen: false,
            currentEditingPurchasedPartId: null,
            invoiceToAttachToLineItem: ''
        });
    };

    handleSaveAttachLineItemInvoice = async () => {
        if (!this.state.invoiceToAttachToLineItem || !this.state.currentEditingPurchasedPartId) {
            window.$alertError('Please select an invoice to attach');
            return;
        }

        this.setState({savingInvoice: true});
        
        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.attachInvoiceToPurchasedPart(
                this.state.currentEditingPurchasedPartId, 
                this.state.invoiceToAttachToLineItem
            );
            
            window.$alertSuccess('Invoice attached to line item successfully');
            this.handleCloseAttachInvoiceToLineItem();
            
            // Refresh the line item invoices
            await this.loadInvoicesForPurchasedPart(this.state.currentEditingPurchasedPartId);
            
            // Refresh main data to update paid status
            await this.loadData();
            await this.refreshEditingOrder();
            
            // Close the manage line item invoices drawer
            this.handleCloseLineItemInvoiceDialog();
        } catch (error) {
            console.error('Error attaching invoice to line item:', error);
            window.$alertError('Failed to attach invoice to line item');
        } finally {
            this.setState({savingInvoice: false});
        }
    };

    handleDetachInvoiceFromLineItem = async (purchasedPartId, invoiceId) => {
        if (!window.confirm('Are you sure you want to detach this invoice from the line item?')) {
            return;
        }

        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.detachInvoiceFromPurchasedPart(purchasedPartId, invoiceId);
            
            window.$alertSuccess('Invoice detached from line item successfully');
            
            // Refresh the line item invoices
            await this.loadInvoicesForPurchasedPart(purchasedPartId);
            
            // Refresh main data to update paid status
            await this.loadData();
            await this.refreshEditingOrder();
            
            // Close the manage line item invoices drawer
            this.handleCloseLineItemInvoiceDialog();
        } catch (error) {
            console.error('Error detaching invoice from line item:', error);
            window.$alertError('Failed to detach invoice from line item');
        }
    };

    getInvoicesForLineItem = (purchasedPartId) => {
        return this.state.purchasedPartInvoices[purchasedPartId] || [];
    };

    getLineItemPaidStatus = (purchasedPartId) => {
        const invoices = this.getInvoicesForLineItem(purchasedPartId);
        return invoices.some(attachment => attachment.invoice?.isPaid);
    };

    loadAllPurchasedPartInvoices = async () => {
        try {
            // Load all purchased part invoices in a single call
            const partService = ServiceLocator.Instance.getPartService();
            const allInvoices = await partService.getAllPurchasedPartInvoices();
            
            // Update the state with the loaded invoices
            this.setState({
                purchasedPartInvoices: allInvoices
            });
        } catch (error) {
            console.error('Error loading purchased part invoices:', error);
        }
    };

    // Sorting methods
    handleSort = (field) => {
        this.setState(prevState => ({
            sortField: field,
            sortDirection: prevState.sortField === field && prevState.sortDirection === 'asc' ? 'desc' : 'asc',
            page: 0
        }), () => {
            this.saveFilterSettings();
        });
    };

    handlePurchaseLogReceivingActionsSort = bindTableSortHandler(this, {
        fieldKey: 'purchaseLogReceivingActionsSortField',
        directionKey: 'purchaseLogReceivingActionsSortDirection',
    });

    getSortedPurchaseLogReceivingActions = () => {
        return sortCollection(
            this.state.purchaseLogReceivingActions,
            this.state.purchaseLogReceivingActionsSortField,
            this.state.purchaseLogReceivingActionsSortDirection,
            RECEIVING_ACTIONS_SORT_ACCESSORS
        );
    };

    getSortIcon = (field) => {
        if (this.state.sortField !== field) {
            return null;
        }
        return this.state.sortDirection === 'asc' ? 
            <FontAwesomeIcon icon={faChevronUp} size="1x" style={{marginLeft: '5px'}} /> : 
            <FontAwesomeIcon icon={faChevronDown} size="1x" style={{marginLeft: '5px'}} />;
    };

    comparePurchaseOrderNumbers = (purchaseOrderNumberA, purchaseOrderNumberB) => {
        const aNum = Number(purchaseOrderNumberA);
        const bNum = Number(purchaseOrderNumberB);
        if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) {
            return aNum - bNum;
        }
        return String(purchaseOrderNumberA || '').localeCompare(String(purchaseOrderNumberB || ''));
    };

    comparePurchaseOrderThenPartNumber = (lineItemA, lineItemB, partNumberA, partNumberB) => {
        const poCompare = this.comparePurchaseOrderNumbers(
            lineItemA.purchaseOrderNumber,
            lineItemB.purchaseOrderNumber
        );
        if (poCompare !== 0) {
            return poCompare;
        }
        return partNumberA.localeCompare(partNumberB);
    };

    isBlankVendorOrderNumber = (vendorOrderNumber) => !String(vendorOrderNumber || '').trim();

    isBlankVendorOrderNumber = (vendorOrderNumber) => !String(vendorOrderNumber || '').trim();

    escapeCsvCell = (value) => {
        const str = value == null ? '' : String(value);
        return `"${str.replace(/"/g, '""')}"`;
    };

    getPurchaseExportItemText = (part) => {
        if (!part) {
            return 'Unknown Part';
        }
        const description = part.description ? ` ${part.description}` : '';
        return `${part.partId} rev ${part.revision}${description}`;
    };

    getPurchaseExportCellValue = (purchaseLog, columnId, isInTransitView) => {
        const partExpanded = this.state.parts.find((x) => x.part.id === purchaseLog.partId);
        const part = partExpanded?.part;
        const purchaseOrder = this.state.purchaseOrders.find((po) => po.id === purchaseLog.purchaseOrderId);
        const lineItemInvoices = this.getInvoicesForLineItem(purchaseLog.id);
        const isPaid = lineItemInvoices.some((attachment) => attachment.invoice?.isPaid) || purchaseLog.isPaid;
        const onOrderQuantity = purchaseLog.onOrderQuantity || (purchaseLog.quantity - purchaseLog.quantityReceived);
        const transitShipmentDetails = isInTransitView
            ? this.getInTransitShipmentDetailsForPurchasedPart(purchaseLog.id, purchaseLog.purchaseOrderId, purchaseLog.partId)
            : null;

        switch (columnId) {
            case 'line':
                return `${purchaseLog.purchaseOrderNumber}-${purchaseLog.purchaseOrderLineNumber}`;
            case 'purchaseOrderNumber':
                return purchaseLog.purchaseOrderNumber ?? '';
            case 'orderDate':
                return purchaseLog.orderDate ? fromUtcForDisplay(purchaseLog.orderDate).format('YYYY-MM-DD') : '';
            case 'company':
                return purchaseLog.companyName || '';
            case 'vendorOrderNumber':
                return purchaseOrder?.vendorOrderNumber || '';
            case 'quantity':
                return purchaseLog.quantity ?? '';
            case 'item':
                return this.getPurchaseExportItemText(part);
            case 'unitCost':
                return purchaseLog.quantity
                    ? (purchaseLog.pricePaid / purchaseLog.quantity).toFixed(2)
                    : '0.00';
            case 'extended':
                return Number.parseFloat(purchaseLog.pricePaid || 0).toFixed(2);
            case 'quantityReceived':
                return purchaseLog.quantityReceived ?? '';
            case 'onOrder':
                return onOrderQuantity > 0 ? onOrderQuantity : '';
            case 'inTransit':
                return purchaseLog.inTransitQuantity > 0 ? purchaseLog.inTransitQuantity : '';
            case 'packingSlipBox':
                return transitShipmentDetails?.packingSlipBoxText || '-';
            case 'tracking':
                return transitShipmentDetails?.trackingText || '-';
            case 'eta':
                return purchaseLog.onOrderQuantity > 0 && purchaseLog.orderDate && part?.leadTimeInWeeks
                    ? fromUtcForDisplay(addDays(new Date(purchaseLog.orderDate), (part.leadTimeInWeeks * 7))).format('YYYY-MM-DD')
                    : '';
            case 'paid':
                return isPaid ? 'Yes' : 'No';
            case 'receivedDate':
                return purchaseLog.receivedDate ? new Date(purchaseLog.receivedDate).toISOString().split('T')[0] : '';
            default:
                return '';
        }
    };

    openExportDialog = () => {
        const isInTransitView = this.state.showOnlyInTransit;
        const columns = getPurchaseExportColumnDefinitions(isInTransitView);
        this.setState({
            exportDialogOpen: true,
            exportDialogInTransitView: isInTransitView,
            exportSelectedColumnIds: columns.map((column) => column.id),
        });
    };

    closeExportDialog = () => {
        this.setState({
            exportDialogOpen: false,
            exportSelectedColumnIds: [],
        });
    };

    toggleExportColumn = (columnId) => {
        this.setState((prevState) => {
            const isSelected = prevState.exportSelectedColumnIds.includes(columnId);
            return {
                exportSelectedColumnIds: isSelected
                    ? prevState.exportSelectedColumnIds.filter((id) => id !== columnId)
                    : [...prevState.exportSelectedColumnIds, columnId],
            };
        });
    };

    selectAllExportColumns = () => {
        const columns = getPurchaseExportColumnDefinitions(this.state.exportDialogInTransitView);
        this.setState({
            exportSelectedColumnIds: columns.map((column) => column.id),
        });
    };

    selectNoExportColumns = () => {
        this.setState({ exportSelectedColumnIds: [] });
    };

    exportPurchasesToCsv = () => {
        const { exportSelectedColumnIds, exportDialogInTransitView } = this.state;
        if (!exportSelectedColumnIds.length) {
            window.$alertWarning('Select at least one column to export.');
            return;
        }

        const lineItems = this.getMemoizedLineItems();
        if (!lineItems.length) {
            window.$alertWarning('No rows match the current filters to export.');
            return;
        }

        const allColumns = getPurchaseExportColumnDefinitions(exportDialogInTransitView);
        const selectedColumns = allColumns.filter((column) => exportSelectedColumnIds.includes(column.id));
        const csvRows = lineItems.map((purchaseLog) =>
            selectedColumns.map((column) => this.getPurchaseExportCellValue(purchaseLog, column.id, exportDialogInTransitView))
        );
        const csvContent = [
            selectedColumns.map((column) => column.label),
            ...csvRows,
        ]
            .map((row) => row.map((cell) => this.escapeCsvCell(cell)).join(','))
            .join('\n');

        const blob = new Blob([`\ufeff${csvContent}`], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        const dateStamp = format(new Date(), 'yyyy-MM-dd');
        const filePrefix = exportDialogInTransitView ? 'purchases_in_transit' : 'purchases';
        link.setAttribute('download', `${filePrefix}_${dateStamp}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        this.closeExportDialog();
    };

            sortLineItems = (lineItems) => {
            const { sortField, sortDirection } = this.state;
            
            return [...lineItems].sort((a, b) => {
                let aValue, bValue;
                
                // Get part numbers for secondary/tertiary sorting
                const partA = this.state.parts.find(x => x.part.id === a.partId);
                const partB = this.state.parts.find(x => x.part.id === b.partId);
                const aPartNumber = partA?.part.partId || '';
                const bPartNumber = partB?.part.partId || '';
                
                // Primary sort values
                if (sortField === 'item') {
                    aValue = aPartNumber;
                    bValue = bPartNumber;
                } else if (sortField === 'purchaseOrderNumber') {
                    aValue = a.purchaseOrderNumber || 0;
                    bValue = b.purchaseOrderNumber || 0;
                } else if (sortField === 'orderDate') {
                    aValue = new Date(a.orderDate);
                    bValue = new Date(b.orderDate);
                } else if (sortField === 'company') {
                    aValue = a.companyName || '';
                    bValue = b.companyName || '';
                } else if (sortField === 'vendorOrderNumber') {
                    const poA = this.state.purchaseOrders.find(po => po.id === a.purchaseOrderId);
                    const poB = this.state.purchaseOrders.find(po => po.id === b.purchaseOrderId);
                    aValue = poA?.vendorOrderNumber || '';
                    bValue = poB?.vendorOrderNumber || '';
                } else if (sortField === 'eta') {
                    const partAForEta = this.state.parts.find(x => x.part.id === a.partId);
                    const partBForEta = this.state.parts.find(x => x.part.id === b.partId);
                    const etaA = a.orderDate && partAForEta?.part.leadTimeInWeeks ? 
                        addDays(new Date(a.orderDate), (partAForEta.part.leadTimeInWeeks * 7)) : null;
                    const etaB = b.orderDate && partBForEta?.part.leadTimeInWeeks ? 
                        addDays(new Date(b.orderDate), (partBForEta.part.leadTimeInWeeks * 7)) : null;
                    aValue = etaA;
                    bValue = etaB;
                } else if (sortField === 'receivedDate') {
                    aValue = a.receivedDate ? new Date(a.receivedDate) : null;
                    bValue = b.receivedDate ? new Date(b.receivedDate) : null;
                } else if (sortField === 'inTransit') {
                    aValue = a.inTransitQuantity || 0;
                    bValue = b.inTransitQuantity || 0;
                } else {
                    // Default to purchase order number
                    aValue = a.purchaseOrderNumber || 0;
                    bValue = b.purchaseOrderNumber || 0;
                }
                
                // Handle null values - null values should be treated as "no data" and sorted to the end
                if (aValue === null && bValue === null) {
                    return this.comparePurchaseOrderThenPartNumber(a, b, aPartNumber, bPartNumber);
                }
                if (aValue === null) {
                    return 1; // null values go to the end
                }
                if (bValue === null) {
                    return -1; // null values go to the end
                }

                if (sortField === 'vendorOrderNumber') {
                    const aBlank = this.isBlankVendorOrderNumber(aValue);
                    const bBlank = this.isBlankVendorOrderNumber(bValue);
                    if (aBlank && bBlank) {
                        return this.comparePurchaseOrderThenPartNumber(a, b, aPartNumber, bPartNumber);
                    }
                    if (aBlank) {
                        return 1;
                    }
                    if (bBlank) {
                        return -1;
                    }
                }
                
                // Primary sort comparison
                let primaryComparison = 0;
                if (typeof aValue === 'string' && typeof bValue === 'string') {
                    primaryComparison = aValue.localeCompare(bValue);
                    primaryComparison = sortDirection === 'asc' ? primaryComparison : -primaryComparison;
                } else {
                    if (aValue < bValue) {
                        primaryComparison = sortDirection === 'asc' ? -1 : 1;
                    } else if (aValue > bValue) {
                        primaryComparison = sortDirection === 'asc' ? 1 : -1;
                    }
                }
                
                // If primary values are equal, use secondary sort (PO #), then tertiary sort (Part Number)
                if (primaryComparison === 0) {
                    return this.comparePurchaseOrderThenPartNumber(a, b, aPartNumber, bPartNumber);
                }
                
                return primaryComparison;
            });
        };

    renderReceiveDrawer = () => {
        if (!this.state.selectedPackingSlip) return null;

        return (
            <DrawerMenuRight
                open={this.state.receiveDrawerOpen}
                onClose={this.closeReceiveDrawer}
                title="Receive Packing Slip"
                subtitle={`${this.state.selectedPackingSlip.name || 'Unnamed'} - ${this.state.selectedPackingSlip.vendorName}`}
            >
                <div style={{padding: '20px'}}>
                    <div style={{marginBottom: '20px'}}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleReceiveAll}
                            className="success-button-lg"
                            disabled={this.state.receivingPackingSlip}
                            style={{width: '100%', marginBottom: '12px'}}
                        >
                            Receive All Expected
                        </Button>
                    </div>
                    
                    <Typography variant="h6" style={{marginBottom: '16px'}}>
                        Or adjust quantities:
                    </Typography>
                    
                    {this.state.selectedPackingSlip.items?.sort((a, b) => {
                        const partA = this.state.parts.find(p => p.part.id === a.purchasedPart?.partId);
                        const partB = this.state.parts.find(p => p.part.id === b.purchasedPart?.partId);
                        const partIdA = partA ? partA.part.partId : 'Unknown Part';
                        const partIdB = partB ? partB.part.partId : 'Unknown Part';
                        return partIdA.localeCompare(partIdB);
                    }).map((item) => (
                        <div key={item.id} style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '12px 0',
                            borderBottom: '1px solid #eee'
                        }}>
                            <div style={{flex: 1, marginRight: '12px'}}>
                                <div style={{fontSize: '14px', fontWeight: 'bold'}}>
                                    {(() => {
                                        const part = this.state.parts.find(p => p.part.id === item.purchasedPart?.partId);
                                        return part ? part.part.partId : 'Unknown Part';
                                    })()}
                                </div>
                                <div style={{fontSize: '12px', color: '#666'}}>
                                    Expected: {item.quantityExpected}
                                </div>
                            </div>
                            <TextField
                                type="number"
                                value={this.state.receivedQuantities[item.id] || ''}
                                onChange={(e) => this.handleQuantityChange(item.id, e.target.value)}
                                inputProps={{min: 0}}
                                variant="outlined"
                                size="small"
                                style={{width: '80px'}}
                                autoComplete="off"
                            />
                        </div>
                    ))}
                    
                    <div style={{marginTop: '20px', display: 'flex', gap: '12px'}}>
                        <Button
                            onClick={this.closeReceiveDrawer}
                            variant="outlined"
                            style={{flex: 1}}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={this.handleReceiveCustom}
                            variant="contained"
                            color="primary"
                            disabled={this.state.receivingPackingSlip}
                            style={{flex: 1}}
                        >
                            {this.state.receivingPackingSlip ? <CircularProgress size={20} /> : 'Receive'}
                        </Button>
                    </div>
                </div>
            </DrawerMenuRight>
        );
    };

    render() {
        const self = this;
        if (this.state.loading) {
            return (
                <DashboardTemplate title="Purchases" onSyncDatabase={this.loadData}>
                    <div className="main-dashboard-root">
                        <CircularProgress/>
                    </div>
                </DashboardTemplate>
            );
        }

        // Use memoized calculations for better performance
        const sortedLineItems = this.getMemoizedLineItems();

        // Paginate the sorted line items
        const paginatedLineItems = sortedLineItems.slice(
            this.state.page * this.state.rowsPerPage,
            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
        );
        const isInTransitView = this.state.showOnlyInTransit;

        return (
            <DashboardTemplate title="Purchases" onSyncDatabase={this.loadData}>
                <div className="main-dashboard-root">
                    <div className="container">
                        <div style={{position: 'relative', display: 'flex', alignItems: 'center', width: '100%', marginBottom: '20px'}}>
                            {/* Left: Search Bar */}
                            <div style={{flex: '1', display: 'flex', justifyContent: 'flex-start'}}>
                                <TextField
                                    value={this.state.searchTerm}
                                    onChange={this.searchPurchases}
                                    label="Search by PN, PO #, Vendor Order #, Company, or User..."
                                    variant="outlined"
                                    style={{width: 460}}
                                    autoComplete="off"
                                    inputRef={ref => this.searchInputRef = ref}
                                />
                            </div>
                            
                            {/* Center: Buttons - Absolutely centered */}
                            <div style={{position: 'absolute', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '10px'}}>
                                <Button 
                                    variant="contained"
                                    color="primary"
                                    onClick={this.openAddPurchaseLog} 
                                    className="success-button-lg"
                                >
                                    New Purchase
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={this.openExportDialog}
                                    className="success-button-lg"
                                    style={{ backgroundColor: 'white' }}
                                >
                                    Export
                                </Button>
                            </div>
                            
                            {/* Right: Filter toggles and multi-select actions */}
                            <div style={{flex: '1', display: 'flex', justifyContent: 'flex-end', gap: '10px', alignItems: 'center'}}>
                                <div 
                                    className={this.props.classes.filterToggle}
                                    onClick={() => this.setState(prevState => ({ 
                                        showOnlyOutstanding: !prevState.showOnlyOutstanding,
                                        page: 0
                                    }))}
                                >
                                    <Checkbox
                                        checked={this.state.showOnlyOutstanding}
                                        onChange={() => {}}
                                        size="small"
                                    />
                                    <span className={this.props.classes.filterLabel}>
                                        Show Only Outstanding
                                    </span>
                                </div>
                                <div 
                                    className={this.props.classes.filterToggle}
                                    onClick={() => this.setState(prevState => ({ 
                                        showOnlyUnpaid: !prevState.showOnlyUnpaid,
                                        page: 0
                                    }))}
                                >
                                    <Checkbox
                                        checked={this.state.showOnlyUnpaid}
                                        onChange={() => {}}
                                        size="small"
                                    />
                                    <span className={this.props.classes.filterLabel}>
                                        Show Only Unpaid
                                    </span>
                                </div>
                                <div 
                                    className={this.props.classes.filterToggle}
                                    onClick={() => this.setState(prevState => ({ 
                                        showOnlyInTransit: !prevState.showOnlyInTransit,
                                        page: 0
                                    }), () => {
                                        if (this.state.showOnlyInTransit) {
                                            this.loadInTransitPackingSlips();
                                        }
                                    })}
                                >
                                    <Checkbox
                                        checked={this.state.showOnlyInTransit}
                                        onChange={() => {}}
                                        size="small"
                                    />
                                    <span className={this.props.classes.filterLabel}>
                                        Show Only In Transit
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                        {/* Color Legend */}
                        <div style={{
                            margin: '5px 0',
                            padding: '0'
                        }}>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <div style={{
                                        width: '20px',
                                        height: '20px',
                                        backgroundColor: '#929292',
                                        border: '1px solid #ccc'
                                    }}></div>
                                    <span style={{ fontSize: '14px' }}>Fully received and paid</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <div style={{
                                        width: '20px',
                                        height: '20px',
                                        backgroundColor: '#e8f5e8',
                                        border: '1px solid #ccc'
                                    }}></div>
                                    <span style={{ fontSize: '14px' }}>Fully received, not paid</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <div style={{
                                        width: '20px',
                                        height: '20px',
                                        backgroundColor: '#fff3c1',
                                        border: '1px solid #ccc'
                                    }}></div>
                                    <span style={{ fontSize: '14px' }}>Partially received, not paid</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <div style={{
                                        width: '20px',
                                        height: '20px',
                                        backgroundColor: '#ffd2c1',
                                        border: '1px solid #ccc'
                                    }}></div>
                                    <span style={{ fontSize: '14px' }}>Not fully received and paid</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <div style={{
                                        width: '20px',
                                        height: '20px',
                                        backgroundColor: '#d7ffff',
                                        border: '1px solid #ccc'
                                    }}></div>
                                    <span style={{ fontSize: '14px' }}>Nothing received, items in transit</span>
                                </div>
                            </div>
                        </div>
                        
                        <center>
                            <TablePagination
                                rowsPerPageOptions={[50, 100, 200, 500]}
                                colSpan={4}
                                count={sortedLineItems.length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                slotProps={{
                                    select: {
                                        'aria-label': 'rows per page',
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                        slots: {
                                            firstPageIcon: FirstPageIcon,
                                            lastPageIcon: LastPageIcon,
                                            nextPageIcon: ChevronRightIcon,
                                            backPageIcon: ChevronLeftIcon,
                                        },
                                    },
                                }}
                                onPageChange={this.handleChangePage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                            />
                        </center>
                        <div className="parts-table-container">
                            <table className="parts-table">
                                <thead>
                                <tr>
                                    <th style={{minWidth: 40}}>
                                        <Checkbox
                                            checked={this.state.selectedPurchasedParts.length === paginatedLineItems.length && paginatedLineItems.length > 0}
                                            indeterminate={this.state.selectedPurchasedParts.length > 0 && this.state.selectedPurchasedParts.length < paginatedLineItems.length}
                                            onChange={this.handleSelectAllPurchasedParts}
                                        />
                                    </th>
                                    <th style={{minWidth: 70}}>Edit</th>
                                    <th 
                                        className={this.props.classes.sortableHeader}
                                        style={{minWidth: 100}}
                                        onClick={() => this.handleSort('purchaseOrderNumber')}
                                    >
                                        PO # {this.getSortIcon('purchaseOrderNumber')}
                                    </th>
                                    <th 
                                        className={this.props.classes.sortableHeader}
                                        style={{minWidth: 130}}
                                        onClick={() => this.handleSort('orderDate')}
                                    >
                                        Order Date {this.getSortIcon('orderDate')}
                                    </th>
                                    <th 
                                        className={this.props.classes.sortableHeader}
                                        style={{minWidth: 150}}
                                        onClick={() => this.handleSort('company')}
                                    >
                                        Company {this.getSortIcon('company')}
                                    </th>
                                    <th 
                                        className={this.props.classes.sortableHeader}
                                        style={{minWidth: 120}}
                                        onClick={() => this.handleSort('vendorOrderNumber')}
                                    >
                                        Vendor Order # {this.getSortIcon('vendorOrderNumber')}
                                    </th>
                                    <th style={{minWidth: 65}}>Quantity</th>
                                    <th 
                                        className={this.props.classes.sortableHeader}
                                        style={{minWidth: 350}}
                                        onClick={() => this.handleSort('item')}
                                    >
                                        Item {this.getSortIcon('item')}
                                    </th>
                                    {!isInTransitView && <th style={{minWidth: 65}}>Unit Cost</th>}
                                    {!isInTransitView && <th style={{minWidth: 65}}>Extended</th>}
                                    <th style={{minWidth: 80}}>Received</th>
                                    <th style={{minWidth: 80}}>On Order</th>
                                    <th 
                                        className={this.props.classes.sortableHeader}
                                        style={{minWidth: 80}}
                                        onClick={() => this.handleSort('inTransit')}
                                    >
                                        In Transit {this.getSortIcon('inTransit')}
                                    </th>
                                    {isInTransitView ? (
                                        <>
                                            <th style={{minWidth: 220}}>Packing Slip - Box #</th>
                                            <th style={{minWidth: 160}}>Tracking</th>
                                        </>
                                    ) : (
                                        <>
                                            <th style={{minWidth: 80}}>ETA</th>
                                            <th style={{minWidth: 50}}>Paid</th>
                                            <th style={{minWidth: 85}}>Received Date</th>
                                        </>
                                    )}
                                </tr>
                                </thead>
                                <tbody>
                                {paginatedLineItems.map((purchaseLog) => {
                                    const partExpanded = this.state.parts.find(x => x.part.id === purchaseLog.partId);
                                    const part = partExpanded?.part;
                                    const transitShipmentDetails = isInTransitView
                                        ? this.getInTransitShipmentDetailsForPurchasedPart(purchaseLog.id, purchaseLog.purchaseOrderId, purchaseLog.partId)
                                        : null;
                                    
                                    // Calculate row background color based on "On Order" and "isPaid" status
                                    const onOrderQuantity = purchaseLog.onOrderQuantity || (purchaseLog.quantity - purchaseLog.quantityReceived);
                                    const lineItemInvoices = this.getInvoicesForLineItem(purchaseLog.id);
                                    const isPaid = lineItemInvoices.some(attachment => attachment.invoice?.isPaid) || purchaseLog.isPaid;
                                    
                                    let rowBackgroundColor = 'inherit';
                                    if (purchaseLog.quantityReceived >= purchaseLog.quantity && isPaid) {
                                        // Grey: Fully received and paid
                                        rowBackgroundColor = '#929292';
                                    } else if (purchaseLog.quantityReceived >= purchaseLog.quantity && !isPaid) {
                                        // Green: Fully received and not paid
                                        rowBackgroundColor = '#e8f5e8';
                                    } else if (purchaseLog.quantityReceived > 0 && !isPaid) {
                                        // Yellow: Partially received and not paid
                                        rowBackgroundColor = '#fff3c1';
                                    } else if (isPaid && onOrderQuantity > 0) {
                                        // Red: Partially received and paid
                                        rowBackgroundColor = '#ffd2c1';
                                    } else if (purchaseLog.quantityReceived === 0 && (purchaseLog.inTransitQuantity || 0) > 0) {
                                        // Light cyan: Nothing received but items in transit
                                        rowBackgroundColor = '#d7ffff';
                                    }

                                    return (
                                        <tr key={purchaseLog.id} style={{backgroundColor: rowBackgroundColor}}>
                                            <td
                                                onClick={(e) => {
                                                    const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                    const isShiftPressed = e.shiftKey;
                                                    
                                                    if (isCtrlPressed || isShiftPressed) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                            e.nativeEvent.stopImmediatePropagation();
                                                        }
                                                        const syntheticEvent = {
                                                            ctrlKey: isCtrlPressed,
                                                            metaKey: e.metaKey,
                                                            shiftKey: isShiftPressed,
                                                            preventDefault: () => {},
                                                            stopPropagation: () => {},
                                                            target: { checked: !this.state.selectedPurchasedParts.includes(purchaseLog.id) },
                                                            nativeEvent: e.nativeEvent
                                                        };
                                                        this.handleSelectPurchasedPart(purchaseLog.id, syntheticEvent);
                                                    }
                                                }}
                                                onMouseDown={(e) => {
                                                    const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                    const isShiftPressed = e.shiftKey;
                                                    
                                                    if (isCtrlPressed || isShiftPressed) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                            e.nativeEvent.stopImmediatePropagation();
                                                        }
                                                    }
                                                }}
                                                style={{cursor: 'pointer'}}
                                            >
                                                <span
                                                    onClick={(e) => {
                                                        const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                        const isShiftPressed = e.shiftKey;
                                                        
                                                        if (isCtrlPressed || isShiftPressed) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                e.nativeEvent.stopImmediatePropagation();
                                                            }
                                                        }
                                                    }}
                                                    style={{display: 'inline-block'}}
                                                >
                                                    <Checkbox
                                                        checked={this.state.selectedPurchasedParts.includes(purchaseLog.id)}
                                                        onChange={(e) => {
                                                            if (this.state.isProcessingModifierClick) {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                return;
                                                            }
                                                            
                                                            const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                            const isShiftPressed = e.shiftKey;
                                                        
                                                            if (isCtrlPressed || isShiftPressed) {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                return;
                                                            }
                                                        
                                                            this.handleSelectPurchasedPart(purchaseLog.id, e);
                                                        }}
                                                        onClick={(e) => {
                                                            const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                            const isShiftPressed = e.shiftKey;
                                                        
                                                            if (isCtrlPressed || isShiftPressed) {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                    e.nativeEvent.stopImmediatePropagation();
                                                                }
                                                                return false;
                                                            }
                                                        }}
                                                        style={{padding: 2}}
                                                    />
                                                </span>
                                            </td>
                                            <td>
                                                <span
                                                    style={{
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        cursor: 'pointer',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                    onClick={() => {
                                                        this.editLog(purchaseLog, purchaseLog.purchaseOrderId);
                                                    }}
                                                >
                                                    {purchaseLog.purchaseOrderNumber}-{purchaseLog.purchaseOrderLineNumber}
                                                </span>
                                            </td>
                                            <td>
                                                <span style={{
                                                    fontWeight: 'bold',
                                                    color: 'black',
                                                    cursor: 'pointer'
                                                }}
                                                    onClick={(event) => {
                                                        const po = this.state.purchaseOrders.find(x => x.id === purchaseLog.purchaseOrderId);
                                                        this.editPurchaseOrder(po, purchaseLog.purchaseOrderId, event.ctrlKey);
                                                    }}>
                                                    {purchaseLog.purchaseOrderNumber}
                                                </span>
                                            </td>
                                            <td>{purchaseLog.orderDate ? fromUtcForDisplay(purchaseLog.orderDate).format('YYYY-MM-DD') : ''}</td>
                                            <td>{purchaseLog.companyName}</td>
                                            <td>
                                                {(() => {
                                                    const purchaseOrder = this.state.purchaseOrders.find(po => po.id === purchaseLog.purchaseOrderId);
                                                    return purchaseOrder?.vendorOrderNumber || '';
                                                })()}
                                            </td>
                                            <td>{purchaseLog.quantity}</td>
                                            <td className="text-left">
                                                {this.state.permissions.includes('EditAssembliesAndParts') && part ? (
                                                    <div style={{cursor: 'pointer'}} onClick={(event) => this.editPart(partExpanded, event.ctrlKey)}>
                                                        <PartDisplay 
                                                            part={part}
                                                            variant="table"
                                                            classes={this.props.classes}
                                                        />
                                                    </div>
                                                ) : part ? (
                                                    <PartDisplay 
                                                        part={part}
                                                        variant="table"
                                                        classes={this.props.classes}
                                                    />
                                                ) : (
                                                    <span>Unknown Part</span>
                                                )}
                                            </td>
                                            {!isInTransitView && <td>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                    <span>${(purchaseLog.pricePaid / purchaseLog.quantity).toFixed(2) || '0.00'}</span>
                                                    {partExpanded?.costType === 0 && (
                                                        <FontAwesomeIcon 
                                                            icon={faInfoCircle} 
                                                            style={{ cursor: 'help' }}
                                                            title={this.getTieredPricingTooltip(partExpanded)}
                                                        />
                                                    )}
                                                </div>
                                            </td>}
                                            {!isInTransitView && <td>${Number.parseFloat(purchaseLog.pricePaid).toFixed(2)}</td>}
                                            <td>{purchaseLog.quantityReceived}</td>
                                            <td>{purchaseLog.onOrderQuantity > 0 ? purchaseLog.onOrderQuantity : ''}</td>
                                            <td>{purchaseLog.inTransitQuantity > 0 ? purchaseLog.inTransitQuantity : ''}</td>
                                            {isInTransitView ? (
                                                <>
                                                    <td>{transitShipmentDetails?.packingSlipBoxText || '-'}</td>
                                                    <td>{transitShipmentDetails?.trackingText || '-'}</td>
                                                </>
                                            ) : (
                                                <>
                                            <td>{purchaseLog.onOrderQuantity > 0 && purchaseLog.orderDate && part?.leadTimeInWeeks ? fromUtcForDisplay(addDays(new Date(purchaseLog.orderDate), (part.leadTimeInWeeks * 7))).format('YYYY-MM-DD') : ''}</td>
                                            <td>
                                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                    {(() => {
                                                        // Check if this line item has any invoices attached and if any are paid
                                                        const lineItemInvoices = this.getInvoicesForLineItem(purchaseLog.id);
                                                        const hasPaidInvoice = lineItemInvoices.filter(attachment => attachment.invoice?.isPaid).length > 0;
                                                        
                                                        return (
                                                            <>
                                                                {/* Show checkmark if line item is paid */}
                                                                {(hasPaidInvoice || isPaid) && (
                                                                    <FontAwesomeIcon
                                                                        icon={faCheck}
                                                                        style={{ 
                                                                            color: '#4caf50',
                                                                            fontSize: '14px',
                                                                            cursor: lineItemInvoices.length > 0 ? 'pointer' : 'default',
                                                                            border: '1px solid #fff',
                                                                            background: '#fff',
                                                                            padding: '1px',
                                                                            borderRadius: '100%'
                                                                        }}
                                                                        title={lineItemInvoices.length > 0 ? 
                                                                            `Invoice: ${lineItemInvoices.map(att => att.invoice?.invoiceNumber).join(', ')}` : 
                                                                            'This line item is paid'
                                                                        }
                                                                        onClick={() => {
                                                                            if (lineItemInvoices.length > 0) {
                                                                                if (lineItemInvoices.length === 1) {
                                                                                    // Single invoice, download it directly
                                                                                    const invoice = lineItemInvoices[0].invoice;
                                                                                    if (invoice?.fileUrl) {
                                                                                        this.download(invoice.fileUrl, invoice.fileName || invoice.invoiceNumber || `invoice_${invoice.id}`);
                                                                                    }
                                                                                } else {
                                                                                    // Multiple invoices, download the first paid one or open management dialog
                                                                                    const firstPaidInvoice = lineItemInvoices.find(att => att.invoice?.isPaid)?.invoice;
                                                                                    if (firstPaidInvoice?.fileUrl) {
                                                                                        this.download(firstPaidInvoice.fileUrl, firstPaidInvoice.fileName || firstPaidInvoice.invoiceNumber || `invoice_${firstPaidInvoice.id}`);
                                                                                    } else {
                                                                                        // No paid invoice found, open management dialog
                                                                                        this.handleManageLineItemInvoices(purchaseLog.id);
                                                                                    }
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            </>
                                                        );
                                                    })()}
                                                </div>
                                            </td>
                                            <td>{purchaseLog.receivedDate ? new Date(purchaseLog.receivedDate).toISOString().split('T')[0] : ''}</td>
                                                </>
                                            )}
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>
                        <center>
                            <TablePagination
                                rowsPerPageOptions={[50, 100, 200, 500]}
                                colSpan={4}
                                count={sortedLineItems.length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                slotProps={{
                                    select: {
                                        'aria-label': 'rows per page',
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                        slots: {
                                            firstPageIcon: FirstPageIcon,
                                            lastPageIcon: LastPageIcon,
                                            nextPageIcon: ChevronRightIcon,
                                            backPageIcon: ChevronLeftIcon,
                                        },
                                    },
                                }}
                                onPageChange={this.handleChangePage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                            />
                        </center>
                    </div>
                </div>



                {this.state.addingPurchaseLogOpen && (
                    <DrawerMenuRight title={"New Purchase"} customWidth={1300}
                                     open={this.state.addingPurchaseLogOpen}
                                     onClose={this.handleCloseNewPurchaseLog}
                                     hasUnsavedChanges={
                                         this.state.newLogParts.length > 0 ||
                                         this.state.newVendorOrderNumber !== ''
                                     }
                                     onSubmit={this.submitPurchaseOrder}
                                     submitConfirmMessage="Are you sure you want to submit this purchase order?"
                                     >
                        <div style={{marginBottom: 20, width: '22%', display: 'inline-block'}}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    label="Order Date"
                                    value={this.state.newPurchaseOrderDate}
                                    onChange={(newValue) => this.setState({newPurchaseOrderDate: newValue})}
                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        <div style={{marginBottom: 20, width: '24%', display: 'inline-block'}}>
                            <TextField
                                label="Vendor Order Number (Optional)"
                                value={this.state.newVendorOrderNumber}
                                onChange={(event) => this.setState({newVendorOrderNumber: event.target.value})}
                                variant="outlined"
                                style={{width: '100%'}}
                                inputProps={{maxLength: 200}}
                                autoComplete="off"
                            />
                        </div>
                        <div className="parts-table-container">
                            <table className="parts-table">
                                <thead>
                                    <tr>
                                        <th style={{minWidth: 300}}>PN + Description</th>
                                        <th style={{minWidth: 80}}>Qty</th>
                                        <th style={{minWidth: 90}}>Vendor</th>
                                        <th style={{minWidth: 120}}>Price</th>
                                        <th style={{minWidth: 90}}>Total</th>
                                        <th style={{minWidth: 80}}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.newLogParts.map((row, index) => {
                                        if (row.isFamilyRow) {
                                            return (
                                                <tr key={row.id}>
                                                    <td>
                                                        {row.selectedOption && !row.isModifying ? (
                                                            <div style={{cursor: 'pointer'}} onClick={() => this.handlePartDisplayClick(index)}>
                                                                <PartDisplay 
                                                                    part={{
                                                                        partId: row.selectedOption.family?.partFamilyId || 'Unknown Family',
                                                                        revision: '',
                                                                        description: row.selectedOption.family?.description || row.description
                                                                    }}
                                                                    variant="table"
                                                                    classes={this.props.classes}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <Autocomplete autoHighlight
                                                                options={this.state.partsOptions}
                                                                getOptionLabel={(option) => {
                                                                    if (option.family) {
                                                                        return option.family.partFamilyId;
                                                                    } else if (option.part) {
                                                                        return `${option.part.partId} rev ${option.part.revision}`;
                                                                    }
                                                                    return option.title || '';
                                                                }}
                                                                value={row.selectedOption}
                                                                onChange={(event, newValue) => {
                                                                    // Check if the new value is a family or an individual part
                                                                    if (newValue && newValue.isFamily) {
                                                                        // If changing from an existing family, remove old child parts first
                                                                        const currentRow = this.state.newLogParts[index];
                                                                        if (currentRow.familyId && currentRow.isFamilyRow) {
                                                                            const oldFamilyId = currentRow.familyId;
                                                                            const updatedRows = this.state.newLogParts.filter((row, i) => 
                                                                                i === index || row.familyId !== oldFamilyId
                                                                            );
                                                                            this.setState({ newLogParts: updatedRows }, () => {
                                                                                // Now call handleFamilyChange with the cleaned state
                                                                                this.handleFamilyChange(event, newValue, index);
                                                                                setTimeout(() => {
                                                                                    const updatedRows2 = [...this.state.newLogParts];
                                                                                    updatedRows2[index].isModifying = false;
                                                                                    this.setState({ newLogParts: updatedRows2 });
                                                                                }, 0);
                                                                            });
                                                                        } else {
                                                                            // It's a family, use handleFamilyChange
                                                                            this.handleFamilyChange(event, newValue, index);
                                                                            // handleFamilyChange already updates the state, just need to set isModifying to false
                                                                            setTimeout(() => {
                                                                                const updatedRows = [...this.state.newLogParts];
                                                                                updatedRows[index].isModifying = false;
                                                                                this.setState({ newLogParts: updatedRows });
                                                                            }, 0);
                                                                        }
                                                                    } else if (newValue && newValue.part) {
                                                                        // It's an individual part, remove child parts and convert to part row
                                                                        let updatedRows = [...this.state.newLogParts];
                                                                        const currentRow = updatedRows[index];
                                                                        
                                                                        if (currentRow.familyId) {
                                                                            const familyId = currentRow.familyId;
                                                                            // Remove all rows that belong to this family (except the row we're modifying)
                                                                            updatedRows = updatedRows.filter((row, i) => 
                                                                                i === index || row.familyId !== familyId
                                                                            );
                                                                        }
                                                                        
                                                                        // Find the row again after filtering
                                                                        const rowIndex = updatedRows.findIndex(r => r.id === currentRow.id);
                                                                        
                                                                        if (rowIndex !== -1) {
                                                                            const row = updatedRows[rowIndex];
                                                                            row.selectedOption = newValue;
                                                                            row.isModifying = false;
                                                                            row.isFamilyRow = false;
                                                                            row.familyId = null;
                                                                            row.partId = newValue.part.id;
                                                                            
                                                                            // Set vendor and pricing information
                                                                            const purchasingPart = this.state.parts.find(x => x.part.id === newValue.part.id);
                                                                            if (purchasingPart) {
                                                                                let vendors = [];
                purchasingPart.part.vendorParts.forEach((vendorPart) => {
                    const vendor = this.state.vendors.find(x => x.id === vendorPart.vendorId);
                    if (vendor && vendors.indexOf(vendor) < 0) vendors.push(vendor);
                });
                                                                                row.vendors = vendors;
                                                                                row.vendorsList = vendors.map((vendor) => vendor.name);
                                                                                
                                                                                // Set vendorParts for dropdown
                                                                                row.vendorParts = purchasingPart.part.vendorParts;
                                                                                
                                                                                // Calculate initial pricing based on part cost and quantity
                                                                                const partExpanded = this.state.parts.find(x => x.part.id === newValue.part.id);
                                                                                if (partExpanded) {
                                                                                    const unitCost = partExpanded.cost || 0.00;
                                                                                    let quantity = row.quantity || 1;
                                                                                    
                                                                                    // Set initial vendor information
                                                                                    const selectedVendorId = purchasingPart.part.selectedVendorId;
                                                                                    const vendorPart = purchasingPart.part.vendorParts.find(x => x.vendorId === selectedVendorId) || purchasingPart.part.vendorParts[0];
                                                                                    if (vendorPart) {
                                                                                        row.vendorId = vendorPart.vendorId;
                                                                                        const vendor = this.state.vendors.find(x => x.id === vendorPart.vendorId);
                                                                                        if (vendor) {
                                                                                            row.vendor = vendor.name;
                                                                                            row.companyName = vendor.name;
                                                                                        }
                                                                                        
                                                                                        // Calculate price based on vendor pricing if available
                                                                                        if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas && vendorPart.tieredCostFormulas.length > 0) {
                                                                                            // Use selected tiered cost formula for default quantity and unit price
                                                                                            const selectedTier = vendorPart.tieredCostFormulas.find(t => t.isSelected);
                                                                                            const tier = selectedTier || [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity)[0];
                                                                                            quantity = tier.quantity || 1;
                                                                                            row.quantity = quantity;
                                                                                            row.partQuantity = quantity;
                                                                                            row.price = normalizeUnitCost(tier.price);
                                                                                            row.total = calculateLineTotal(row.price, quantity);
                                                                                            row.pricePaid = row.total.toFixed(2);
                                                                                        } else if (vendorPart.costType === 1) {
                                                                                            // Use fixed pricing
                                                                                            quantity = vendorPart.quantity || quantity;
                                                                                            row.quantity = quantity;
                                                                                            row.partQuantity = quantity;
                                                                                            const unitPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
                                                                                            row.price = unitPrice;
                                                                                            row.total = calculateLineTotal(unitPrice, quantity);
                                                                                            row.pricePaid = row.total.toFixed(2);
                                                                                        }
                                                                                    } else {
                                                                                        // No vendor part found, use part cost
                                                                                        row.price = normalizeUnitCost(unitCost);
                                                                                        row.total = calculateLineTotal(row.price, quantity);
                                                                                        row.pricePaid = row.total.toFixed(2);
                                                                                    }
                                                                                } else {
                                                                                    // No partExpanded found, set default values
                                                                                    row.price = 0;
                                                                                    row.pricePaid = '0.00';
                                                                                    row.total = 0;
                                                                                }
                                                                            }
                                                                        }
                                                                        
                                                                        this.setState({ newLogParts: updatedRows }, () => {
                                                                            // After state update for individual part, focus the quantity field
                                                                            setTimeout(() => {
                                                                                const allQuantityInputs = document.querySelectorAll(`input[data-field-type="part-quantity"]`);
                                                                                if (allQuantityInputs.length > 0) {
                                                                                    let quantityInput = document.querySelector(`input[data-row-index="${rowIndex}"][data-field-type="part-quantity"]`);
                                                                                    if (!quantityInput && allQuantityInputs.length > rowIndex) {
                                                                                        quantityInput = allQuantityInputs[rowIndex];
                                                                                    }
                                                                                    if (quantityInput) {
                                                                                        quantityInput.focus();
                                                                                        quantityInput.select();
                                                                                    }
                                                                                }
                                                                            }, 150);
                                                                        });
                                                                    }
                                                                }}
                                                                renderOption={(option) => <PartAutocompleteOption option={option} classes={this.props.classes} />}
                                                                renderInput={(params) => <TextField {...params} variant="outlined" 
                                                                    inputProps={{ 
                                                                        ...params.inputProps,
                                                                        tabIndex: index * 4 + 1,
                                                                        'data-row-index': index,
                                                                        'data-field-type': 'part-number'
                                                                    }}
                                                                    onKeyDown={(event) => {
                                                                        if (event.key === 'Enter') {
                                                                            // Focus the family quantity field when Enter is pressed
                                                                            setTimeout(() => {
                                                                                const quantityInput = document.querySelector(`input[data-row-index="${index}"][data-field-type="family-quantity"]`);
                                                                                if (quantityInput) {
                                                                                    quantityInput.focus();
                                                                                    quantityInput.select();
                                                                                }
                                                                            }, 100);
                                                                        }
                                                                    }}
                                                                />}
                                                            />
                                                        )}
                                                    </td>
                                                    <td>
                                                        <TextField
                                                            type="number"
                                                            value={getNumberInputDisplayValue(row.familyQuantity)}
                                                            onChange={(event) => this.handleFamilyQuantityChange(event, index)}
                                                            variant="outlined"
                                                            style={{width: '75%'}}
                                                            inputProps={{ 
                                                                tabIndex: index * 4 + 2,
                                                                'data-row-index': index,
                                                                'data-field-type': 'family-quantity'
                                                            }}
                                            onKeyDown={(event) => this.handleQuantityKeyDown(event, index)}
                                                            autoComplete="off"
                                                        />
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>
                                                        <FontAwesomeIcon
                                                            icon={faTrash}
                                                            style={{ cursor: 'pointer', color: 'black' }}
                                                            onClick={() => this.removeLine(index)}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        } else {
                                            const partExpanded = this.state.parts.find(x => x.part.id === (row.selectedOption?.part?.id || row.partId));
                                            return (
                                                <tr key={row.id} style={{backgroundColor: row.isFamilyPart ? '#f5f5f5' : 'inherit'}}>
                                                    <td>
                                                        {row.selectedOption && !row.isModifying ? (
                                                            <div style={{cursor: 'pointer'}} onClick={() => this.handlePartDisplayClick(index)}>
                                                                <PartDisplay 
                                                                    part={row.selectedOption?.part || partExpanded?.part || {
                                                                        partId: 'Unknown Part',
                                                                        revision: '',
                                                                        description: ''
                                                                    }}
                                                                    variant="table"
                                                                    classes={this.props.classes}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <Autocomplete autoHighlight
                                                                options={this.state.partsOptions}
                                                                getOptionLabel={(option) => option.title || ''}
                                                                value={row.selectedOption}
                                                                onChange={(event, newValue) => {
                                                                    
                                                                    // Check if the new value is a family or an individual part
                                                                    if (newValue && newValue.isFamily) {
                                                                        // Converting to a family, use handleFamilyChange
                                                                        this.handleFamilyChange(event, newValue, index);
                                                                        setTimeout(() => {
                                                                            const updatedRows = [...this.state.newLogParts];
                                                                            updatedRows[index].isModifying = false;
                                                                            this.setState({ newLogParts: updatedRows });
                                                                        }, 0);
                                                                    } else if (newValue && newValue.part) {
                                                                        // It's an individual part
                                                                        let updatedRows = [...this.state.newLogParts];
                                                                        const currentRow = updatedRows[index];
                                                                        
                                                                        // If this row had child parts (was a family), remove them
                                                                        if (currentRow.familyId) {
                                                                            const familyId = currentRow.familyId;
                                                                            updatedRows = updatedRows.filter((row, i) => 
                                                                                i === index || row.familyId !== familyId
                                                                            );
                                                                        }
                                                                        
                                                                        // Find the row again after filtering
                                                                        const rowIndex = updatedRows.findIndex(r => r.id === currentRow.id);
                                                                        
                                                                        if (rowIndex !== -1) {
                                                                            const row = updatedRows[rowIndex];
                                                                            row.selectedOption = newValue;
                                                                            row.isModifying = false;
                                                                            row.isFamilyRow = false;
                                                                            row.familyId = null;
                                                                            row.partId = newValue.part.id;
                                                                            
                                                                            // Set vendor and pricing information
                                                                            const purchasingPart = this.state.parts.find(x => x.part.id === newValue.part.id);
                                                                            if (purchasingPart) {
                                                                                let vendors = [];
                purchasingPart.part.vendorParts.forEach((vendorPart) => {
                    const vendor = this.state.vendors.find(x => x.id === vendorPart.vendorId);
                    if (vendor && vendors.indexOf(vendor) < 0) vendors.push(vendor);
                });
                                                                                row.vendors = vendors;
                                                                                row.vendorsList = vendors.map((vendor) => vendor.name);
                                                                                
                                                                                // Set vendorParts for dropdown
                                                                                row.vendorParts = purchasingPart.part.vendorParts;
                                                                                
                                                                                // Calculate initial pricing based on part cost and quantity
                                                                                const partExpanded = this.state.parts.find(x => x.part.id === newValue.part.id);
                                                                                if (partExpanded) {
                                                                                    const unitCost = partExpanded.cost || 0.00;
                                                                                    let quantity = row.quantity || 1;
                                                                                    
                                                                                    // Set initial vendor information
                                                                                    const selectedVendorId = purchasingPart.part.selectedVendorId;
                                                                                    const vendorPart = purchasingPart.part.vendorParts.find(x => x.vendorId === selectedVendorId) || purchasingPart.part.vendorParts[0];
                                                                                    if (vendorPart) {
                                                                                        row.vendorId = vendorPart.vendorId;
                                                                                        const vendor = this.state.vendors.find(x => x.id === vendorPart.vendorId);
                                                                                        if (vendor) {
                                                                                            row.vendor = vendor.name;
                                                                                            row.companyName = vendor.name;
                                                                                        }
                                                                                        
                                                                                        // Calculate price based on vendor pricing if available
                                                                                        if (vendorPart.costType === 0 && vendorPart.tieredCostFormulas && vendorPart.tieredCostFormulas.length > 0) {
                                                                                            // Use selected tiered cost formula for default quantity and unit price
                                                                                            const selectedTier = vendorPart.tieredCostFormulas.find(t => t.isSelected);
                                                                                            const tier = selectedTier || [...vendorPart.tieredCostFormulas].sort((a, b) => a.quantity - b.quantity)[0];
                                                                                            quantity = tier.quantity || 1;
                                                                                            row.quantity = quantity;
                                                                                            row.partQuantity = quantity;
                                                                                            row.price = normalizeUnitCost(tier.price);
                                                                                            row.total = calculateLineTotal(row.price, quantity);
                                                                                            row.pricePaid = row.total.toFixed(2);
                                                                                        } else if (vendorPart.costType === 1) {
                                                                                            // Use fixed pricing
                                                                                            quantity = vendorPart.quantity || quantity;
                                                                                            row.quantity = quantity;
                                                                                            row.partQuantity = quantity;
                                                                                            const unitPrice = normalizeUnitCost(vendorPart.basePrice / vendorPart.quantity);
                                                                                            row.price = unitPrice;
                                                                                            row.total = calculateLineTotal(unitPrice, quantity);
                                                                                            row.pricePaid = row.total.toFixed(2);
                                                                                        }
                                                                                    } else {
                                                                                        // No vendor part found, use part cost
                                                                                        row.price = normalizeUnitCost(unitCost);
                                                                                        row.total = calculateLineTotal(row.price, quantity);
                                                                                        row.pricePaid = row.total.toFixed(2);
                                                                                    }
                                                                                } else {
                                                                                    // No partExpanded found, set default values
                                                                                    row.price = 0;
                                                                                    row.pricePaid = '0.00';
                                                                                    row.total = 0;
                                                                                }
                                                                            }
                                                                        }
                                                                        
                                                                        this.setState({ newLogParts: updatedRows }, () => {
                                                                            // After state update, focus the quantity field for the updated row
                                                                            setTimeout(() => {
                                                                                const allQuantityInputs = document.querySelectorAll(`input[data-field-type="part-quantity"]`);
                                                                                if (allQuantityInputs.length > 0) {
                                                                                    let quantityInput = document.querySelector(`input[data-row-index="${rowIndex}"][data-field-type="part-quantity"]`);
                                                                                    if (!quantityInput && allQuantityInputs.length > rowIndex) {
                                                                                        quantityInput = allQuantityInputs[rowIndex];
                                                                                    }
                                                                                    if (quantityInput) {
                                                                                        quantityInput.focus();
                                                                                        quantityInput.select();
                                                                                    }
                                                                                }
                                                                            }, 150);
                                                                        });
                                                                    }
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        variant="outlined"
                                                                        placeholder="Select Part"
                                                                    />
                                                                )}
                                                                renderOption={(option) => (
                                                                    <PartAutocompleteOption
                                                                        option={option}
                                                                        variant="part"
                                                                    />
                                                                )}
                                                            />
                                                        )}
                                                    </td>
                                                    <td>
                                                        <TextField
                                                            type="number"
                                                            value={getNumberInputDisplayValue(row.partQuantity)}
                                                            onChange={(event) => this.handlePartQuantityChange(event, index)}
                                                            variant="outlined"
                                                            style={{width: '75%'}}
                                                                                                        inputProps={{ 
                                                tabIndex: index * 4 + 2,
                                                'data-row-index': index,
                                                'data-field-type': 'part-quantity'
                                            }}
                                            onKeyDown={(event) => this.handleQuantityKeyDown(event, index)}
                                                            autoComplete="off"
                                                        />
                                                    </td>
                                                    <td>
                                                        {row.vendorParts && row.vendorParts.length > 0 ? (
                                                            <FormControl variant="outlined" style={{minWidth: 150}}>
                                                                <Select
                                                                    value={row.vendorId || ''}
                                                                    onChange={(event) => this.handleVendorChange(event, index)}
                                                                                                                        inputProps={{ 
                                                        tabIndex: -1,
                                                        'data-row-index': index,
                                                        'data-field-type': 'vendor'
                                                    }}
                                                                >
                                                                    {row.vendorParts.map((vendorPart) => {
                                                                        const vendor = this.state.vendors.find(x => x.id === vendorPart.vendorId);
                                                                        return (
                                                                            <MenuItem key={vendorPart.vendorId} value={vendorPart.vendorId}>
                                                                                {vendor?.name || `Unknown Vendor`}
                                                                            </MenuItem>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            </FormControl>
                                                        ) : (
                                                            row.vendor || ''
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                            <TextField
                                                                type="number"
                                                                value={getNumberInputDisplayValue(row.price)}
                                                                onChange={(event) => this.handlePartPriceChange(event, index)}
                                                                variant="outlined"
                                                                style={{width: '75%'}}
                                                                InputProps={{
                                                                    startAdornment: <span style={{marginRight: 8}}>$</span>
                                                                }}
                                                                inputProps={{ 
                                                                    tabIndex: -1,
                                                                    'data-row-index': index,
                                                                    'data-field-type': 'price'
                                                                }}
                                                                autoComplete="off"
                                                            />
                                                            {row.vendorParts?.find(vp => vp.vendorId === row.vendorId)?.costType === 0 && (
                                                                <FontAwesomeIcon 
                                                                    icon={faInfoCircle} 
                                                                    style={{ cursor: 'help' }}
                                                                    title={this.getTieredPricingTooltip(row.vendorParts.find(vp => vp.vendorId === row.vendorId))}
                                                                />
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>${(row.total || 0).toFixed(2)}</td>
                                                    <td>
                                                        <FontAwesomeIcon
                                                            icon={faTrash}
                                                            style={{ cursor: 'pointer', color: 'black' }}
                                                            onClick={() => this.removeLine(index)}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    })}
                                    <tr style={{backgroundColor: '#f0f0f0', fontWeight: 'bold'}}>
                                        <td colSpan={5} style={{textAlign: 'right'}}>Total:</td>
                                        <td>
                                            ${this.state.newLogParts
                                                .filter(row => !row.isFamilyRow)
                                                .reduce((sum, row) => sum + (row.total || 0), 0)
                                                .toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <center>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.addNewLine}
                                className="success-button-lg"
                                style={{margin: '20px 0'}}
                            >
                                Add Line
                            </Button>
                            <br/>
                            {this.state.savingPurchaseLog ?
                                <CircularProgress/>
                                :
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.submitPurchaseOrder}
                                    className="success-button-lg"
                                >
                                    Submit Purchase Orders
                                </Button>
                            }
                        </center>
                    </DrawerMenuRight>
                )}

                {this.state.editLogOpen && (
                    <DrawerMenuRight title={"Edit Purchase Log"} customWidth={1000}
                                     open={this.state.editLogOpen}
                                     onClose={this.handleCloseEditLog}
                                     hasUnsavedChanges={this.hasEditLogUnsavedChanges()}
                                     onSubmit={this.updatePurchaseLog}
                                     submitConfirmMessage="Are you sure you want to save these changes?"
                                     >
                        {/* Part Selection */}
                        <div style={{marginBottom: 20, width: '49%', display: 'inline-block'}}>
                            <Autocomplete
                                autoHighlight
                                options={this.state.partsOptionsForEdit}
                                getOptionLabel={(option) => {
                                    if (option.part) {
                                        return `${option.part.partId} rev ${option.part.revision}`;
                                    }
                                    return option.title || '';
                                }}
                                value={this.state.partsOptionsForEdit.find(option => option.value === editingLog.partId) || null}
                                onChange={(event, newValue) => this.handleEditLogPartChange(event, newValue)}
                                renderOption={(option) => <PartAutocompleteOption option={option} classes={this.props.classes} />}
                                renderInput={(params) => <TextField {...params} label="Part" variant="outlined" />}
                            />
                        </div>
                        
                        {/* Company Name Selection */}
                        <div style={{marginBottom: 20, marginLeft: 10, width: '49%', display: 'inline-block'}}>
                            <Autocomplete
                                autoHighlight
                                options={editingLog.vendorParts ? editingLog.vendorParts.map(vendorPart => {
                                    const vendor = this.state.vendors.find(x => x.id === vendorPart.vendorId);
                                    return vendor;
                                }).filter(vendor => vendor) : []}
                                getOptionLabel={(option) => option.name || ''}
                                value={editingLog.vendorParts ? editingLog.vendorParts.map(vendorPart => {
                                    const vendor = this.state.vendors.find(x => x.id === vendorPart.vendorId);
                                    return vendor;
                                }).filter(vendor => vendor).find(vendor => vendor.name === editingLog.companyName) : null}
                                onChange={(event, newValue) => {
                                    editingLog.companyName = newValue ? newValue.name : '';
                                    this.forceUpdate();
                                }}
                                renderInput={(params) => <TextField {...params} label="Vendor" variant="outlined" />}
                            />
                        </div>
                        
                        <div style={{marginBottom: 20, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    label="Order Date"
                                    value={dayjs(editingLog.orderDate)}
                                    onChange={(newValue) => {
                                        editingLog.orderDate = newValue;
                                        this.forceUpdate();
                                    }}
                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                                />
                                <TextField value={editingLog.quantity || ''} label={"Quantity Ordered"}
                                           onChange={this.editQuantity}
                                           variant="outlined" type="number"
                                           style={{marginLeft: 10}}
                                           autoComplete="off"/>
                            </MuiPickersUtilsProvider>
                        </div>
                        <div style={{margin: '10px auto 20px'}}>
                            <TextField value={editingLog.unitCost || editingLog.pricePaid / editingLog.quantity}
                                    onChange={this.editUnitCost}
                                    label={"Unit Cost"}
                                    variant="outlined" type="number"
                                    style={{width: '49%', marginRight: 5}}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">$</InputAdornment>
                                    }}
                                    autoComplete="off"/>
                            <TextField value={editingLog.pricePaid}
                                        onChange={this.editLogPricePaid}
                                        label={"Total Price Paid"}
                                        variant="outlined" type="number"
                                        style={{width: '49%', marginLeft: 5}}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">$</InputAdornment>
                                        }}
                                        autoComplete="off"/>
                        </div>
                        <div style={{marginBottom: 15}}>
                            <Checkbox onClick={this.editIsPaid}
                                      checked={editingLog.isPaid}/> Is Paid
                            <Checkbox onClick={this.editIsReceived}
                                      checked={editingLog.quantityReceived >= editingLog.quantity}
                                      style={{marginLeft: 20}}/> Is Received
                        </div>

                        {/* Activity History Section */}
                        <div style={{marginTop: 15, marginBottom: 20}}>
                            <Typography variant="h6" style={{marginBottom: 15}}>
                                Activity History
                            </Typography>
                            
                            {/* Invoice History */}
                            <Typography variant="subtitle1" style={{marginBottom: 10, fontWeight: 'bold'}}>
                                📄 Invoices
                            </Typography>
                            {(() => {
                                const invoices = this.getInvoicesForLineItem(editingLog.id);
                                
                                if (invoices.length === 0) {
                                    return (
                                        <Typography variant="body2" style={{fontStyle: 'italic', color: '#666', marginBottom: 20}}>
                                            No invoices attached to this line item.
                                        </Typography>
                                    );
                                }
                                
                                return (
                                    <div className="parts-table-container" style={{marginBottom: 20}}>
                                        <table className="parts-table">
                                            <thead>
                                                <tr>
                                                    <th>Invoice Number</th>
                                                    <th>Date Attached</th>
                                                    <th>Status</th>
                                                    <th>File</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {invoices.map((attachment) => (
                                                    <tr key={attachment.id}>
                                                        <td>
                                                            {attachment.invoice?.id ? (
                                                                <span 
                                                                    style={{
                                                                        color: '#1976d2',
                                                                        cursor: 'pointer',
                                                                        textDecoration: 'underline'
                                                                    }}
                                                                    onClick={(e) => {
                                                                        if (e.ctrlKey || e.metaKey) {
                                                                            window.open(`/admin/invoices/${attachment.invoice.id}`, '_blank');
                                                                        } else {
                                                                            globalProps.history.push(`/admin/invoices/${attachment.invoice.id}`);
                                                                        }
                                                                    }}
                                                                >
                                                                    {attachment.invoice.invoiceNumber || 'N/A'}
                                                                </span>
                                                            ) : (
                                                                attachment.invoice?.invoiceNumber || 'N/A'
                                                            )}
                                                        </td>
                                                        <td>
                                                            {formatUtcForDisplay(attachment.dateAttached)}
                                                        </td>
                                                        <td>
                                                            <span style={{
                                                                color: attachment.invoice?.isPaid ? '#4caf50' : '#f44336',
                                                                fontWeight: 'bold'
                                                            }}>
                                                                {attachment.invoice?.isPaid ? 'Paid' : 'Unpaid'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {attachment.invoice?.fileUrl ? (
                                                                <Button 
                                                                    size="small" 
                                                                    onClick={() => this.download(attachment.invoice.fileUrl, attachment.invoice.fileName)}
                                                                >
                                                                    View
                                                                </Button>
                                                            ) : 'No file'}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                );
                            })()}

                            {/* Packing Slips */}
                            <Typography variant="subtitle1" style={{marginBottom: 10, fontWeight: 'bold'}}>
                                📦 Packing Slips
                            </Typography>
                            {(() => {
                                const packingSlipItems = this.getPackingSlipsForPurchasedPart(editingLog.id);
                                const allPackingSlips = this.state.editingOrder?.packingSlips || [];
                                
                                if (packingSlipItems.length === 0) {
                                    return (
                                        <Typography variant="body2" style={{fontStyle: 'italic', color: '#666', marginBottom: 20}}>
                                            No packing slips assigned to this purchase log.
                                        </Typography>
                                    );
                                }
                                
                                return (
                                    <div className="parts-table-container" style={{marginBottom: 20}}>
                                        <table className="parts-table">
                                            <thead>
                                                <tr>
                                                    <th>Packing Slip</th>
                                                    <th>Status</th>
                                                    <th>Qty on Slip</th>
                                                    <th>Qty Received</th>
                                                    <th>In Transit</th>
                                                    <th>Date Received</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {packingSlipItems.map((item) => {
                                                    const slip = item.packingSlip;
                                                    const qtyOnSlip = item.quantityExpected || 0;
                                                    const qtyReceived = item.quantityReceived || 0;
                                                    const inTransit = Math.max(0, qtyOnSlip - qtyReceived);
                                                    const isFullyReceived = qtyReceived >= qtyOnSlip;
                                                    const attachedFile = getPackingSlipAttachedFile(slip, allPackingSlips);
                                                    const slipFileUrl = attachedFile.url;
                                                    const slipFileName = attachedFile.name || slip.name || 'packing-slip-file';
                                                    
                                                    return (
                                                        <tr key={slip.id + '-' + item.id}>
                                                            <td>
                                                                <span 
                                                                    style={{
                                                                        color: '#1976d2',
                                                                        cursor: 'pointer',
                                                                        textDecoration: 'underline'
                                                                    }}
                                                                    onClick={(e) => navigateToPackingSlipBoxEditor(globalProps.history, slip.id, e)}
                                                                >
                                                                    {slip.name || `Slip ${slip.id?.substring(0, 8)}`}
                                                                </span>
                                                                {slipFileUrl ? (
                                                                    <span
                                                                        title={`Download ${slipFileName}`}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            this.download(slipFileUrl, slipFileName);
                                                                        }}
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            color: '#1976d2',
                                                                            marginLeft: 8,
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            padding: '2px 4px'
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faDownload} />
                                                                    </span>
                                                                ) : null}
                                                            </td>
                                                            <td>
                                                                <span style={{
                                                                    color: isFullyReceived ? '#4caf50' : '#ff9800',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    {isFullyReceived ? '✓ Received' : '🚚 In Transit'}
                                                                </span>
                                                            </td>
                                                            <td>{qtyOnSlip}</td>
                                                            <td>{qtyReceived}</td>
                                                            <td>
                                                                <span style={{
                                                                    fontWeight: inTransit > 0 ? 'bold' : 'normal'
                                                                }}>
                                                                    {inTransit}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {slip.receivedDate ? 
                                                                    formatUtcForDisplay(slip.receivedDate) : 
                                                                    (slip.dateReceived ? formatUtcForDisplay(slip.dateReceived) : '-')}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                );
                            })()}

                            {/* Receiving Actions */}
                            <Typography variant="subtitle1" style={{marginBottom: 10, fontWeight: 'bold'}}>
                                Receiving Actions 📦
                            </Typography>
                            {(() => {
                                if (this.state.loadingReceivingActions) {
                                    return (
                                        <div style={{textAlign: 'center', padding: '20px'}}>
                                            <CircularProgress size={24} />
                                            <Typography variant="body2" style={{marginTop: 10, color: '#666'}}>
                                                Loading receiving actions...
                                            </Typography>
                                        </div>
                                    );
                                }
                                
                                const receivingActions = this.getSortedPurchaseLogReceivingActions();
                                
                                if (receivingActions.length === 0) {
                                    return (
                                        <Typography variant="body2" style={{fontStyle: 'italic', color: '#666', marginBottom: 20}}>
                                            No receiving actions found for this line item.
                                        </Typography>
                                    );
                                }
                                
                                return (
                                    <div className="parts-table-container" style={{marginBottom: 20}}>
                                        <table className="parts-table purchase-log-receiving-actions-table">
                                            <colgroup>
                                                <col style={{width: '18%'}} />
                                                <col style={{width: '12%'}} />
                                                <col style={{width: '27%'}} />
                                                <col style={{width: '15%'}} />
                                                <col style={{width: '17%'}} />
                                                <col style={{width: '7%'}} />
                                                <col style={{width: '7%'}} />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <SortableTableHeader field="receivedDate" sortField={this.state.purchaseLogReceivingActionsSortField} sortDirection={this.state.purchaseLogReceivingActionsSortDirection} onSort={this.handlePurchaseLogReceivingActionsSort} style={{whiteSpace: 'nowrap'}}>Date</SortableTableHeader>
                                                    <SortableTableHeader field="quantityReceived" sortField={this.state.purchaseLogReceivingActionsSortField} sortDirection={this.state.purchaseLogReceivingActionsSortDirection} onSort={this.handlePurchaseLogReceivingActionsSort} style={{whiteSpace: 'nowrap'}}>Quantity Received</SortableTableHeader>
                                                    <SortableTableHeader field="packingSlip" sortField={this.state.purchaseLogReceivingActionsSortField} sortDirection={this.state.purchaseLogReceivingActionsSortDirection} onSort={this.handlePurchaseLogReceivingActionsSort} style={{whiteSpace: 'nowrap'}}>Packing Slip</SortableTableHeader>
                                                    <SortableTableHeader field="userName" sortField={this.state.purchaseLogReceivingActionsSortField} sortDirection={this.state.purchaseLogReceivingActionsSortDirection} onSort={this.handlePurchaseLogReceivingActionsSort} style={{whiteSpace: 'nowrap'}}>Received By</SortableTableHeader>
                                                    <SortableTableHeader field="notes" sortField={this.state.purchaseLogReceivingActionsSortField} sortDirection={this.state.purchaseLogReceivingActionsSortDirection} onSort={this.handlePurchaseLogReceivingActionsSort} style={{whiteSpace: 'nowrap'}}>Notes</SortableTableHeader>
                                                    <th style={{whiteSpace: 'nowrap'}}>File</th>
                                                    <th style={{whiteSpace: 'nowrap'}}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {receivingActions.map((action) => {
                                                    const isEditing = this.state.editingReceivingActionId === action.id;
                                                    return (
                                                    <tr key={action.id}>
                                                        <td>
                                                            {action.receivedDate ? formatUtcForDisplay(action.receivedDate) : 
                                                             action.dateCreated ? formatUtcForDisplay(action.dateCreated) : '-'}
                                                        </td>
                                                        <td>
                                                            {isEditing ? (
                                                                <TextField
                                                                    type="number"
                                                                    value={getNumberInputDisplayValue(this.state.editingReceivingAction.quantityReceived)}
                                                                    onChange={(e) => this.handleEditingReceivingActionChange('quantityReceived', e.target.value)}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    inputProps={{ min: 1 }}
                                                                />
                                                            ) : (
                                                                action.quantityReceived || 0
                                                            )}
                                                        </td>
                                                        <td>
                                                            {action.packingSlip ? (
                                                                action.packingSlip.name
                                                            ) : '-'}
                                                        </td>
                                                        <td>{action.userName || '-'}</td>
                                                        <td>
                                                            {isEditing ? (
                                                                <TextField
                                                                    value={this.state.editingReceivingAction.notes || ''}
                                                                    onChange={(e) => this.handleEditingReceivingActionChange('notes', e.target.value)}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    placeholder="Notes"
                                                                />
                                                            ) : (
                                                                action.notes || '-'
                                                            )}
                                                        </td>
                                                        <td>
                                                            {action.packingSlip?.fileUrl ? (
                                                                <Button 
                                                                    size="small" 
                                                                    onClick={() => this.download(action.packingSlip.fileUrl, action.packingSlip.fileName)}
                                                                >
                                                                    View
                                                                </Button>
                                                            ) : '-'}
                                                        </td>
                                                        <td>
                                                            {isEditing ? (
                                                                <div style={{display: 'flex', gap: '2px'}}>
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => this.handleSaveReceivingAction(action.id)}
                                                                        title="Save"
                                                                        style={{padding: 4}}
                                                                    >
                                                                        <FontAwesomeIcon icon={faCheck} />
                                                                    </IconButton>
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={this.handleCancelEditReceivingAction}
                                                                        title="Cancel"
                                                                        style={{padding: 4}}
                                                                    >
                                                                        <FontAwesomeIcon icon={faTimes} />
                                                                    </IconButton>
                                                                </div>
                                                            ) : (
                                                                <div style={{display: 'flex', gap: '2px'}}>
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => this.handleEditReceivingAction(action)}
                                                                        title="Edit receiving action"
                                                                        style={{padding: 4}}
                                                                    >
                                                                        <FontAwesomeIcon icon={faPencilAlt} />
                                                                    </IconButton>
                                                                    <IconButton
                                                                        size="small"
                                                                        color="secondary"
                                                                        onClick={() => this.handleDeleteReceivingAction(action)}
                                                                        title={this.isDirectReceiveAction(action) ? 'Delete direct receive' : 'Delete receiving action'}
                                                                        style={{padding: 4}}
                                                                    >
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </IconButton>
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                );
                            })()}
                        </div>
                        <center>
                            {this.state.savingPurchaseLog === true ?
                                <CircularProgress/>
                                :
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.updatePurchaseLog}
                                    className="success-button-lg"
                                    style={{width: 150, display: 'inline-block'}}
                                >
                                    Save
                                </Button>
                            }
                            {this.state.savingPurchaseLog !== true && editingLog.id !== '' ?
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.deletePurchaseLog}
                                    className="delete-button-lg"
                                    style={{margin: '0 0 0 10px'}}
                                >
                                    Delete
                                </Button>
                                : ""}
                        </center>
                    </DrawerMenuRight>
                )}

                {/* Create Invoice Dialog */}
                {this.state.createInvoiceDialogOpen && (
                    <DrawerMenuRight title={"Create New Invoice"} customWidth={1100}
                                     open={this.state.createInvoiceDialogOpen}
                                     onClose={this.handleCloseCreateInvoice}>
                        <TextField
                            label="Invoice Number"
                            fullWidth
                            variant="outlined"
                            value={this.state.newInvoiceNumber}
                            onChange={(e) => this.setState({newInvoiceNumber: e.target.value})}
                            style={{marginBottom: 20}}
                            autoComplete="off"
                        />
                        
                        <Typography variant="subtitle1" style={{marginBottom: 10}}>Invoice File (Optional)</Typography>
                        <FilePond
                            files={this.state.newInvoiceFile ? [this.state.newInvoiceFile] : []}
                            allowMultiple={false}
                            maxFiles={1}
                            acceptedFileTypes={['application/pdf', 'image/*']}
                            maxFileSize="10MB"
                            onupdatefiles={(files) => {
                                this.setState({
                                    newInvoiceFile: files.length > 0 ? files[0].file : null
                                });
                            }}
                            labelIdle='Drag & Drop your invoice file or <span class="filepond--label-action">Browse</span>'
                        />
                        
                        <div style={{marginTop: 30, display: 'flex', gap: '10px'}}>
                            {this.state.savingInvoice ? (
                                <CircularProgress />
                            ) : (
                                <Button 
                                    onClick={this.handleSaveNewInvoice} 
                                    className="success-button-lg" style={{width: 140}}
                                    disabled={this.state.savingInvoice}
                                >
                                    CREATE & ATTACH
                                </Button>
                            )}
                        </div>
                    </DrawerMenuRight>
                )}

                {/* Attach Existing Invoice Dialog */}
                {this.state.attachInvoiceDialogOpen && (
                    <DrawerMenuRight title={"Attach Existing Invoice"} customWidth={1100}
                                     open={this.state.attachInvoiceDialogOpen}
                                     onClose={this.handleCloseAttachInvoice}>
                        <FormControl fullWidth variant="outlined" style={{marginBottom: 20}}>
                            <InputLabel>Select Invoice</InputLabel>
                            <Select
                                value={this.state.invoiceToAttach}
                                onChange={(e) => this.setState({invoiceToAttach: e.target.value})}
                                label="Select Invoice"
                            >
                                {this.state.allInvoices.map((invoice) => (
                                    <MenuItem key={invoice.id} value={invoice.id}>
                                        {invoice.invoiceNumber} - {invoice.isPaid ? 'Paid' : 'Unpaid'} 
                                        {invoice.fileName && ` (${invoice.fileName})`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        
                        <div style={{marginTop: 30, display: 'flex', gap: '10px'}}>
                            {this.state.savingInvoice ? (
                                <CircularProgress />
                            ) : (
                                <Button 
                                    onClick={this.handleSaveAttachInvoice} 
                                    className="success-button-lg" style={{width: 75}}
                                    disabled={this.state.savingInvoice}
                                >
                                    ATTACH
                                </Button>
                            )}
                        </div>
                    </DrawerMenuRight>
                )}

                {/* Export Dialog */}
                <Dialog
                    open={this.state.exportDialogOpen}
                    onClose={this.closeExportDialog}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>Export Purchases</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                            Exports {this.getMemoizedLineItems().length} row(s) using your current filters and sort order.
                        </Typography>
                        <div style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
                            <Button size="small" variant="outlined" onClick={this.selectAllExportColumns}>
                                Select All
                            </Button>
                            <Button size="small" variant="outlined" onClick={this.selectNoExportColumns}>
                                Select None
                            </Button>
                        </div>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr',
                            gap: 4,
                        }}>
                            {getPurchaseExportColumnDefinitions(this.state.exportDialogInTransitView).map((column) => (
                                <FormControlLabel
                                    key={column.id}
                                    control={(
                                        <Checkbox
                                            checked={this.state.exportSelectedColumnIds.includes(column.id)}
                                            onChange={() => this.toggleExportColumn(column.id)}
                                            color="primary"
                                        />
                                    )}
                                    label={column.label}
                                />
                            ))}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeExportDialog}>
                            Cancel
                        </Button>
                        <Button
                            onClick={this.exportPurchasesToCsv}
                            color="primary"
                            variant="contained"
                            disabled={!this.state.exportSelectedColumnIds.length}
                        >
                            Export CSV
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Copy Table Dialog */}
                <Dialog 
                    open={this.state.showCopyTable} 
                    onClose={this.closeCopyTable}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>
                        Copy Tables for Email
                    </DialogTitle>
                    <DialogContent style={{textAlign: 'center'}}>
                        {Object.entries(this.state.copyTablesByVendor).map(([vendor, tableData], vendorIndex) => (
                            <div key={vendor} style={{marginBottom: vendorIndex < Object.keys(this.state.copyTablesByVendor).length - 1 ? '30px' : '0px'}}>
                                <h3 style={{
                                    margin: '0 0 10px 0',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    color: '#333'
                                }}>
                                    {vendor}
                                </h3>
                                <table style={{
                                    width: '100%',
                                    maxWidth: '300px',
                                    margin: '10px auto',
                                    borderCollapse: 'collapse',
                                    border: '1px solid black',
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '12px'
                                }}>
                                    <thead>
                                        <tr>
                                            <th style={{
                                                border: '1px solid black',
                                                padding: '8px',
                                                backgroundColor: '#f0f0f0',
                                                textAlign: 'center'
                                            }}>
                                                Quantity
                                            </th>
                                            <th style={{
                                                border: '1px solid black',
                                                padding: '8px',
                                                backgroundColor: '#f0f0f0',
                                                textAlign: 'center'
                                            }}>
                                                Item
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableData.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{
                                                    border: '1px solid black',
                                                    padding: '8px',
                                                    textAlign: 'center'
                                                }}>
                                                    {item.quantity}
                                                </td>
                                                <td style={{
                                                    border: '1px solid black',
                                                    padding: '8px',
                                                    textAlign: 'left'
                                                }}>
                                                    {item.partNumber} rev {item.revision}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                                    <Button 
                                        onClick={() => this.copyVendorTableToClipboard(vendor, tableData)} 
                                        color="primary" 
                                        variant="contained"
                                        size="small"
                                    >
                                        Copy {vendor} Table
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeCopyTable} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Create Invoice for Line Items Dialog */}
                {this.state.createLineItemInvoiceDialogOpen && (
                    <DrawerMenuRight 
                        title={"Create Invoice"} 
                        customWidth={1100}
                        open={this.state.createLineItemInvoiceDialogOpen}
                        onClose={this.handleCloseCreateLineItemInvoice}
                    >
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Invoice Number"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={this.state.newInvoiceNumber}
                            onChange={(e) => this.setState({newInvoiceNumber: e.target.value})}
                            style={{marginBottom: 20}}
                            autoComplete="off"
                        />
                        
                        <div style={{marginBottom: 20}}>
                            <Typography variant="subtitle1" style={{marginBottom: 10}}>
                                Upload Invoice File (Optional)
                            </Typography>
                            <input
                                type="file"
                                onChange={(e) => this.setState({newInvoiceFile: e.target.files[0]})}
                                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                            />
                        </div>
                        
                        <Typography variant="h6" style={{marginBottom: 10}}>
                            Select Line Items for This Invoice
                        </Typography>
                        
                        {this.state.currentPurchaseOrderId && (() => {
                            const currentOrder = this.state.purchaseOrders.find(po => po.id === this.state.currentPurchaseOrderId);
                            if (!currentOrder) return null;
                            
                            return (
                                <TableContainer component={Paper}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={this.state.selectedLineItems.length === currentOrder.purchasedParts.length}
                                                        indeterminate={this.state.selectedLineItems.length > 0 && this.state.selectedLineItems.length < currentOrder.purchasedParts.length}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                this.setState({
                                                                    selectedLineItems: currentOrder.purchasedParts.map(p => p.id),
                                                                    lastSelectedLineItemIndex: null
                                                                });
                                                            } else {
                                                                this.setState({
                                                                    selectedLineItems: [],
                                                                    lastSelectedLineItemIndex: null
                                                                });
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>PN</TableCell>
                                                <TableCell>Description</TableCell>
                                                <TableCell>Quantity</TableCell>
                                                <TableCell>Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {currentOrder.purchasedParts.map((part) => {
                                                const partExpanded = this.state.parts.find(x => x.part.id === part.partId);
                                                const isPaid = this.getLineItemPaidStatus(part.id);
                                                const isSelected = this.state.selectedLineItems.includes(part.id);
                                                
                                                return (
                                                    <TableRow key={part.id}>
                                                        <TableCell padding="checkbox">
                                                            <Checkbox
                                                                checked={isSelected}
                                                                onChange={(e) => this.handleLineItemSelection(part.id, e.target.checked, e, currentOrder)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>{partExpanded?.part.partId}</TableCell>
                                                        <TableCell className="description-ellipsis text-left">{partExpanded?.part.description}</TableCell>
                                                        <TableCell>{part.quantity}</TableCell>
                                                        <TableCell>
                                                            <span style={{
                                                                color: isPaid ? '#4caf50' : '#ff9800',
                                                                fontWeight: 'bold'
                                                            }}>
                                                                {isPaid ? 'PAID' : 'UNPAID'}
                                                            </span>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                                                        </TableContainer>
                            );
                        })()}
                        
                        <div style={{marginTop: 30, display: 'flex', gap: '10px'}}>
                            {this.state.savingInvoice ? (
                                <CircularProgress />
                            ) : (
                                <Button 
                                    onClick={this.handleSaveCreateLineItemInvoice} 
                                    className="success-button-lg" 
                                    style={{width: 140}}
                                    disabled={this.state.selectedLineItems.length === 0}
                                >
                                    CREATE & ATTACH
                                </Button>
                            )}
                        </div>
                    </DrawerMenuRight>
                )}

                {/* Attach Existing Invoice to Line Items Dialog */}
                {this.state.attachExistingInvoiceToLineItemsDialogOpen && (
                    <DrawerMenuRight 
                        title={"Attach Existing Invoice"} 
                        customWidth={1100}
                        open={this.state.attachExistingInvoiceToLineItemsDialogOpen}
                        onClose={this.handleCloseAttachExistingInvoiceToLineItems}
                    >
                        <FormControl fullWidth variant="outlined" style={{marginBottom: 20}}>
                            <InputLabel>Select Invoice</InputLabel>
                            <Select
                                value={this.state.invoiceToAttachToLineItems}
                                onChange={(e) => this.setState({invoiceToAttachToLineItems: e.target.value})}
                                label="Select Invoice"
                            >
                                {this.state.allInvoices.map((invoice) => (
                                    <MenuItem key={invoice.id} value={invoice.id}>
                                        {invoice.invoiceNumber} - {invoice.isPaid ? 'Paid' : 'Unpaid'}
                                        {invoice.fileName && ` (${invoice.fileName})`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        
                        <Typography variant="h6" style={{marginBottom: 10}}>
                            Select Line Items for This Invoice
                        </Typography>
                        
                        {this.state.currentPurchaseOrderId && (() => {
                            const currentOrder = this.state.purchaseOrders.find(po => po.id === this.state.currentPurchaseOrderId);
                            if (!currentOrder) return null;
                            
                            return (
                                <TableContainer component={Paper}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={this.state.selectedLineItems.length === currentOrder.purchasedParts.length}
                                                        indeterminate={this.state.selectedLineItems.length > 0 && this.state.selectedLineItems.length < currentOrder.purchasedParts.length}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                this.setState({
                                                                    selectedLineItems: currentOrder.purchasedParts.map(p => p.id),
                                                                    lastSelectedLineItemIndex: null
                                                                });
                                                            } else {
                                                                this.setState({
                                                                    selectedLineItems: [],
                                                                    lastSelectedLineItemIndex: null
                                                                });
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>PN</TableCell>
                                                <TableCell>Description</TableCell>
                                                <TableCell>Quantity</TableCell>
                                                <TableCell>Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {currentOrder.purchasedParts.map((part) => {
                                                const partExpanded = this.state.parts.find(x => x.part.id === part.partId);
                                                const isPaid = this.getLineItemPaidStatus(part.id);
                                                const isSelected = this.state.selectedLineItems.includes(part.id);
                                                
                                                return (
                                                    <TableRow key={part.id}>
                                                        <TableCell padding="checkbox">
                                                            <Checkbox
                                                                checked={isSelected}
                                                                onChange={(e) => this.handleLineItemSelection(part.id, e.target.checked, e, currentOrder)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>{partExpanded?.part.partId}</TableCell>
                                                        <TableCell className="description-ellipsis">{partExpanded?.part.description}</TableCell>
                                                        <TableCell>{part.quantity}</TableCell>
                                                        <TableCell>
                                                            <span style={{
                                                                color: isPaid ? '#4caf50' : '#ff9800',
                                                                fontWeight: 'bold'
                                                            }}>
                                                                {isPaid ? 'PAID' : 'UNPAID'}
                                                            </span>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                                                        </TableContainer>
                            );
                        })()}
                        
                        <div style={{marginTop: 30, display: 'flex', gap: '10px'}}>
                            {this.state.savingInvoice ? (
                                <CircularProgress />
                            ) : (
                                <Button 
                                    onClick={this.handleSaveAttachExistingInvoiceToLineItems} 
                                    className="success-button-lg" 
                                    style={{width: 180}}
                                    disabled={this.state.selectedLineItems.length === 0 || !this.state.invoiceToAttachToLineItems}
                                >
                                    ATTACH TO SELECTED
                                </Button>
                            )}
                        </div>
                    </DrawerMenuRight>
                )}

                {/* Line Item Invoice Management Dialog */}
                {this.state.lineItemInvoiceDialogOpen && (
                    <DrawerMenuRight title={"Manage Invoices"} customWidth={800}
                                     open={this.state.lineItemInvoiceDialogOpen}
                                     onClose={this.handleCloseLineItemInvoiceDialog}>
                        <div style={{marginBottom: 20}}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={() => this.handleAttachInvoiceToLineItem(this.state.currentEditingPurchasedPartId)}
                                style={{marginBottom: 20}}
                            >
                                Attach Invoice to Line Item
                            </Button>
                        </div>
                        
                        <Typography variant="h6" style={{marginBottom: 15}}>
                            Attached Invoices
                        </Typography>
                        
                        {(() => {
                            const invoices = this.getInvoicesForLineItem(this.state.currentEditingPurchasedPartId);
                            
                            if (invoices.length === 0) {
                                return (
                                    <Typography variant="body1" style={{fontStyle: 'italic', color: '#666'}}>
                                        No invoices attached to this line item.
                                    </Typography>
                                );
                            }
                            
                            return (
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Invoice Number</TableCell>
                                                <TableCell>Date Attached</TableCell>
                                                <TableCell>Paid Status</TableCell>
                                                <TableCell>File</TableCell>
                                                <TableCell>Actions</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {invoices.map((attachment) => (
                                                <TableRow key={attachment.id}>
                                                    <TableCell>{attachment.invoice?.invoiceNumber || 'N/A'}</TableCell>
                                                    <TableCell>
                                                        {formatUtcForDisplay(attachment.dateAttached)}
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                                            <span style={{
                                                                color: attachment.invoice?.isPaid ? '#4caf50' : '#f44336',
                                                                fontWeight: 'bold'
                                                            }}>
                                                                {attachment.invoice?.isPaid ? 'Paid' : 'Unpaid'}
                                                            </span>
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                color={attachment.invoice?.isPaid ? 'secondary' : 'primary'}
                                                                onClick={() => this.handleToggleInvoicePaidStatus(attachment.invoice.id, attachment.invoice.isPaid)}
                                                                style={{
                                                                    minWidth: '80px',
                                                                    fontSize: '11px'
                                                                }}
                                                            >
                                                                {attachment.invoice?.isPaid ? 'Mark Unpaid' : 'Mark Paid'}
                                                            </Button>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        {attachment.invoice?.fileUrl ? (
                                                            <Button 
                                                                size="small" 
                                                                onClick={() => this.download(attachment.invoice.fileUrl, attachment.invoice.fileName)}
                                                            >
                                                                Download
                                                            </Button>
                                                        ) : 'No file'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button 
                                                            size="small" 
                                                            color="secondary"
                                                            onClick={() => this.handleDetachInvoiceFromLineItem(this.state.currentEditingPurchasedPartId, attachment.invoice.id)}
                                                        >
                                                            Detach
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            );
                        })()}
                    </DrawerMenuRight>
                )}

                {/* Attach Invoice to Line Item Dialog */}
                {this.state.attachLineItemInvoiceDialogOpen && (
                    <DrawerMenuRight title={"Attach Invoice to Line Item"} customWidth={600}
                                     open={this.state.attachLineItemInvoiceDialogOpen}
                                     onClose={this.handleCloseAttachInvoiceToLineItem}>
                        <FormControl fullWidth variant="outlined" style={{marginBottom: 20}}>
                            <InputLabel>Select Invoice</InputLabel>
                            <Select
                                value={this.state.invoiceToAttachToLineItem}
                                onChange={(e) => this.setState({invoiceToAttachToLineItem: e.target.value})}
                                label="Select Invoice"
                            >
                                {this.state.allInvoices.map((invoice) => (
                                    <MenuItem key={invoice.id} value={invoice.id}>
                                        {invoice.invoiceNumber} - {invoice.isPaid ? 'Paid' : 'Unpaid'}
                                        {invoice.fileName && ` (${invoice.fileName})`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        
                        <Typography variant="body2" style={{marginBottom: 20, color: '#666'}}>
                            Select an invoice to attach to this line item. The line item will be marked as paid if the invoice is paid.
                        </Typography>
                        
                        <div style={{marginTop: 30, display: 'flex', gap: '10px'}}>
                            {this.state.savingInvoice ? (
                                <CircularProgress />
                            ) : (
                                <Button 
                                    onClick={this.handleSaveAttachLineItemInvoice} 
                                    className="success-button-lg" style={{width: 75}}
                                    disabled={this.state.savingInvoice}
                                >
                                    ATTACH
                                </Button>
                            )}
                        </div>
                    </DrawerMenuRight>
                )}

                {this.renderReceiveDrawer()}

                {/* Paid Modal */}
                <Dialog open={this.state.paidModalOpen} onClose={this.handlePaidModalClose} maxWidth="sm" fullWidth>
                    <DialogTitle>Mark as Paid</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" style={{marginBottom: 20, color: '#666'}}>
                            This will create an invoice and mark the item as paid. Please provide the invoice details below.
                        </Typography>
                        
                        <TextField
                            autoFocus
                            label="Invoice Number"
                            variant="outlined"
                            value={this.state.paidModalInvoiceNumber}
                            onChange={(e) => this.setState({paidModalInvoiceNumber: e.target.value})}
                            fullWidth
                            style={{marginBottom: 20}}
                        />
                        
                        <div
                            style={{
                                border: '2px dashed #ccc',
                                borderRadius: '4px',
                                padding: '20px',
                                textAlign: 'center',
                                backgroundColor: '#fafafa',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                minHeight: '100px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}
                            onDragOver={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#1976d2';
                                e.currentTarget.style.backgroundColor = '#f0f8ff';
                            }}
                            onDragLeave={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#ccc';
                                e.currentTarget.style.backgroundColor = '#fafafa';
                            }}
                            onDrop={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#ccc';
                                e.currentTarget.style.backgroundColor = '#fafafa';
                                const files = e.dataTransfer.files;
                                if (files.length > 0) {
                                    const file = files[0];
                                    if (file.type === 'application/pdf' || file.type.startsWith('image/')) {
                                        this.setState({paidModalInvoiceFile: file});
                                    }
                                }
                            }}
                            onClick={() => document.getElementById('paid-modal-file-input').click()}
                        >
                            {this.state.paidModalInvoiceFile ? (
                                <div>
                                    <div style={{fontSize: '14px', color: '#1976d2', fontWeight: 'bold'}}>
                                        ✓ File Selected
                                    </div>
                                    <div style={{fontSize: '12px', color: '#666', marginTop: '4px'}}>
                                        {this.state.paidModalInvoiceFile.name}
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div style={{fontSize: '14px', color: '#666'}}>
                                        📎 Attach Invoice File
                                    </div>
                                    <div style={{fontSize: '12px', color: '#999', marginTop: '4px'}}>
                                        Drag & drop or click to upload
                                    </div>
                                </div>
                            )}
                            <input
                                id="paid-modal-file-input"
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => this.setState({paidModalInvoiceFile: e.target.files[0]})}
                                style={{display: 'none'}}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handlePaidModalClose}>Cancel</Button>
                        <Button onClick={this.handleSkipInvoice} variant="outlined" color="secondary" style={{marginRight: 'auto'}}>
                            Skip Invoice
                        </Button>
                        <Button onClick={this.handlePaidModalSubmit} variant="contained" color="primary">
                            Create Invoice & Mark Paid
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Received Modal */}
                <Dialog open={this.state.receivedModalOpen} onClose={this.handleReceivedModalClose} maxWidth="sm" fullWidth>
                    <DialogTitle>Mark as Received</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" style={{marginBottom: 20, color: '#666'}}>
                            This will create a packing slip and mark the item as received. Please provide the tracking details below. If you are skipping the packing slip, please provide the received date.
                        </Typography>
                        
                        <TextField
                            label="Received Date"
                            type="date"
                            variant="outlined"
                            value={this.state.receivedModalReceivedDate}
                            onChange={(e) => this.setState({receivedModalReceivedDate: e.target.value})}
                            fullWidth
                            style={{marginBottom: 20}}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        
                        
                        <TextField
                            autoFocus
                            label="Packing Slip Name"
                            variant="outlined"
                            value={this.state.receivedModalPackingSlipName || ''}
                            onChange={(e) => this.setState({receivedModalPackingSlipName: e.target.value})}
                            fullWidth
                            style={{marginBottom: 20}}
                        />
                        
                        <TextField
                            label="Tracking Number (Optional)"
                            variant="outlined"
                            value={this.state.receivedModalTrackingNumber}
                            onChange={(e) => this.setState({receivedModalTrackingNumber: e.target.value})}
                            fullWidth
                            style={{marginBottom: 20}}
                        />
                        <div
                            style={{
                                border: '2px dashed #ccc',
                                borderRadius: '4px',
                                padding: '20px',
                                textAlign: 'center',
                                backgroundColor: '#fafafa',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                minHeight: '100px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}
                            onDragOver={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#1976d2';
                                e.currentTarget.style.backgroundColor = '#f0f8ff';
                            }}
                            onDragLeave={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#ccc';
                                e.currentTarget.style.backgroundColor = '#fafafa';
                            }}
                            onDrop={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#ccc';
                                e.currentTarget.style.backgroundColor = '#fafafa';
                                const files = e.dataTransfer.files;
                                if (files.length > 0) {
                                    const file = files[0];
                                    if (file.type === 'application/pdf' || file.type.startsWith('image/')) {
                                        this.setState({receivedModalFile: file});
                                    }
                                }
                            }}
                            onClick={() => document.getElementById('received-modal-file-input').click()}
                        >
                            {this.state.receivedModalFile ? (
                                <div>
                                    <div style={{fontSize: '14px', color: '#1976d2', fontWeight: 'bold'}}>
                                        ✓ File Selected
                                    </div>
                                    <div style={{fontSize: '12px', color: '#666', marginTop: '4px'}}>
                                        {this.state.receivedModalFile.name}
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div style={{fontSize: '14px', color: '#666'}}>
                                        📎 Attach Receipt File
                                    </div>
                                    <div style={{fontSize: '12px', color: '#999', marginTop: '4px'}}>
                                        Drag & drop or click to upload
                                    </div>
                                </div>
                            )}
                            <input
                                id="received-modal-file-input"
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => this.setState({receivedModalFile: e.target.files[0]})}
                                style={{display: 'none'}}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleReceivedModalClose}>Cancel</Button>
                        <Button onClick={this.handleSkipPackingSlip} variant="outlined" color="secondary" style={{marginRight: 'auto'}}>
                            Skip Packing Slip
                        </Button>
                        <Button onClick={this.handleReceivedModalSubmit} variant="contained" color="primary">
                            Create Packing Slip & Mark Received
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Multi-Select Paid Modal */}
                <Dialog open={this.state.multiSelectPaidModalOpen} onClose={() => this.setState({multiSelectPaidModalOpen: false})} maxWidth="sm" fullWidth>
                    <DialogTitle>Mark Selected Items as Paid</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" style={{marginBottom: 20, color: '#666'}}>
                            This will create an invoice for {this.state.selectedPurchasedParts.length} selected item(s) and mark them as paid. Please provide the invoice details below.
                        </Typography>
                        
                        <TextField
                            autoFocus
                            label="Invoice Number"
                            variant="outlined"
                            value={this.state.multiSelectInvoiceNumber}
                            onChange={(e) => this.setState({multiSelectInvoiceNumber: e.target.value})}
                            fullWidth
                            style={{marginBottom: 20}}
                        />
                        
                        <div
                            style={{
                                border: '2px dashed #ccc',
                                borderRadius: '4px',
                                padding: '20px',
                                textAlign: 'center',
                                backgroundColor: '#fafafa',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                minHeight: '100px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}
                            onDragOver={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#1976d2';
                                e.currentTarget.style.backgroundColor = '#f0f8ff';
                            }}
                            onDragLeave={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#ccc';
                                e.currentTarget.style.backgroundColor = '#fafafa';
                            }}
                            onDrop={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#ccc';
                                e.currentTarget.style.backgroundColor = '#fafafa';
                                const files = e.dataTransfer.files;
                                if (files.length > 0) {
                                    const file = files[0];
                                    if (file.type === 'application/pdf' || file.type.startsWith('image/')) {
                                        this.setState({multiSelectInvoiceFile: file});
                                    }
                                }
                            }}
                            onClick={() => document.getElementById('multi-select-paid-modal-file-input').click()}
                        >
                            {this.state.multiSelectInvoiceFile ? (
                                <div>
                                    <div style={{fontSize: '14px', color: '#1976d2', fontWeight: 'bold'}}>
                                        ✓ File Selected
                                    </div>
                                    <div style={{fontSize: '12px', color: '#666', marginTop: '4px'}}>
                                        {this.state.multiSelectInvoiceFile.name}
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div style={{fontSize: '14px', color: '#666'}}>
                                        📎 Attach Invoice File
                                    </div>
                                    <div style={{fontSize: '12px', color: '#999', marginTop: '4px'}}>
                                        Drag & drop or click to upload
                                    </div>
                                </div>
                            )}
                            <input
                                id="multi-select-paid-modal-file-input"
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => this.setState({multiSelectInvoiceFile: e.target.files[0]})}
                                style={{display: 'none'}}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({multiSelectPaidModalOpen: false})}>Cancel</Button>
                        <Button onClick={this.handleMultiSelectSkipInvoice} variant="outlined" color="secondary" style={{marginRight: 'auto'}}>
                            Skip Invoice
                        </Button>
                        <Button onClick={this.handleMultiSelectPaidSubmit} variant="contained" color="primary">
                            Create Invoice & Mark Paid
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Multi-Select Received Modal */}
                <Dialog open={this.state.multiSelectReceivedModalOpen} onClose={() => this.setState({
                    multiSelectReceivedModalOpen: false, 
                    multiSelectReceivedDate: new Date().toISOString().split('T')[0],
                    multiSelectReceivedQuantities: {},
                    multiSelectShowQuantities: false
                })} maxWidth="sm" fullWidth>
                    <DialogTitle>Mark Selected Items as Received</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" style={{marginBottom: 20, color: '#666'}}>
                            This will create a packing slip for {this.state.selectedPurchasedParts.length} selected item(s) and mark them as received. Please provide the tracking details below.
                        </Typography>
                        
                        <Button
                            variant="outlined"
                            onClick={() => {
                                const filteredPurchaseOrders = this.getFilteredPurchaseOrders(this.state.purchaseOrders || []);
                                const allLineItems = filteredPurchaseOrders.flatMap(po => 
                                    po.purchasedParts.map(part => ({
                                        ...part,
                                        purchaseOrderNumber: po.purchaseOrderNumber,
                                        purchaseOrderId: po.id,
                                        placedOn: po.placedOn
                                    }))
                                );
                                const selectedItems = allLineItems.filter(item => 
                                    this.state.selectedPurchasedParts.includes(item.id)
                                );
                                
                                const receivedQuantities = {};
                                selectedItems.forEach(item => {
                                    const remainingToReceive = Math.max(0, item.quantity - (item.quantityReceived || 0));
                                    receivedQuantities[item.id] = remainingToReceive;
                                });
                                
                                this.setState({
                                    multiSelectShowQuantities: !this.state.multiSelectShowQuantities,
                                    multiSelectReceivedQuantities: receivedQuantities
                                });
                            }}
                            style={{marginBottom: 20, width: '100%'}}
                            startIcon={<FontAwesomeIcon icon={this.state.multiSelectShowQuantities ? faChevronUp : faChevronDown} />}
                        >
                            {this.state.multiSelectShowQuantities ? 'Hide' : 'Show'} Quantity Received Per Item
                        </Button>
                        
                        {this.state.multiSelectShowQuantities && (() => {
                            const filteredPurchaseOrders = this.getFilteredPurchaseOrders(this.state.purchaseOrders || []);
                            const allLineItems = filteredPurchaseOrders.flatMap(po => 
                                po.purchasedParts.map(part => ({
                                    ...part,
                                    purchaseOrderNumber: po.purchaseOrderNumber,
                                    purchaseOrderId: po.id,
                                    placedOn: po.placedOn
                                }))
                            );
                            const selectedItems = allLineItems.filter(item => 
                                this.state.selectedPurchasedParts.includes(item.id)
                            );
                            
                            return (
                                <div style={{marginBottom: 20, border: '1px solid #ddd', borderRadius: '4px', padding: '16px'}}>
                                    {selectedItems.sort((a, b) => {
                                        const partInfoA = this.state.parts.find(p => p.part.id === a.partId);
                                        const partInfoB = this.state.parts.find(p => p.part.id === b.partId);
                                        return (partInfoA?.part.partId || '').localeCompare(partInfoB?.part.partId || '');
                                    }).map((item) => {
                                        const remainingToReceive = Math.max(0, item.quantity - (item.quantityReceived || 0));
                                        const isPartiallyReceived = (item.quantityReceived || 0) > 0;
                                        const partInfo = this.state.parts.find(p => p.part.id === item.partId);
                                        
                                        return (
                                            <div key={item.id} style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '8px 0',
                                                borderBottom: '1px solid #eee'
                                            }}>
                                                <div style={{flex: 1, marginRight: '12px', flexBasis: '100%'}}>
                                                    <div style={{fontSize: '14px', fontWeight: 'bold'}}>
                                                        {partInfo?.part.partId || item.partId || 'Unknown'}
                                                    </div>
                                                    <div style={{fontSize: '12px', color: '#666'}}>
                                                        Ordered: {item.quantity}
                                                        {isPartiallyReceived && (
                                                            <span> | Received: {item.quantityReceived || 0}</span>
                                                        )}
                                                    </div>
                                                </div>
                                                <TextField
                                                    type="number"
                                                    value={this.state.multiSelectReceivedQuantities[item.id] === 0 ? '' : this.state.multiSelectReceivedQuantities[item.id] || ''}
                                                    onChange={(e) => {
                                                        const value = parseNumberInputValue(e.target.value);
                                                        this.setState(prevState => ({
                                                            multiSelectReceivedQuantities: {
                                                                ...prevState.multiSelectReceivedQuantities,
                                                                [item.id]: value
                                                            }
                                                        }));
                                                    }}
                                                    inputProps={{min: 0, max: remainingToReceive}}
                                                    variant="outlined"
                                                    size="small"
                                                    autoComplete="off"
                                                    style={{width: '100px'}}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })()}
                        
                        <TextField
                            autoFocus
                            label="Packing Slip Name"
                            variant="outlined"
                            value={this.state.multiSelectPackingSlipName}
                            onChange={(e) => this.setState({multiSelectPackingSlipName: e.target.value})}
                            fullWidth
                            style={{marginBottom: 20}}
                        />
                        
                        <TextField
                            label="Tracking Number"
                            variant="outlined"
                            value={this.state.multiSelectTrackingNumber}
                            onChange={(e) => this.setState({multiSelectTrackingNumber: e.target.value})}
                            fullWidth
                            style={{marginBottom: 20}}
                        />
                        
                        <TextField
                            label="Received Date"
                            type="date"
                            variant="outlined"
                            value={this.state.multiSelectReceivedDate}
                            onChange={(e) => this.setState({multiSelectReceivedDate: e.target.value})}
                            fullWidth
                            style={{marginBottom: 20}}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        
                        <div
                            style={{
                                border: '2px dashed #ccc',
                                borderRadius: '4px',
                                padding: '20px',
                                textAlign: 'center',
                                backgroundColor: '#fafafa',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                minHeight: '100px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}
                            onDragOver={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#1976d2';
                                e.currentTarget.style.backgroundColor = '#f0f8ff';
                            }}
                            onDragLeave={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#ccc';
                                e.currentTarget.style.backgroundColor = '#fafafa';
                            }}
                            onDrop={(e) => {
                                e.preventDefault();
                                e.currentTarget.style.borderColor = '#ccc';
                                e.currentTarget.style.backgroundColor = '#fafafa';
                                const files = e.dataTransfer.files;
                                if (files.length > 0) {
                                    const file = files[0];
                                    if (file.type === 'application/pdf' || file.type.startsWith('image/')) {
                                        this.setState({multiSelectReceivedFile: file});
                                    }
                                }
                            }}
                            onClick={() => document.getElementById('multi-select-received-modal-file-input').click()}
                        >
                            {this.state.multiSelectReceivedFile ? (
                                <div>
                                    <div style={{fontSize: '14px', color: '#1976d2', fontWeight: 'bold'}}>
                                        ✓ File Selected
                                    </div>
                                    <div style={{fontSize: '12px', color: '#666', marginTop: '4px'}}>
                                        {this.state.multiSelectReceivedFile.name}
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div style={{fontSize: '14px', color: '#666'}}>
                                        📎 Attach Receipt File
                                    </div>
                                    <div style={{fontSize: '12px', color: '#999', marginTop: '4px'}}>
                                        Drag & drop or click to upload
                                    </div>
                                </div>
                            )}
                            <input
                                id="multi-select-received-modal-file-input"
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => this.setState({multiSelectReceivedFile: e.target.files[0]})}
                                style={{display: 'none'}}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({multiSelectReceivedModalOpen: false, multiSelectReceivedDate: getCurrentLocalTime().format('YYYY-MM-DD')})}>Cancel</Button>
                        <Button onClick={this.handleMultiSelectSkipPackingSlip} variant="outlined" color="secondary" style={{marginRight: 'auto'}}>
                            Skip Packing Slip
                        </Button>
                        <Button onClick={this.handleMultiSelectReceivedSubmit} variant="contained" color="primary">
                            Create Packing Slip & Mark Received
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Floating action buttons for multiselect */}
                {this.state.selectedPurchasedParts.length > 0 && (
                    <div style={{
                        position: 'fixed',
                        bottom: 20,
                        left: 182,
                        right: 0,
                        zIndex: 1000,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '16px',
                        pointerEvents: 'none'
                    }}>
                        <div style={{
                            display: 'flex',
                            gap: '16px',
                            pointerEvents: 'auto'
                        }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.handleMultiSelectPaid}
                                className="success-button-lg"
                                startIcon={<FontAwesomeIcon icon={faCheck} />}
                            >
                                Mark Paid ({this.state.selectedPurchasedParts.length})
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.handleMultiSelectReceived}
                                className="success-button-lg"
                                startIcon={<FontAwesomeIcon icon={faFileInvoice} />}
                            >
                                Mark Received ({this.state.selectedPurchasedParts.length})
                            </Button>
                        </div>
                    </div>
                )}
            </DashboardTemplate>
        );
    }
}

AdminPurchases.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminPurchases);
